/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.14.4.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class AppointmentsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    deleteBrokerId(ensBrokerIdTid: number, callingUser: CallingUserMessage): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/appointment/broker_id/{ensBrokerIdTid}";
        if (ensBrokerIdTid === undefined || ensBrokerIdTid === null)
            throw new Error("The parameter 'ensBrokerIdTid' must be defined.");
        url_ = url_.replace("{ensBrokerIdTid}", encodeURIComponent("" + ensBrokerIdTid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(callingUser);

        let options_ = <RequestInit>{
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteBrokerId(_response);
        });
    }

    protected processDeleteBrokerId(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    editBrokerId(ensBrokerIdTid: number, request: EditBrokerIdRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/appointment/broker_id/{ensBrokerIdTid}";
        if (ensBrokerIdTid === undefined || ensBrokerIdTid === null)
            throw new Error("The parameter 'ensBrokerIdTid' must be defined.");
        url_ = url_.replace("{ensBrokerIdTid}", encodeURIComponent("" + ensBrokerIdTid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditBrokerId(_response);
        });
    }

    protected processEditBrokerId(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    processRtsReport(reportName: ReadyToSellReportType, fileGuid: string | null): Promise<RtsReportUploadResponse> {
        let url_ = this.baseUrl + "/api/appointment/rts_report/{reportName}/{fileGuid}";
        if (reportName === undefined || reportName === null)
            throw new Error("The parameter 'reportName' must be defined.");
        url_ = url_.replace("{reportName}", encodeURIComponent("" + reportName));
        if (fileGuid === undefined || fileGuid === null)
            throw new Error("The parameter 'fileGuid' must be defined.");
        url_ = url_.replace("{fileGuid}", encodeURIComponent("" + fileGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProcessRtsReport(_response);
        });
    }

    protected processProcessRtsReport(response: Response): Promise<RtsReportUploadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RtsReportUploadResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RtsReportUploadResponse>(<any>null);
    }
}

export class FacebookAdsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getChallengeResponse(challenge: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/facebook/challenge?";
        if (challenge !== undefined && challenge !== null)
            url_ += "hub.challenge=" + encodeURIComponent("" + challenge) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetChallengeResponse(_response);
        });
    }

    protected processGetChallengeResponse(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    postLeadGen(challenge: string | null | undefined, request: LeadPostRequest): Promise<string> {
        let url_ = this.baseUrl + "/api/facebook/challenge?";
        if (challenge !== undefined && challenge !== null)
            url_ += "hub.challenge=" + encodeURIComponent("" + challenge) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostLeadGen(_response);
        });
    }

    protected processPostLeadGen(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }
}

export class FailClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    fail(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Fail";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFail(_response);
        });
    }

    protected processFail(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class HealthClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    healthCheck(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Health";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheck(_response);
        });
    }

    protected processHealthCheck(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class LicenseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getActiveLicensesByState(state: string | null): Promise<GetActiveLicensesByStateResponse> {
        let url_ = this.baseUrl + "/api/license/{state}";
        if (state === undefined || state === null)
            throw new Error("The parameter 'state' must be defined.");
        url_ = url_.replace("{state}", encodeURIComponent("" + state));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetActiveLicensesByState(_response);
        });
    }

    protected processGetActiveLicensesByState(response: Response): Promise<GetActiveLicensesByStateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetActiveLicensesByStateResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetActiveLicensesByStateResponse>(<any>null);
    }
}

export class NiprClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getLastNiprUpdate(): Promise<NiprLastUpdateResponse> {
        let url_ = this.baseUrl + "/api/nipr/last_update";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLastNiprUpdate(_response);
        });
    }

    protected processGetLastNiprUpdate(response: Response): Promise<NiprLastUpdateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NiprLastUpdateResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NiprLastUpdateResponse>(<any>null);
    }

    createReportRequest(request: CreateReportRequest): Promise<CreateReportResponse> {
        let url_ = this.baseUrl + "/api/nipr/pdb/create_report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateReportRequest(_response);
        });
    }

    protected processCreateReportRequest(response: Response): Promise<CreateReportResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateReportResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateReportResponse>(<any>null);
    }

    checkReportRequest(request: CheckReportStatusRequest): Promise<CheckReportStatusResponse> {
        let url_ = this.baseUrl + "/api/nipr/pdb/check_status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckReportRequest(_response);
        });
    }

    protected processCheckReportRequest(response: Response): Promise<CheckReportStatusResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckReportStatusResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CheckReportStatusResponse>(<any>null);
    }

    loadReportRequest(request: RetrieveReportRequest): Promise<RetrieveReportResponse> {
        let url_ = this.baseUrl + "/api/nipr/pdb/retrieve_report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLoadReportRequest(_response);
        });
    }

    protected processLoadReportRequest(response: Response): Promise<RetrieveReportResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RetrieveReportResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RetrieveReportResponse>(<any>null);
    }
}

export class OverlordSlackMessageClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    post(request: OverlordSlackMessageRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/overlord/slack_message";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class OverlordTeamsMessageClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    post(request: OverlordTeamsMessageRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/overlord/teams_message";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class OverlordTriggerSequenceClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    post(request: OverlordTriggerSequenceRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/overlord/trigger_sequence";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class OverlordTriggerTaskClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    post(request: OverlordTriggerTaskRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/overlord/trigger_task";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class PicDispositionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    post(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/five9/pic_disposition_callback";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class ProductCarrierClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getActiveProducts(): Promise<EnsProductResponse[]> {
        let url_ = this.baseUrl + "/api/product_carrier/product";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetActiveProducts(_response);
        });
    }

    protected processGetActiveProducts(response: Response): Promise<EnsProductResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnsProductResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnsProductResponse[]>(<any>null);
    }

    getActiveProductCategory(): Promise<EnsProductCategoryResponse[]> {
        let url_ = this.baseUrl + "/api/product_carrier/product_category";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetActiveProductCategory(_response);
        });
    }

    protected processGetActiveProductCategory(response: Response): Promise<EnsProductCategoryResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnsProductCategoryResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnsProductCategoryResponse[]>(<any>null);
    }

    getActiveCarriers(): Promise<EnsProductCarrierResponse[]> {
        let url_ = this.baseUrl + "/api/product_carrier/carrier";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetActiveCarriers(_response);
        });
    }

    protected processGetActiveCarriers(response: Response): Promise<EnsProductCarrierResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnsProductCarrierResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnsProductCarrierResponse[]>(<any>null);
    }

    getCarrierChildrenInfoTypes(): Promise<EnsProductCarrierChildInfoTypeResponse[]> {
        let url_ = this.baseUrl + "/api/product_carrier/carrier_children_info_type";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCarrierChildrenInfoTypes(_response);
        });
    }

    protected processGetCarrierChildrenInfoTypes(response: Response): Promise<EnsProductCarrierChildInfoTypeResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnsProductCarrierChildInfoTypeResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnsProductCarrierChildInfoTypeResponse[]>(<any>null);
    }

    getActiveCarrierChildren(ens_product_carrier_tid: EnsProductCarrierTid): Promise<EnsProductCarrierChildResponse[]> {
        let url_ = this.baseUrl + "/api/product_carrier/carrier_children/{ens_product_carrier_tid}";
        if (ens_product_carrier_tid === undefined || ens_product_carrier_tid === null)
            throw new Error("The parameter 'ens_product_carrier_tid' must be defined.");
        url_ = url_.replace("{ens_product_carrier_tid}", encodeURIComponent("" + ens_product_carrier_tid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetActiveCarrierChildren(_response);
        });
    }

    protected processGetActiveCarrierChildren(response: Response): Promise<EnsProductCarrierChildResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnsProductCarrierChildResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnsProductCarrierChildResponse[]>(<any>null);
    }

    addCarrierChild(req: AddEnsProductCarrierChildRequest): Promise<EnsProductCarrierChildResponse> {
        let url_ = this.baseUrl + "/api/product_carrier/carrier_children";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddCarrierChild(_response);
        });
    }

    protected processAddCarrierChild(response: Response): Promise<EnsProductCarrierChildResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnsProductCarrierChildResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnsProductCarrierChildResponse>(<any>null);
    }

    updateCarrierChild(req: UpdateEnsProductCarrierChildRequest): Promise<EnsProductCarrierChildResponse> {
        let url_ = this.baseUrl + "/api/product_carrier/carrier_children";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCarrierChild(_response);
        });
    }

    protected processUpdateCarrierChild(response: Response): Promise<EnsProductCarrierChildResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnsProductCarrierChildResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnsProductCarrierChildResponse>(<any>null);
    }

    deleteCarrierChild(ens_product_carrier_child_tid: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/product_carrier/carrier_children/{ens_product_carrier_child_tid}";
        if (ens_product_carrier_child_tid === undefined || ens_product_carrier_child_tid === null)
            throw new Error("The parameter 'ens_product_carrier_child_tid' must be defined.");
        url_ = url_.replace("{ens_product_carrier_child_tid}", encodeURIComponent("" + ens_product_carrier_child_tid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteCarrierChild(_response);
        });
    }

    protected processDeleteCarrierChild(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class RoboBenClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getSaleInformation(saleTid: number): Promise<GetSaleInformationRow> {
        let url_ = this.baseUrl + "/api/roboben/sale/{saleTid}";
        if (saleTid === undefined || saleTid === null)
            throw new Error("The parameter 'saleTid' must be defined.");
        url_ = url_.replace("{saleTid}", encodeURIComponent("" + saleTid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSaleInformation(_response);
        });
    }

    protected processGetSaleInformation(response: Response): Promise<GetSaleInformationRow> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSaleInformationRow.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetSaleInformationRow>(<any>null);
    }

    updateCampaignMapping(saleTid: number, campaignTid: number): Promise<UpdateCampaignMappingResult> {
        let url_ = this.baseUrl + "/api/roboben/campaign_mapping/sale/{saleTid}/campaign/{campaignTid}";
        if (saleTid === undefined || saleTid === null)
            throw new Error("The parameter 'saleTid' must be defined.");
        url_ = url_.replace("{saleTid}", encodeURIComponent("" + saleTid));
        if (campaignTid === undefined || campaignTid === null)
            throw new Error("The parameter 'campaignTid' must be defined.");
        url_ = url_.replace("{campaignTid}", encodeURIComponent("" + campaignTid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCampaignMapping(_response);
        });
    }

    protected processUpdateCampaignMapping(response: Response): Promise<UpdateCampaignMappingResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCampaignMappingResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateCampaignMappingResult>(<any>null);
    }

    getSaleMarketingInformation(request: MarketingDiagnosticsSearchRequest): Promise<MarketingDiagnosticsSearchResponse> {
        let url_ = this.baseUrl + "/api/roboben/marketing_action_diagnostics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSaleMarketingInformation(_response);
        });
    }

    protected processGetSaleMarketingInformation(response: Response): Promise<MarketingDiagnosticsSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarketingDiagnosticsSearchResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingDiagnosticsSearchResponse>(<any>null);
    }

    mergeContacts(parentContactTid: number, orphanContactTid: number): Promise<MarketingDiagnosticsSearchResponse> {
        let url_ = this.baseUrl + "/api/roboben/merge_contacts/{parentContactTid}/{orphanContactTid}";
        if (parentContactTid === undefined || parentContactTid === null)
            throw new Error("The parameter 'parentContactTid' must be defined.");
        url_ = url_.replace("{parentContactTid}", encodeURIComponent("" + parentContactTid));
        if (orphanContactTid === undefined || orphanContactTid === null)
            throw new Error("The parameter 'orphanContactTid' must be defined.");
        url_ = url_.replace("{orphanContactTid}", encodeURIComponent("" + orphanContactTid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMergeContacts(_response);
        });
    }

    protected processMergeContacts(response: Response): Promise<MarketingDiagnosticsSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarketingDiagnosticsSearchResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingDiagnosticsSearchResponse>(<any>null);
    }

    updateDidMapping(request: CreateCampaignMappingRequest): Promise<CreateCampaignMappingResult> {
        let url_ = this.baseUrl + "/api/roboben/create_campaign_mapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateDidMapping(_response);
        });
    }

    protected processUpdateDidMapping(response: Response): Promise<CreateCampaignMappingResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateCampaignMappingResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCampaignMappingResult>(<any>null);
    }

    getCampaignMappingOptions(): Promise<GetCampaignMappingOptionsResponse> {
        let url_ = this.baseUrl + "/api/roboben/get_campaign_mapping_options";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCampaignMappingOptions(_response);
        });
    }

    protected processGetCampaignMappingOptions(response: Response): Promise<GetCampaignMappingOptionsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCampaignMappingOptionsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCampaignMappingOptionsResponse>(<any>null);
    }

    getFilteredCampaigns(request: CampaignFilteredGetRequest): Promise<MarketingCampaign[]> {
        let url_ = this.baseUrl + "/api/roboben/marketing_campaigns";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFilteredCampaigns(_response);
        });
    }

    protected processGetFilteredCampaigns(response: Response): Promise<MarketingCampaign[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarketingCampaign.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingCampaign[]>(<any>null);
    }

    getActiveVendors(): Promise<EnsVendorResponse[]> {
        let url_ = this.baseUrl + "/api/roboben/vendors";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetActiveVendors(_response);
        });
    }

    protected processGetActiveVendors(response: Response): Promise<EnsVendorResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnsVendorResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnsVendorResponse[]>(<any>null);
    }

    getActiveBrands(): Promise<EnsBrandResponse[]> {
        let url_ = this.baseUrl + "/api/roboben/brands";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetActiveBrands(_response);
        });
    }

    protected processGetActiveBrands(response: Response): Promise<EnsBrandResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnsBrandResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnsBrandResponse[]>(<any>null);
    }

    getActiveChannels(): Promise<EnsChannelResponse[]> {
        let url_ = this.baseUrl + "/api/roboben/channels";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetActiveChannels(_response);
        });
    }

    protected processGetActiveChannels(response: Response): Promise<EnsChannelResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnsChannelResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnsChannelResponse[]>(<any>null);
    }

    getActiveLeadTypes(): Promise<EnsLeadTypeResponse[]> {
        let url_ = this.baseUrl + "/api/roboben/leadtypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetActiveLeadTypes(_response);
        });
    }

    protected processGetActiveLeadTypes(response: Response): Promise<EnsLeadTypeResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnsLeadTypeResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnsLeadTypeResponse[]>(<any>null);
    }
}

export class UploadClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getPreSignedUrl(): Promise<PreSignedUrlResponse> {
        let url_ = this.baseUrl + "/api/upload/presignedurl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPreSignedUrl(_response);
        });
    }

    protected processGetPreSignedUrl(response: Response): Promise<PreSignedUrlResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreSignedUrlResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PreSignedUrlResponse>(<any>null);
    }
}

export class UserClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getUsers(agentOnly: boolean | undefined, includeInactive: boolean | null | undefined, includeSupervisors: boolean | null | undefined): Promise<GetUserSimpleResponse[]> {
        let url_ = this.baseUrl + "/api/portal/user?";
        if (agentOnly === null)
            throw new Error("The parameter 'agentOnly' cannot be null.");
        else if (agentOnly !== undefined)
            url_ += "agentOnly=" + encodeURIComponent("" + agentOnly) + "&";
        if (includeInactive !== undefined && includeInactive !== null)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (includeSupervisors !== undefined && includeSupervisors !== null)
            url_ += "includeSupervisors=" + encodeURIComponent("" + includeSupervisors) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: Response): Promise<GetUserSimpleResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetUserSimpleResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetUserSimpleResponse[]>(<any>null);
    }

    findUser(searchType: FindUserRequestType | undefined, searchParam: string | null | undefined, inactive: boolean | undefined): Promise<EnsUser[]> {
        let url_ = this.baseUrl + "/api/portal/user/find?";
        if (searchType === null)
            throw new Error("The parameter 'searchType' cannot be null.");
        else if (searchType !== undefined)
            url_ += "searchType=" + encodeURIComponent("" + searchType) + "&";
        if (searchParam !== undefined && searchParam !== null)
            url_ += "searchParam=" + encodeURIComponent("" + searchParam) + "&";
        if (inactive === null)
            throw new Error("The parameter 'inactive' cannot be null.");
        else if (inactive !== undefined)
            url_ += "inactive=" + encodeURIComponent("" + inactive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFindUser(_response);
        });
    }

    protected processFindUser(response: Response): Promise<EnsUser[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnsUser.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnsUser[]>(<any>null);
    }

    getUserLicenses(ensUserTid: number): Promise<License[]> {
        let url_ = this.baseUrl + "/api/portal/user/license/{ensUserTid}";
        if (ensUserTid === undefined || ensUserTid === null)
            throw new Error("The parameter 'ensUserTid' must be defined.");
        url_ = url_.replace("{ensUserTid}", encodeURIComponent("" + ensUserTid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserLicenses(_response);
        });
    }

    protected processGetUserLicenses(response: Response): Promise<License[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(License.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<License[]>(<any>null);
    }

    getUserAppointments(ensUserTid: number): Promise<Appointment[]> {
        let url_ = this.baseUrl + "/api/portal/user/appointment/{ensUserTid}";
        if (ensUserTid === undefined || ensUserTid === null)
            throw new Error("The parameter 'ensUserTid' must be defined.");
        url_ = url_.replace("{ensUserTid}", encodeURIComponent("" + ensUserTid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserAppointments(_response);
        });
    }

    protected processGetUserAppointments(response: Response): Promise<Appointment[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Appointment.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Appointment[]>(<any>null);
    }

    getUserCertifications(ensUserTid: number): Promise<Certification[]> {
        let url_ = this.baseUrl + "/api/portal/user/certification/{ensUserTid}";
        if (ensUserTid === undefined || ensUserTid === null)
            throw new Error("The parameter 'ensUserTid' must be defined.");
        url_ = url_.replace("{ensUserTid}", encodeURIComponent("" + ensUserTid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserCertifications(_response);
        });
    }

    protected processGetUserCertifications(response: Response): Promise<Certification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Certification.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Certification[]>(<any>null);
    }

    getReadyToSellStatus(ensUserTid: number, productCarrierTid: EnsProductCarrierTid | undefined, productCategoryTid: EnsProductCategoryTid | undefined, effectiveYear: number | undefined): Promise<RtsStatus[]> {
        let url_ = this.baseUrl + "/api/portal/user/ready_to_sell/{ensUserTid}?";
        if (ensUserTid === undefined || ensUserTid === null)
            throw new Error("The parameter 'ensUserTid' must be defined.");
        url_ = url_.replace("{ensUserTid}", encodeURIComponent("" + ensUserTid));
        if (productCarrierTid === null)
            throw new Error("The parameter 'productCarrierTid' cannot be null.");
        else if (productCarrierTid !== undefined)
            url_ += "productCarrierTid=" + encodeURIComponent("" + productCarrierTid) + "&";
        if (productCategoryTid === null)
            throw new Error("The parameter 'productCategoryTid' cannot be null.");
        else if (productCategoryTid !== undefined)
            url_ += "productCategoryTid=" + encodeURIComponent("" + productCategoryTid) + "&";
        if (effectiveYear === null)
            throw new Error("The parameter 'effectiveYear' cannot be null.");
        else if (effectiveYear !== undefined)
            url_ += "effectiveYear=" + encodeURIComponent("" + effectiveYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetReadyToSellStatus(_response);
        });
    }

    protected processGetReadyToSellStatus(response: Response): Promise<RtsStatus[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RtsStatus.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RtsStatus[]>(<any>null);
    }

    updateUser(ensUserTid: number, request: UpdateUserRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/portal/user/ens_user_tid/{ensUserTid}";
        if (ensUserTid === undefined || ensUserTid === null)
            throw new Error("The parameter 'ensUserTid' must be defined.");
        url_ = url_.replace("{ensUserTid}", encodeURIComponent("" + ensUserTid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    updateUserV2(ensUserTid: number, request: UpdateUserRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/portal/user/v2/{ensUserTid}";
        if (ensUserTid === undefined || ensUserTid === null)
            throw new Error("The parameter 'ensUserTid' must be defined.");
        url_ = url_.replace("{ensUserTid}", encodeURIComponent("" + ensUserTid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUserV2(_response);
        });
    }

    protected processUpdateUserV2(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    updateUserCertificationCompleteFl(ensUserCertificationTid: number, request: UpdateUserCertificationCompleteFlRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/portal/user/certification/{ensUserCertificationTid}";
        if (ensUserCertificationTid === undefined || ensUserCertificationTid === null)
            throw new Error("The parameter 'ensUserCertificationTid' must be defined.");
        url_ = url_.replace("{ensUserCertificationTid}", encodeURIComponent("" + ensUserCertificationTid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUserCertificationCompleteFl(_response);
        });
    }

    protected processUpdateUserCertificationCompleteFl(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    getUserBrokerIds(ensUserTid: number): Promise<BrokerId[]> {
        let url_ = this.baseUrl + "/api/portal/user/brokerid/{ensUserTid}";
        if (ensUserTid === undefined || ensUserTid === null)
            throw new Error("The parameter 'ensUserTid' must be defined.");
        url_ = url_.replace("{ensUserTid}", encodeURIComponent("" + ensUserTid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserBrokerIds(_response);
        });
    }

    protected processGetUserBrokerIds(response: Response): Promise<BrokerId[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BrokerId.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BrokerId[]>(<any>null);
    }

    addBrokerId(ensUserTid: number, request: AddBrokerIdRequest): Promise<BrokerId> {
        let url_ = this.baseUrl + "/api/portal/user/broker_id/{ensUserTid}";
        if (ensUserTid === undefined || ensUserTid === null)
            throw new Error("The parameter 'ensUserTid' must be defined.");
        url_ = url_.replace("{ensUserTid}", encodeURIComponent("" + ensUserTid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddBrokerId(_response);
        });
    }

    protected processAddBrokerId(response: Response): Promise<BrokerId> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BrokerId.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BrokerId>(<any>null);
    }

    updateBrokerId(request: UpdateBrokerIdRequest): Promise<BrokerId> {
        let url_ = this.baseUrl + "/api/portal/user/broker_id";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateBrokerId(_response);
        });
    }

    protected processUpdateBrokerId(response: Response): Promise<BrokerId> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BrokerId.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BrokerId>(<any>null);
    }

    deleteBrokerId(ensUserBrokerTid: number): Promise<BrokerId> {
        let url_ = this.baseUrl + "/api/portal/user/broker_id/{ensUserBrokerTid}";
        if (ensUserBrokerTid === undefined || ensUserBrokerTid === null)
            throw new Error("The parameter 'ensUserBrokerTid' must be defined.");
        url_ = url_.replace("{ensUserBrokerTid}", encodeURIComponent("" + ensUserBrokerTid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteBrokerId(_response);
        });
    }

    protected processDeleteBrokerId(response: Response): Promise<BrokerId> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BrokerId.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BrokerId>(<any>null);
    }

    getUserPermissionTypes(): Promise<GetPermissionsResponse[]> {
        let url_ = this.baseUrl + "/api/portal/user/permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserPermissionTypes(_response);
        });
    }

    protected processGetUserPermissionTypes(response: Response): Promise<GetPermissionsResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetPermissionsResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPermissionsResponse[]>(<any>null);
    }

    addUserPermission(ensUserTid: number, ensUserPermissionTypeTid: number, callingUser: CallingUserMessage): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/portal/user/ens_user_tid/{ensUserTid}/permissions/{ensUserPermissionTypeTid}";
        if (ensUserTid === undefined || ensUserTid === null)
            throw new Error("The parameter 'ensUserTid' must be defined.");
        url_ = url_.replace("{ensUserTid}", encodeURIComponent("" + ensUserTid));
        if (ensUserPermissionTypeTid === undefined || ensUserPermissionTypeTid === null)
            throw new Error("The parameter 'ensUserPermissionTypeTid' must be defined.");
        url_ = url_.replace("{ensUserPermissionTypeTid}", encodeURIComponent("" + ensUserPermissionTypeTid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(callingUser);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddUserPermission(_response);
        });
    }

    protected processAddUserPermission(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    deleteUserPermission(ensUserTid: number, ensUserPermissionTypeTid: number, callingUser: CallingUserMessage): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/portal/user/ens_user_tid/{ensUserTid}/permissions/{ensUserPermissionTypeTid}";
        if (ensUserTid === undefined || ensUserTid === null)
            throw new Error("The parameter 'ensUserTid' must be defined.");
        url_ = url_.replace("{ensUserTid}", encodeURIComponent("" + ensUserTid));
        if (ensUserPermissionTypeTid === undefined || ensUserPermissionTypeTid === null)
            throw new Error("The parameter 'ensUserPermissionTypeTid' must be defined.");
        url_ = url_.replace("{ensUserPermissionTypeTid}", encodeURIComponent("" + ensUserPermissionTypeTid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(callingUser);

        let options_ = <RequestInit>{
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteUserPermission(_response);
        });
    }

    protected processDeleteUserPermission(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    getRoleTypes(): Promise<GetRoleTypeResponse[]> {
        let url_ = this.baseUrl + "/api/portal/user/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRoleTypes(_response);
        });
    }

    protected processGetRoleTypes(response: Response): Promise<GetRoleTypeResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetRoleTypeResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetRoleTypeResponse[]>(<any>null);
    }

    getRoleType(ensUserRoleTypeTid: number): Promise<GetRoleTypeResponse> {
        let url_ = this.baseUrl + "/api/portal/user/roles/{ensUserRoleTypeTid}";
        if (ensUserRoleTypeTid === undefined || ensUserRoleTypeTid === null)
            throw new Error("The parameter 'ensUserRoleTypeTid' must be defined.");
        url_ = url_.replace("{ensUserRoleTypeTid}", encodeURIComponent("" + ensUserRoleTypeTid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRoleType(_response);
        });
    }

    protected processGetRoleType(response: Response): Promise<GetRoleTypeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleTypeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetRoleTypeResponse>(<any>null);
    }

    updateRoleDefaultPermissions(ensUserRoleTypeTid: number, ensUserPermissionsTypeTid: EnsUserPermissionTypeTid): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/portal/user/roles/{ensUserRoleTypeTid}/role_permissions/{ensUserPermissionsTypeTid}";
        if (ensUserRoleTypeTid === undefined || ensUserRoleTypeTid === null)
            throw new Error("The parameter 'ensUserRoleTypeTid' must be defined.");
        url_ = url_.replace("{ensUserRoleTypeTid}", encodeURIComponent("" + ensUserRoleTypeTid));
        if (ensUserPermissionsTypeTid === undefined || ensUserPermissionsTypeTid === null)
            throw new Error("The parameter 'ensUserPermissionsTypeTid' must be defined.");
        url_ = url_.replace("{ensUserPermissionsTypeTid}", encodeURIComponent("" + ensUserPermissionsTypeTid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateRoleDefaultPermissions(_response);
        });
    }

    protected processUpdateRoleDefaultPermissions(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    deleteRoleDefaultPermissions(ensUserRoleTypeTid: number, ensUserPermissionsTypeTid: EnsUserPermissionTypeTid): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/portal/user/roles/{ensUserRoleTypeTid}/role_permissions/{ensUserPermissionsTypeTid}";
        if (ensUserRoleTypeTid === undefined || ensUserRoleTypeTid === null)
            throw new Error("The parameter 'ensUserRoleTypeTid' must be defined.");
        url_ = url_.replace("{ensUserRoleTypeTid}", encodeURIComponent("" + ensUserRoleTypeTid));
        if (ensUserPermissionsTypeTid === undefined || ensUserPermissionsTypeTid === null)
            throw new Error("The parameter 'ensUserPermissionsTypeTid' must be defined.");
        url_ = url_.replace("{ensUserPermissionsTypeTid}", encodeURIComponent("" + ensUserPermissionsTypeTid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteRoleDefaultPermissions(_response);
        });
    }

    protected processDeleteRoleDefaultPermissions(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    getUserRoleTypesByEmail(userEmail: string | null): Promise<GetUserRolesResponse> {
        let url_ = this.baseUrl + "/api/portal/user/email/{userEmail}/permissions_roles";
        if (userEmail === undefined || userEmail === null)
            throw new Error("The parameter 'userEmail' must be defined.");
        url_ = url_.replace("{userEmail}", encodeURIComponent("" + userEmail));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserRoleTypesByEmail(_response);
        });
    }

    protected processGetUserRoleTypesByEmail(response: Response): Promise<GetUserRolesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserRolesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetUserRolesResponse>(<any>null);
    }

    updateUserRole(ensUserTid: number, ensUserRoleTypeTid: number, callingUser: CallingUserMessage): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/portal/user/ens_user_tid/{ensUserTid}/roles/{ensUserRoleTypeTid}";
        if (ensUserTid === undefined || ensUserTid === null)
            throw new Error("The parameter 'ensUserTid' must be defined.");
        url_ = url_.replace("{ensUserTid}", encodeURIComponent("" + ensUserTid));
        if (ensUserRoleTypeTid === undefined || ensUserRoleTypeTid === null)
            throw new Error("The parameter 'ensUserRoleTypeTid' must be defined.");
        url_ = url_.replace("{ensUserRoleTypeTid}", encodeURIComponent("" + ensUserRoleTypeTid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(callingUser);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUserRole(_response);
        });
    }

    protected processUpdateUserRole(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class WavFetchDownloadClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(request: WavFetchRequest): Promise<WavFetchResponse> {
        let url_ = this.baseUrl + "/api/wavfetch/archive_downloader";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<WavFetchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WavFetchResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WavFetchResponse>(<any>null);
    }
}

export class BenepathLeadsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    post(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/benepath/lead";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class BloomConceptsLeadsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    post(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/bloomconcepts/lead";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class CrispLeadsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    post(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/crisp/lead";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class DmsLeadsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    post(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/dms/lead";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class Five9SaleDispositionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    post(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/five9/sale_disposition";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class HealthcareIncLeadsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    post(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/healthcareinc/lead";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class IapAccessLogClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    insertAccessLog(request: IapAccessLogRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/iap/log";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInsertAccessLog(_response);
        });
    }

    protected processInsertAccessLog(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class LeadSearchClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getSearchResults(phoneNumber: string | null | undefined): Promise<LeadSearchResponse> {
        let url_ = this.baseUrl + "/api/leads/search?";
        if (phoneNumber !== undefined && phoneNumber !== null)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSearchResults(_response);
        });
    }

    protected processGetSearchResults(response: Response): Promise<LeadSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LeadSearchResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LeadSearchResponse>(<any>null);
    }
}

export class LeadTimelineClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getLeadTimeline(from: number | null | undefined, to: number | null | undefined): Promise<LeadTimelineResponse> {
        let url_ = this.baseUrl + "/api/leads/timeline?";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLeadTimeline(_response);
        });
    }

    protected processGetLeadTimeline(response: Response): Promise<LeadTimelineResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LeadTimelineResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LeadTimelineResponse>(<any>null);
    }
}

export class MyHealthAngelLeadsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    post(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/myhealthangel/lead";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class ReversePhoneSearchClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAssociatedPhones(phoneNumber: string | null): Promise<ReversePhoneSearchResult> {
        let url_ = this.baseUrl + "/api/reverse_phone_search/{phoneNumber}";
        if (phoneNumber === undefined || phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' must be defined.");
        url_ = url_.replace("{phoneNumber}", encodeURIComponent("" + phoneNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssociatedPhones(_response);
        });
    }

    protected processGetAssociatedPhones(response: Response): Promise<ReversePhoneSearchResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReversePhoneSearchResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReversePhoneSearchResult>(<any>null);
    }
}

export class SalesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    updateSaleStatus(saleTid: number, request: SaleStatusUpdateMessage): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/sale/{saleTid}/status";
        if (saleTid === undefined || saleTid === null)
            throw new Error("The parameter 'saleTid' must be defined.");
        url_ = url_.replace("{saleTid}", encodeURIComponent("" + saleTid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSaleStatus(_response);
        });
    }

    protected processUpdateSaleStatus(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    updateSale(saleTid: number, request: SaleUpdateRequest): Promise<EnsSaleResponse> {
        let url_ = this.baseUrl + "/api/sale/{saleTid}";
        if (saleTid === undefined || saleTid === null)
            throw new Error("The parameter 'saleTid' must be defined.");
        url_ = url_.replace("{saleTid}", encodeURIComponent("" + saleTid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSale(_response);
        });
    }

    protected processUpdateSale(response: Response): Promise<EnsSaleResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnsSaleResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnsSaleResponse>(<any>null);
    }

    insertSale(request: SaleInsertRequest): Promise<EnsSaleResponse> {
        let url_ = this.baseUrl + "/api/sale";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInsertSale(_response);
        });
    }

    protected processInsertSale(response: Response): Promise<EnsSaleResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnsSaleResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnsSaleResponse>(<any>null);
    }

    updateSalePolicyNumber(saleTid: number, request: SalePolicyUpdateMessage): Promise<SalePolicyResponse> {
        let url_ = this.baseUrl + "/api/sale/{saleTid}/policy";
        if (saleTid === undefined || saleTid === null)
            throw new Error("The parameter 'saleTid' must be defined.");
        url_ = url_.replace("{saleTid}", encodeURIComponent("" + saleTid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSalePolicyNumber(_response);
        });
    }

    protected processUpdateSalePolicyNumber(response: Response): Promise<SalePolicyResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SalePolicyResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SalePolicyResponse>(<any>null);
    }

    getMarketingCampaignOptions(): Promise<MktgCampaign[]> {
        let url_ = this.baseUrl + "/api/sale/campaigns";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMarketingCampaignOptions(_response);
        });
    }

    protected processGetMarketingCampaignOptions(response: Response): Promise<MktgCampaign[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MktgCampaign.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MktgCampaign[]>(<any>null);
    }
}

export class SalesforceCaseSubmissionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    postCase(formData: SalesforceFormSubmission | null | undefined): Promise<SalesforceCaseSubmissionResponse> {
        let url_ = this.baseUrl + "/api/salesforce/case_submission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formData !== null && formData !== undefined)
            content_.append("formData", formData.toString());

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostCase(_response);
        });
    }

    protected processPostCase(response: Response): Promise<SalesforceCaseSubmissionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SalesforceCaseSubmissionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SalesforceCaseSubmissionResponse>(<any>null);
    }
}

export class SalesforceDtcSubmissionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    postDtcSubmission(submission: SalesforceSubmission): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/salesforce/dtc_salesforce_submission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(submission);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostDtcSubmission(_response);
        });
    }

    protected processPostDtcSubmission(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class SalesforceFormSubmissionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    postForm(formData: SalesforceFormSubmission | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/salesforce/form_submission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formData !== null && formData !== undefined)
            content_.append("formData", formData.toString());

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostForm(_response);
        });
    }

    protected processPostForm(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result204 = resultData204 !== undefined ? resultData204 : <any>null;
            return result204;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    postJsonForm(submission: SalesforceFormSubmission): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/salesforce/form_submission/json";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(submission);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostJsonForm(_response);
        });
    }

    protected processPostJsonForm(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result204 = resultData204 !== undefined ? resultData204 : <any>null;
            return result204;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class SalesforceHealthCheckClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(prodEnvironment: boolean | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/salesforce/health?";
        if (prodEnvironment === null)
            throw new Error("The parameter 'prodEnvironment' cannot be null.");
        else if (prodEnvironment !== undefined)
            url_ += "prodEnvironment=" + encodeURIComponent("" + prodEnvironment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class UserCommissionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getProductCommission(): Promise<ProductCommissionResponseRow[]> {
        let url_ = this.baseUrl + "/api/commission/product";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProductCommission(_response);
        });
    }

    protected processGetProductCommission(response: Response): Promise<ProductCommissionResponseRow[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductCommissionResponseRow.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductCommissionResponseRow[]>(<any>null);
    }

    updateProductCommission(request: CommissionAmountUpdateRequest): Promise<ProductCommissionResponseRow> {
        let url_ = this.baseUrl + "/api/commission/product";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateProductCommission(_response);
        });
    }

    protected processUpdateProductCommission(response: Response): Promise<ProductCommissionResponseRow> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductCommissionResponseRow.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductCommissionResponseRow>(<any>null);
    }

    generateAgentCommission(ens_user_tid: number, request: GenerateCommissionRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/commission/admin/{ens_user_tid}";
        if (ens_user_tid === undefined || ens_user_tid === null)
            throw new Error("The parameter 'ens_user_tid' must be defined.");
        url_ = url_.replace("{ens_user_tid}", encodeURIComponent("" + ens_user_tid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateAgentCommission(_response);
        });
    }

    protected processGenerateAgentCommission(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    getAllCommission(ens_user_tid: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/commission/user/{ens_user_tid}";
        if (ens_user_tid === undefined || ens_user_tid === null)
            throw new Error("The parameter 'ens_user_tid' must be defined.");
        url_ = url_.replace("{ens_user_tid}", encodeURIComponent("" + ens_user_tid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllCommission(_response);
        });
    }

    protected processGetAllCommission(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    getPreApprovedCommissionAsAgent(ens_user_tid: number): Promise<CommissionRow[]> {
        let url_ = this.baseUrl + "/api/commission/agent/{ens_user_tid}/pre_approved";
        if (ens_user_tid === undefined || ens_user_tid === null)
            throw new Error("The parameter 'ens_user_tid' must be defined.");
        url_ = url_.replace("{ens_user_tid}", encodeURIComponent("" + ens_user_tid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPreApprovedCommissionAsAgent(_response);
        });
    }

    protected processGetPreApprovedCommissionAsAgent(response: Response): Promise<CommissionRow[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommissionRow.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommissionRow[]>(<any>null);
    }

    getPaidCommissionAsAgent(ens_user_tid: number): Promise<CommissionRow[]> {
        let url_ = this.baseUrl + "/api/commission/agent/{ens_user_tid}/paid";
        if (ens_user_tid === undefined || ens_user_tid === null)
            throw new Error("The parameter 'ens_user_tid' must be defined.");
        url_ = url_.replace("{ens_user_tid}", encodeURIComponent("" + ens_user_tid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPaidCommissionAsAgent(_response);
        });
    }

    protected processGetPaidCommissionAsAgent(response: Response): Promise<CommissionRow[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommissionRow.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommissionRow[]>(<any>null);
    }

    getPreApprovedCommissionAsAdmin(ens_user_tid: number): Promise<AdminCommissionRow[]> {
        let url_ = this.baseUrl + "/api/commission/admin/{ens_user_tid}/pre_approved";
        if (ens_user_tid === undefined || ens_user_tid === null)
            throw new Error("The parameter 'ens_user_tid' must be defined.");
        url_ = url_.replace("{ens_user_tid}", encodeURIComponent("" + ens_user_tid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPreApprovedCommissionAsAdmin(_response);
        });
    }

    protected processGetPreApprovedCommissionAsAdmin(response: Response): Promise<AdminCommissionRow[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdminCommissionRow.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminCommissionRow[]>(<any>null);
    }

    getAgentApprovedCommission(ens_user_tid: number): Promise<AdminCommissionRow[]> {
        let url_ = this.baseUrl + "/api/commission/admin/{ens_user_tid}/agent_approved";
        if (ens_user_tid === undefined || ens_user_tid === null)
            throw new Error("The parameter 'ens_user_tid' must be defined.");
        url_ = url_.replace("{ens_user_tid}", encodeURIComponent("" + ens_user_tid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentApprovedCommission(_response);
        });
    }

    protected processGetAgentApprovedCommission(response: Response): Promise<AdminCommissionRow[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdminCommissionRow.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminCommissionRow[]>(<any>null);
    }

    getReadyForPaymentCommission(ens_user_tid: number): Promise<AdminCommissionRow[]> {
        let url_ = this.baseUrl + "/api/commission/admin/{ens_user_tid}/ready_for_payment";
        if (ens_user_tid === undefined || ens_user_tid === null)
            throw new Error("The parameter 'ens_user_tid' must be defined.");
        url_ = url_.replace("{ens_user_tid}", encodeURIComponent("" + ens_user_tid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetReadyForPaymentCommission(_response);
        });
    }

    protected processGetReadyForPaymentCommission(response: Response): Promise<AdminCommissionRow[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdminCommissionRow.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminCommissionRow[]>(<any>null);
    }

    getPaidCommission(ens_user_tid: number): Promise<AdminCommissionRow[]> {
        let url_ = this.baseUrl + "/api/commission/admin/{ens_user_tid}/paid";
        if (ens_user_tid === undefined || ens_user_tid === null)
            throw new Error("The parameter 'ens_user_tid' must be defined.");
        url_ = url_.replace("{ens_user_tid}", encodeURIComponent("" + ens_user_tid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPaidCommission(_response);
        });
    }

    protected processGetPaidCommission(response: Response): Promise<AdminCommissionRow[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdminCommissionRow.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminCommissionRow[]>(<any>null);
    }

    updateCommissionStatus(request: CommissionStatusRequest[]): Promise<UserCommissionStatusResponse> {
        let url_ = this.baseUrl + "/api/commission/status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCommissionStatus(_response);
        });
    }

    protected processUpdateCommissionStatus(response: Response): Promise<UserCommissionStatusResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserCommissionStatusResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserCommissionStatusResponse>(<any>null);
    }

    addAgentCommission(request: AddCommissionRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/commission/special";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddAgentCommission(_response);
        });
    }

    protected processAddAgentCommission(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class CallingUserMessage implements ICallingUserMessage {
    calling_user!: string;

    constructor(data?: ICallingUserMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calling_user = _data["calling_user"];
        }
    }

    static fromJS(data: any): CallingUserMessage {
        data = typeof data === 'object' ? data : {};
        let result = new CallingUserMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calling_user"] = this.calling_user;
        return data; 
    }
}

export interface ICallingUserMessage {
    calling_user: string;
}

export class EditBrokerIdRequest extends CallingUserMessage implements IEditBrokerIdRequest {
    broker_id!: string;

    constructor(data?: IEditBrokerIdRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.broker_id = _data["broker_id"];
        }
    }

    static fromJS(data: any): EditBrokerIdRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditBrokerIdRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["broker_id"] = this.broker_id;
        super.toJSON(data);
        return data; 
    }
}

export interface IEditBrokerIdRequest extends ICallingUserMessage {
    broker_id: string;
}

export class RtsReportUploadResponse implements IRtsReportUploadResponse {
    readyToSellUpdateCount?: number;

    constructor(data?: IRtsReportUploadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.readyToSellUpdateCount = _data["readyToSellUpdateCount"];
        }
    }

    static fromJS(data: any): RtsReportUploadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RtsReportUploadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["readyToSellUpdateCount"] = this.readyToSellUpdateCount;
        return data; 
    }
}

export interface IRtsReportUploadResponse {
    readyToSellUpdateCount?: number;
}

export enum ReadyToSellReportType {
    Humana = 0,
    UHC = 1,
    AetnaMA2021 = 2,
    AetnaMA2022 = 3,
    Anthem = 4,
    SunFireSmallCarriers = 5,
    HarvardPilgrim = 6,
    PeoplesHealth = 7,
}

export class LeadPostRequest implements ILeadPostRequest {
    object?: string | undefined;
    entry?: Entry[] | undefined;
    ipAddress?: string | undefined;

    constructor(data?: ILeadPostRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.object = _data["object"];
            if (Array.isArray(_data["entry"])) {
                this.entry = [] as any;
                for (let item of _data["entry"])
                    this.entry!.push(Entry.fromJS(item));
            }
            this.ipAddress = _data["ipAddress"];
        }
    }

    static fromJS(data: any): LeadPostRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LeadPostRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["object"] = this.object;
        if (Array.isArray(this.entry)) {
            data["entry"] = [];
            for (let item of this.entry)
                data["entry"].push(item.toJSON());
        }
        data["ipAddress"] = this.ipAddress;
        return data; 
    }
}

export interface ILeadPostRequest {
    object?: string | undefined;
    entry?: Entry[] | undefined;
    ipAddress?: string | undefined;
}

export class Entry implements IEntry {
    id?: string | undefined;
    time?: number;
    changes?: Change[] | undefined;

    constructor(data?: IEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.time = _data["time"];
            if (Array.isArray(_data["changes"])) {
                this.changes = [] as any;
                for (let item of _data["changes"])
                    this.changes!.push(Change.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Entry {
        data = typeof data === 'object' ? data : {};
        let result = new Entry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["time"] = this.time;
        if (Array.isArray(this.changes)) {
            data["changes"] = [];
            for (let item of this.changes)
                data["changes"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IEntry {
    id?: string | undefined;
    time?: number;
    changes?: Change[] | undefined;
}

export class Change implements IChange {
    value?: Value | undefined;
    field?: string | undefined;

    constructor(data?: IChange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? Value.fromJS(_data["value"]) : <any>undefined;
            this.field = _data["field"];
        }
    }

    static fromJS(data: any): Change {
        data = typeof data === 'object' ? data : {};
        let result = new Change();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        data["field"] = this.field;
        return data; 
    }
}

export interface IChange {
    value?: Value | undefined;
    field?: string | undefined;
}

export class Value implements IValue {
    ad_id?: string | undefined;
    form_id?: string | undefined;
    leadgen_id?: string | undefined;
    created_time?: number;
    page_id?: string | undefined;
    adgroup_id?: string | undefined;

    constructor(data?: IValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ad_id = _data["ad_id"];
            this.form_id = _data["form_id"];
            this.leadgen_id = _data["leadgen_id"];
            this.created_time = _data["created_time"];
            this.page_id = _data["page_id"];
            this.adgroup_id = _data["adgroup_id"];
        }
    }

    static fromJS(data: any): Value {
        data = typeof data === 'object' ? data : {};
        let result = new Value();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ad_id"] = this.ad_id;
        data["form_id"] = this.form_id;
        data["leadgen_id"] = this.leadgen_id;
        data["created_time"] = this.created_time;
        data["page_id"] = this.page_id;
        data["adgroup_id"] = this.adgroup_id;
        return data; 
    }
}

export interface IValue {
    ad_id?: string | undefined;
    form_id?: string | undefined;
    leadgen_id?: string | undefined;
    created_time?: number;
    page_id?: string | undefined;
    adgroup_id?: string | undefined;
}

export class GetActiveLicensesByStateResponse implements IGetActiveLicensesByStateResponse {
    active_licenses!: ActiveLicense[] | undefined;

    constructor(data?: IGetActiveLicensesByStateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["active_licenses"])) {
                this.active_licenses = [] as any;
                for (let item of _data["active_licenses"])
                    this.active_licenses!.push(ActiveLicense.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetActiveLicensesByStateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetActiveLicensesByStateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.active_licenses)) {
            data["active_licenses"] = [];
            for (let item of this.active_licenses)
                data["active_licenses"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetActiveLicensesByStateResponse {
    active_licenses: ActiveLicense[] | undefined;
}

export class ActiveLicense implements IActiveLicense {
    ens_user_tid!: number;
    first_name!: string;
    last_name!: string;
    npn!: string;
    state!: string;

    constructor(data?: IActiveLicense) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_user_tid = _data["ens_user_tid"];
            this.first_name = _data["first_name"];
            this.last_name = _data["last_name"];
            this.npn = _data["npn"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): ActiveLicense {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveLicense();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_user_tid"] = this.ens_user_tid;
        data["first_name"] = this.first_name;
        data["last_name"] = this.last_name;
        data["npn"] = this.npn;
        data["state"] = this.state;
        return data; 
    }
}

export interface IActiveLicense {
    ens_user_tid: number;
    first_name: string;
    last_name: string;
    npn: string;
    state: string;
}

export class NiprLastUpdateResponse implements INiprLastUpdateResponse {
    appointment_status!: NiprTaskStatus;
    licensing_status!: NiprTaskStatus;

    constructor(data?: INiprLastUpdateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.appointment_status = new NiprTaskStatus();
            this.licensing_status = new NiprTaskStatus();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointment_status = _data["appointment_status"] ? NiprTaskStatus.fromJS(_data["appointment_status"]) : new NiprTaskStatus();
            this.licensing_status = _data["licensing_status"] ? NiprTaskStatus.fromJS(_data["licensing_status"]) : new NiprTaskStatus();
        }
    }

    static fromJS(data: any): NiprLastUpdateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NiprLastUpdateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointment_status"] = this.appointment_status ? this.appointment_status.toJSON() : <any>undefined;
        data["licensing_status"] = this.licensing_status ? this.licensing_status.toJSON() : <any>undefined;
        return data; 
    }
}

export interface INiprLastUpdateResponse {
    appointment_status: NiprTaskStatus;
    licensing_status: NiprTaskStatus;
}

export class NiprTaskStatus implements INiprTaskStatus {
    last_run_timestamp!: Date | undefined;
    last_run_status!: string | undefined;
    last_successful_timestamp!: Date | undefined;

    constructor(data?: INiprTaskStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.last_run_timestamp = _data["last_run_timestamp"] ? new Date(_data["last_run_timestamp"].toString()) : <any>undefined;
            this.last_run_status = _data["last_run_status"];
            this.last_successful_timestamp = _data["last_successful_timestamp"] ? new Date(_data["last_successful_timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NiprTaskStatus {
        data = typeof data === 'object' ? data : {};
        let result = new NiprTaskStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["last_run_timestamp"] = this.last_run_timestamp ? this.last_run_timestamp.toISOString() : <any>undefined;
        data["last_run_status"] = this.last_run_status;
        data["last_successful_timestamp"] = this.last_successful_timestamp ? this.last_successful_timestamp.toISOString() : <any>undefined;
        return data; 
    }
}

export interface INiprTaskStatus {
    last_run_timestamp: Date | undefined;
    last_run_status: string | undefined;
    last_successful_timestamp: Date | undefined;
}

export class CreateReportResponse implements ICreateReportResponse {
    report_id?: string | undefined;

    constructor(data?: ICreateReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.report_id = _data["report_id"];
        }
    }

    static fromJS(data: any): CreateReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["report_id"] = this.report_id;
        return data; 
    }
}

export interface ICreateReportResponse {
    report_id?: string | undefined;
}

export class CreateReportRequest implements ICreateReportRequest {
    calling_object?: string | undefined;

    constructor(data?: ICreateReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calling_object = _data["calling_object"];
        }
    }

    static fromJS(data: any): CreateReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calling_object"] = this.calling_object;
        return data; 
    }
}

export interface ICreateReportRequest {
    calling_object?: string | undefined;
}

export class CheckReportStatusResponse implements ICheckReportStatusResponse {
    report_id?: string | undefined;
    report_title?: string | undefined;
    report_status?: string | undefined;
    submit_date?: string | undefined;
    processed_date?: string | undefined;
    complete_date?: string | undefined;
    lines?: string | undefined;
    price?: string | undefined;
    environment?: string | undefined;

    constructor(data?: ICheckReportStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.report_id = _data["report_id"];
            this.report_title = _data["report_title"];
            this.report_status = _data["report_status"];
            this.submit_date = _data["submit_date"];
            this.processed_date = _data["processed_date"];
            this.complete_date = _data["complete_date"];
            this.lines = _data["lines"];
            this.price = _data["price"];
            this.environment = _data["environment"];
        }
    }

    static fromJS(data: any): CheckReportStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CheckReportStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["report_id"] = this.report_id;
        data["report_title"] = this.report_title;
        data["report_status"] = this.report_status;
        data["submit_date"] = this.submit_date;
        data["processed_date"] = this.processed_date;
        data["complete_date"] = this.complete_date;
        data["lines"] = this.lines;
        data["price"] = this.price;
        data["environment"] = this.environment;
        return data; 
    }
}

export interface ICheckReportStatusResponse {
    report_id?: string | undefined;
    report_title?: string | undefined;
    report_status?: string | undefined;
    submit_date?: string | undefined;
    processed_date?: string | undefined;
    complete_date?: string | undefined;
    lines?: string | undefined;
    price?: string | undefined;
    environment?: string | undefined;
}

export class CheckReportStatusRequest implements ICheckReportStatusRequest {
    calling_object?: string | undefined;
    report_id?: string | undefined;

    constructor(data?: ICheckReportStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calling_object = _data["calling_object"];
            this.report_id = _data["report_id"];
        }
    }

    static fromJS(data: any): CheckReportStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckReportStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calling_object"] = this.calling_object;
        data["report_id"] = this.report_id;
        return data; 
    }
}

export interface ICheckReportStatusRequest {
    calling_object?: string | undefined;
    report_id?: string | undefined;
}

export class RetrieveReportResponse implements IRetrieveReportResponse {
    sCB_Report_Header?: ScbReportHeader | undefined;
    sCB_Report_Body?: ScbReportBody | undefined;

    constructor(data?: IRetrieveReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sCB_Report_Header = _data["SCB_Report_Header"] ? ScbReportHeader.fromJS(_data["SCB_Report_Header"]) : <any>undefined;
            this.sCB_Report_Body = _data["SCB_Report_Body"] ? ScbReportBody.fromJS(_data["SCB_Report_Body"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RetrieveReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SCB_Report_Header"] = this.sCB_Report_Header ? this.sCB_Report_Header.toJSON() : <any>undefined;
        data["SCB_Report_Body"] = this.sCB_Report_Body ? this.sCB_Report_Body.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IRetrieveReportResponse {
    sCB_Report_Header?: ScbReportHeader | undefined;
    sCB_Report_Body?: ScbReportBody | undefined;
}

export class ScbReportHeader implements IScbReportHeader {
    report_Type?: string | undefined;
    title?: string | undefined;
    timeStamp_Created?: string | undefined;

    constructor(data?: IScbReportHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.report_Type = _data["Report_Type"];
            this.title = _data["Title"];
            this.timeStamp_Created = _data["TimeStamp_Created"];
        }
    }

    static fromJS(data: any): ScbReportHeader {
        data = typeof data === 'object' ? data : {};
        let result = new ScbReportHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Report_Type"] = this.report_Type;
        data["Title"] = this.title;
        data["TimeStamp_Created"] = this.timeStamp_Created;
        return data; 
    }
}

export interface IScbReportHeader {
    report_Type?: string | undefined;
    title?: string | undefined;
    timeStamp_Created?: string | undefined;
}

export class ScbReportBody implements IScbReportBody {
    sCB_Producer?: ScbProducer[] | undefined;
    sCB_Partial_Find_List?: string | undefined;

    constructor(data?: IScbReportBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["SCB_Producer"])) {
                this.sCB_Producer = [] as any;
                for (let item of _data["SCB_Producer"])
                    this.sCB_Producer!.push(ScbProducer.fromJS(item));
            }
            this.sCB_Partial_Find_List = _data["SCB_Partial_Find_List"];
        }
    }

    static fromJS(data: any): ScbReportBody {
        data = typeof data === 'object' ? data : {};
        let result = new ScbReportBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sCB_Producer)) {
            data["SCB_Producer"] = [];
            for (let item of this.sCB_Producer)
                data["SCB_Producer"].push(item.toJSON());
        }
        data["SCB_Partial_Find_List"] = this.sCB_Partial_Find_List;
        return data; 
    }
}

export interface IScbReportBody {
    sCB_Producer?: ScbProducer[] | undefined;
    sCB_Partial_Find_List?: string | undefined;
}

export class ScbProducer implements IScbProducer {
    name_Birth?: NameBirth | undefined;
    address?: Address[] | undefined;
    contact_Info?: ContactInfo[] | undefined;
    license?: NiprLicense[] | undefined;
    appointment?: NiprAppointment[] | undefined;
    national_Producer_Number?: string | undefined;
    entity_Id?: string | undefined;
    secondary_ID?: string | undefined;
    fEIN?: string | undefined;

    constructor(data?: IScbProducer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name_Birth = _data["Name_Birth"] ? NameBirth.fromJS(_data["Name_Birth"]) : <any>undefined;
            if (Array.isArray(_data["Address"])) {
                this.address = [] as any;
                for (let item of _data["Address"])
                    this.address!.push(Address.fromJS(item));
            }
            if (Array.isArray(_data["Contact_Info"])) {
                this.contact_Info = [] as any;
                for (let item of _data["Contact_Info"])
                    this.contact_Info!.push(ContactInfo.fromJS(item));
            }
            if (Array.isArray(_data["License"])) {
                this.license = [] as any;
                for (let item of _data["License"])
                    this.license!.push(NiprLicense.fromJS(item));
            }
            if (Array.isArray(_data["Appointment"])) {
                this.appointment = [] as any;
                for (let item of _data["Appointment"])
                    this.appointment!.push(NiprAppointment.fromJS(item));
            }
            this.national_Producer_Number = _data["National_Producer_Number"];
            this.entity_Id = _data["Entity_Id"];
            this.secondary_ID = _data["Secondary_ID"];
            this.fEIN = _data["FEIN"];
        }
    }

    static fromJS(data: any): ScbProducer {
        data = typeof data === 'object' ? data : {};
        let result = new ScbProducer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name_Birth"] = this.name_Birth ? this.name_Birth.toJSON() : <any>undefined;
        if (Array.isArray(this.address)) {
            data["Address"] = [];
            for (let item of this.address)
                data["Address"].push(item.toJSON());
        }
        if (Array.isArray(this.contact_Info)) {
            data["Contact_Info"] = [];
            for (let item of this.contact_Info)
                data["Contact_Info"].push(item.toJSON());
        }
        if (Array.isArray(this.license)) {
            data["License"] = [];
            for (let item of this.license)
                data["License"].push(item.toJSON());
        }
        if (Array.isArray(this.appointment)) {
            data["Appointment"] = [];
            for (let item of this.appointment)
                data["Appointment"].push(item.toJSON());
        }
        data["National_Producer_Number"] = this.national_Producer_Number;
        data["Entity_Id"] = this.entity_Id;
        data["Secondary_ID"] = this.secondary_ID;
        data["FEIN"] = this.fEIN;
        return data; 
    }
}

export interface IScbProducer {
    name_Birth?: NameBirth | undefined;
    address?: Address[] | undefined;
    contact_Info?: ContactInfo[] | undefined;
    license?: NiprLicense[] | undefined;
    appointment?: NiprAppointment[] | undefined;
    national_Producer_Number?: string | undefined;
    entity_Id?: string | undefined;
    secondary_ID?: string | undefined;
    fEIN?: string | undefined;
}

export class NameBirth implements INameBirth {
    other_Name?: OtherName[] | undefined;
    primary_Name?: string | undefined;
    first_Name?: string | undefined;
    middle_Name?: string | undefined;
    last_Name?: string | undefined;
    name_Suffix?: string | undefined;
    date_Of_Birth?: string | undefined;

    constructor(data?: INameBirth) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Other_Name"])) {
                this.other_Name = [] as any;
                for (let item of _data["Other_Name"])
                    this.other_Name!.push(OtherName.fromJS(item));
            }
            this.primary_Name = _data["Primary_Name"];
            this.first_Name = _data["First_Name"];
            this.middle_Name = _data["Middle_Name"];
            this.last_Name = _data["Last_Name"];
            this.name_Suffix = _data["Name_Suffix"];
            this.date_Of_Birth = _data["Date_Of_Birth"];
        }
    }

    static fromJS(data: any): NameBirth {
        data = typeof data === 'object' ? data : {};
        let result = new NameBirth();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.other_Name)) {
            data["Other_Name"] = [];
            for (let item of this.other_Name)
                data["Other_Name"].push(item.toJSON());
        }
        data["Primary_Name"] = this.primary_Name;
        data["First_Name"] = this.first_Name;
        data["Middle_Name"] = this.middle_Name;
        data["Last_Name"] = this.last_Name;
        data["Name_Suffix"] = this.name_Suffix;
        data["Date_Of_Birth"] = this.date_Of_Birth;
        return data; 
    }
}

export interface INameBirth {
    other_Name?: OtherName[] | undefined;
    primary_Name?: string | undefined;
    first_Name?: string | undefined;
    middle_Name?: string | undefined;
    last_Name?: string | undefined;
    name_Suffix?: string | undefined;
    date_Of_Birth?: string | undefined;
}

export class OtherName implements IOtherName {
    state_Code?: string | undefined;
    name?: string | undefined;
    name_Type?: string | undefined;
    first_Name?: string | undefined;
    middle_Name?: string | undefined;
    last_Name?: string | undefined;
    name_Suffix?: string | undefined;
    state_Id?: string | undefined;

    constructor(data?: IOtherName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state_Code = _data["State_Code"];
            this.name = _data["Name"];
            this.name_Type = _data["Name_Type"];
            this.first_Name = _data["First_Name"];
            this.middle_Name = _data["Middle_Name"];
            this.last_Name = _data["Last_Name"];
            this.name_Suffix = _data["Name_Suffix"];
            this.state_Id = _data["State_Id"];
        }
    }

    static fromJS(data: any): OtherName {
        data = typeof data === 'object' ? data : {};
        let result = new OtherName();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["State_Code"] = this.state_Code;
        data["Name"] = this.name;
        data["Name_Type"] = this.name_Type;
        data["First_Name"] = this.first_Name;
        data["Middle_Name"] = this.middle_Name;
        data["Last_Name"] = this.last_Name;
        data["Name_Suffix"] = this.name_Suffix;
        data["State_Id"] = this.state_Id;
        return data; 
    }
}

export interface IOtherName {
    state_Code?: string | undefined;
    name?: string | undefined;
    name_Type?: string | undefined;
    first_Name?: string | undefined;
    middle_Name?: string | undefined;
    last_Name?: string | undefined;
    name_Suffix?: string | undefined;
    state_Id?: string | undefined;
}

export class Address implements IAddress {
    state_Code?: string | undefined;
    address_Type_Code?: string | undefined;
    address_Type?: string | undefined;
    date_Updated?: string | undefined;
    address_Line1?: string | undefined;
    address_Line2?: string | undefined;
    address_Line3?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip_Code?: string | undefined;
    country?: string | undefined;
    state_Id?: string | undefined;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state_Code = _data["State_Code"];
            this.address_Type_Code = _data["Address_Type_Code"];
            this.address_Type = _data["Address_Type"];
            this.date_Updated = _data["Date_Updated"];
            this.address_Line1 = _data["Address_Line1"];
            this.address_Line2 = _data["Address_Line2"];
            this.address_Line3 = _data["Address_Line3"];
            this.city = _data["City"];
            this.state = _data["State"];
            this.zip_Code = _data["Zip_Code"];
            this.country = _data["Country"];
            this.state_Id = _data["State_Id"];
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["State_Code"] = this.state_Code;
        data["Address_Type_Code"] = this.address_Type_Code;
        data["Address_Type"] = this.address_Type;
        data["Date_Updated"] = this.date_Updated;
        data["Address_Line1"] = this.address_Line1;
        data["Address_Line2"] = this.address_Line2;
        data["Address_Line3"] = this.address_Line3;
        data["City"] = this.city;
        data["State"] = this.state;
        data["Zip_Code"] = this.zip_Code;
        data["Country"] = this.country;
        data["State_Id"] = this.state_Id;
        return data; 
    }
}

export interface IAddress {
    state_Code?: string | undefined;
    address_Type_Code?: string | undefined;
    address_Type?: string | undefined;
    date_Updated?: string | undefined;
    address_Line1?: string | undefined;
    address_Line2?: string | undefined;
    address_Line3?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip_Code?: string | undefined;
    country?: string | undefined;
    state_Id?: string | undefined;
}

export class ContactInfo implements IContactInfo {
    state_Code?: string | undefined;
    business_Phone?: string | undefined;
    business_Phone_Update_Date?: string | undefined;
    business_Email?: string | undefined;
    business_Email_Update_Date?: string | undefined;
    fax?: string | undefined;
    fax_Update_Date?: string | undefined;
    state_Id?: string | undefined;

    constructor(data?: IContactInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state_Code = _data["State_Code"];
            this.business_Phone = _data["Business_Phone"];
            this.business_Phone_Update_Date = _data["Business_Phone_Update_Date"];
            this.business_Email = _data["Business_Email"];
            this.business_Email_Update_Date = _data["Business_Email_Update_Date"];
            this.fax = _data["Fax"];
            this.fax_Update_Date = _data["Fax_Update_Date"];
            this.state_Id = _data["State_Id"];
        }
    }

    static fromJS(data: any): ContactInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ContactInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["State_Code"] = this.state_Code;
        data["Business_Phone"] = this.business_Phone;
        data["Business_Phone_Update_Date"] = this.business_Phone_Update_Date;
        data["Business_Email"] = this.business_Email;
        data["Business_Email_Update_Date"] = this.business_Email_Update_Date;
        data["Fax"] = this.fax;
        data["Fax_Update_Date"] = this.fax_Update_Date;
        data["State_Id"] = this.state_Id;
        return data; 
    }
}

export interface IContactInfo {
    state_Code?: string | undefined;
    business_Phone?: string | undefined;
    business_Phone_Update_Date?: string | undefined;
    business_Email?: string | undefined;
    business_Email_Update_Date?: string | undefined;
    fax?: string | undefined;
    fax_Update_Date?: string | undefined;
    state_Id?: string | undefined;
}

export class NiprLicense implements INiprLicense {
    lOA?: Loa[] | undefined;
    state_Code?: string | undefined;
    class?: string | undefined;
    license_Class_Code?: string | undefined;
    license_Number?: string | undefined;
    active?: string | undefined;
    resident_Indicator?: string | undefined;
    license_Issue_Date?: string | undefined;
    license_Expiration_Date?: string | undefined;
    state_Id?: string | undefined;

    constructor(data?: INiprLicense) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["LOA"])) {
                this.lOA = [] as any;
                for (let item of _data["LOA"])
                    this.lOA!.push(Loa.fromJS(item));
            }
            this.state_Code = _data["State_Code"];
            this.class = _data["Class"];
            this.license_Class_Code = _data["License_Class_Code"];
            this.license_Number = _data["License_Number"];
            this.active = _data["Active"];
            this.resident_Indicator = _data["Resident_Indicator"];
            this.license_Issue_Date = _data["License_Issue_Date"];
            this.license_Expiration_Date = _data["License_Expiration_Date"];
            this.state_Id = _data["State_Id"];
        }
    }

    static fromJS(data: any): NiprLicense {
        data = typeof data === 'object' ? data : {};
        let result = new NiprLicense();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.lOA)) {
            data["LOA"] = [];
            for (let item of this.lOA)
                data["LOA"].push(item.toJSON());
        }
        data["State_Code"] = this.state_Code;
        data["Class"] = this.class;
        data["License_Class_Code"] = this.license_Class_Code;
        data["License_Number"] = this.license_Number;
        data["Active"] = this.active;
        data["Resident_Indicator"] = this.resident_Indicator;
        data["License_Issue_Date"] = this.license_Issue_Date;
        data["License_Expiration_Date"] = this.license_Expiration_Date;
        data["State_Id"] = this.state_Id;
        return data; 
    }
}

export interface INiprLicense {
    lOA?: Loa[] | undefined;
    state_Code?: string | undefined;
    class?: string | undefined;
    license_Class_Code?: string | undefined;
    license_Number?: string | undefined;
    active?: string | undefined;
    resident_Indicator?: string | undefined;
    license_Issue_Date?: string | undefined;
    license_Expiration_Date?: string | undefined;
    state_Id?: string | undefined;
}

export class Loa implements ILoa {
    lOA_Name?: string | undefined;
    lOA_Code?: string | undefined;
    lOA_Issue_Date?: string | undefined;
    lOA_Status?: string | undefined;
    lOA_Status_Reason?: string | undefined;
    lOA_Status_Reason_Date?: string | undefined;
    cE_Compliance?: string | undefined;
    cE_Renewal_Date?: string | undefined;
    cE_Credits_Needed?: string | undefined;

    constructor(data?: ILoa) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lOA_Name = _data["LOA_Name"];
            this.lOA_Code = _data["LOA_Code"];
            this.lOA_Issue_Date = _data["LOA_Issue_Date"];
            this.lOA_Status = _data["LOA_Status"];
            this.lOA_Status_Reason = _data["LOA_Status_Reason"];
            this.lOA_Status_Reason_Date = _data["LOA_Status_Reason_Date"];
            this.cE_Compliance = _data["CE_Compliance"];
            this.cE_Renewal_Date = _data["CE_Renewal_Date"];
            this.cE_Credits_Needed = _data["CE_Credits_Needed"];
        }
    }

    static fromJS(data: any): Loa {
        data = typeof data === 'object' ? data : {};
        let result = new Loa();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LOA_Name"] = this.lOA_Name;
        data["LOA_Code"] = this.lOA_Code;
        data["LOA_Issue_Date"] = this.lOA_Issue_Date;
        data["LOA_Status"] = this.lOA_Status;
        data["LOA_Status_Reason"] = this.lOA_Status_Reason;
        data["LOA_Status_Reason_Date"] = this.lOA_Status_Reason_Date;
        data["CE_Compliance"] = this.cE_Compliance;
        data["CE_Renewal_Date"] = this.cE_Renewal_Date;
        data["CE_Credits_Needed"] = this.cE_Credits_Needed;
        return data; 
    }
}

export interface ILoa {
    lOA_Name?: string | undefined;
    lOA_Code?: string | undefined;
    lOA_Issue_Date?: string | undefined;
    lOA_Status?: string | undefined;
    lOA_Status_Reason?: string | undefined;
    lOA_Status_Reason_Date?: string | undefined;
    cE_Compliance?: string | undefined;
    cE_Renewal_Date?: string | undefined;
    cE_Credits_Needed?: string | undefined;
}

export class NiprAppointment implements INiprAppointment {
    state_Code?: string | undefined;
    company_Name?: string | undefined;
    fl_County_Desc?: string | undefined;
    fEIN?: string | undefined;
    cOCODE?: string | undefined;
    line_Of_Authority?: string | undefined;
    lOA_Code?: string | undefined;
    status?: string | undefined;
    termination_Reason?: string | undefined;
    status_Reason_Date?: string | undefined;
    renewal_Date?: string | undefined;

    constructor(data?: INiprAppointment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state_Code = _data["State_Code"];
            this.company_Name = _data["Company_Name"];
            this.fl_County_Desc = _data["Fl_County_Desc"];
            this.fEIN = _data["FEIN"];
            this.cOCODE = _data["COCODE"];
            this.line_Of_Authority = _data["Line_Of_Authority"];
            this.lOA_Code = _data["LOA_Code"];
            this.status = _data["Status"];
            this.termination_Reason = _data["Termination_Reason"];
            this.status_Reason_Date = _data["Status_Reason_Date"];
            this.renewal_Date = _data["Renewal_Date"];
        }
    }

    static fromJS(data: any): NiprAppointment {
        data = typeof data === 'object' ? data : {};
        let result = new NiprAppointment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["State_Code"] = this.state_Code;
        data["Company_Name"] = this.company_Name;
        data["Fl_County_Desc"] = this.fl_County_Desc;
        data["FEIN"] = this.fEIN;
        data["COCODE"] = this.cOCODE;
        data["Line_Of_Authority"] = this.line_Of_Authority;
        data["LOA_Code"] = this.lOA_Code;
        data["Status"] = this.status;
        data["Termination_Reason"] = this.termination_Reason;
        data["Status_Reason_Date"] = this.status_Reason_Date;
        data["Renewal_Date"] = this.renewal_Date;
        return data; 
    }
}

export interface INiprAppointment {
    state_Code?: string | undefined;
    company_Name?: string | undefined;
    fl_County_Desc?: string | undefined;
    fEIN?: string | undefined;
    cOCODE?: string | undefined;
    line_Of_Authority?: string | undefined;
    lOA_Code?: string | undefined;
    status?: string | undefined;
    termination_Reason?: string | undefined;
    status_Reason_Date?: string | undefined;
    renewal_Date?: string | undefined;
}

export class RetrieveReportRequest implements IRetrieveReportRequest {
    calling_object?: string | undefined;
    report_id?: string | undefined;

    constructor(data?: IRetrieveReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calling_object = _data["calling_object"];
            this.report_id = _data["report_id"];
        }
    }

    static fromJS(data: any): RetrieveReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calling_object"] = this.calling_object;
        data["report_id"] = this.report_id;
        return data; 
    }
}

export interface IRetrieveReportRequest {
    calling_object?: string | undefined;
    report_id?: string | undefined;
}

export class OverlordSlackMessageRequest implements IOverlordSlackMessageRequest {
    message?: string | undefined;
    severity?: string | undefined;
    source?: string | undefined;
    data?: string | undefined;

    constructor(data?: IOverlordSlackMessageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.severity = _data["severity"];
            this.source = _data["source"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): OverlordSlackMessageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OverlordSlackMessageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["severity"] = this.severity;
        data["source"] = this.source;
        data["data"] = this.data;
        return data; 
    }
}

export interface IOverlordSlackMessageRequest {
    message?: string | undefined;
    severity?: string | undefined;
    source?: string | undefined;
    data?: string | undefined;
}

export class OverlordTeamsMessageRequest implements IOverlordTeamsMessageRequest {
    message?: string | undefined;
    severity?: string | undefined;
    source?: string | undefined;
    data?: string | undefined;

    constructor(data?: IOverlordTeamsMessageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.severity = _data["severity"];
            this.source = _data["source"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): OverlordTeamsMessageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OverlordTeamsMessageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["severity"] = this.severity;
        data["source"] = this.source;
        data["data"] = this.data;
        return data; 
    }
}

export interface IOverlordTeamsMessageRequest {
    message?: string | undefined;
    severity?: string | undefined;
    source?: string | undefined;
    data?: string | undefined;
}

export class OverlordTriggerSequenceRequest implements IOverlordTriggerSequenceRequest {
    argSequenceId?: string | undefined;
    sequenceArgs?: { [key: string]: string; } | undefined;

    constructor(data?: IOverlordTriggerSequenceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.argSequenceId = _data["argSequenceId"];
            if (_data["sequenceArgs"]) {
                this.sequenceArgs = {} as any;
                for (let key in _data["sequenceArgs"]) {
                    if (_data["sequenceArgs"].hasOwnProperty(key))
                        (<any>this.sequenceArgs)![key] = _data["sequenceArgs"][key];
                }
            }
        }
    }

    static fromJS(data: any): OverlordTriggerSequenceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OverlordTriggerSequenceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["argSequenceId"] = this.argSequenceId;
        if (this.sequenceArgs) {
            data["sequenceArgs"] = {};
            for (let key in this.sequenceArgs) {
                if (this.sequenceArgs.hasOwnProperty(key))
                    (<any>data["sequenceArgs"])[key] = this.sequenceArgs[key];
            }
        }
        return data; 
    }
}

export interface IOverlordTriggerSequenceRequest {
    argSequenceId?: string | undefined;
    sequenceArgs?: { [key: string]: string; } | undefined;
}

export class OverlordTriggerTaskRequest implements IOverlordTriggerTaskRequest {
    taskId?: string | undefined;
    taskArgs?: { [key: string]: string; } | undefined;

    constructor(data?: IOverlordTriggerTaskRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            if (_data["taskArgs"]) {
                this.taskArgs = {} as any;
                for (let key in _data["taskArgs"]) {
                    if (_data["taskArgs"].hasOwnProperty(key))
                        (<any>this.taskArgs)![key] = _data["taskArgs"][key];
                }
            }
        }
    }

    static fromJS(data: any): OverlordTriggerTaskRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OverlordTriggerTaskRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        if (this.taskArgs) {
            data["taskArgs"] = {};
            for (let key in this.taskArgs) {
                if (this.taskArgs.hasOwnProperty(key))
                    (<any>data["taskArgs"])[key] = this.taskArgs[key];
            }
        }
        return data; 
    }
}

export interface IOverlordTriggerTaskRequest {
    taskId?: string | undefined;
    taskArgs?: { [key: string]: string; } | undefined;
}

export class EnsProductResponse implements IEnsProductResponse {
    ens_product_tid!: EnsProductTid;
    product_name!: string;

    constructor(data?: IEnsProductResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_product_tid = _data["ens_product_tid"];
            this.product_name = _data["product_name"];
        }
    }

    static fromJS(data: any): EnsProductResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnsProductResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_product_tid"] = this.ens_product_tid;
        data["product_name"] = this.product_name;
        return data; 
    }
}

export interface IEnsProductResponse {
    ens_product_tid: EnsProductTid;
    product_name: string;
}

export enum EnsProductTid {
    None = 0,
    Unspecfied = 1,
    AAAMembership = 2,
    ADD = 3,
    CremationProduct = 4,
    CriticalIllness = 5,
    DentalVisionCombo = 6,
    DentalVisionHearingCombo = 7,
    Dental = 8,
    DisabilityIncome = 9,
    FinalExpense = 10,
    HospitalIndemnity = 11,
    MASpecialNeedsPlans = 12,
    MA = 13,
    MAPD = 14,
    MedSuppPlanA = 15,
    MedSuppPlanB = 16,
    MedSuppPlanC = 17,
    MedSuppPlanD = 18,
    MedSuppPlanF = 19,
    MedSuppPlanG = 20,
    MedSuppPlanHDF = 21,
    MedSuppPlanHDG = 22,
    MedSuppPlanK = 23,
    MedSuppPlanL = 24,
    MedSuppPlanM = 25,
    MedSuppPlanN = 26,
    MetalGap = 27,
    PDP = 28,
    ShortTermMedical = 29,
    SimplifiedIssueTerm = 30,
    Vision = 31,
    DSNP = 32,
    MedicareCore = 33,
    MedicareSupplement = 34,
    AssociationPackage = 35,
    Cancer = 36,
    CancerHeartCombo = 37,
    Heart = 38,
    IndemnityPlan = 39,
    Life = 40,
    Term = 41,
    Generic = 43,
    OSBDental = 47,
    OSBVision = 48,
    OSBFitness = 49,
    OSBCombo = 50,
    MAChronicConditionSpecialNeedsPlan = 51,
    Error = -1,
}

export class EnsProductCategoryResponse implements IEnsProductCategoryResponse {
    ens_product_category_tid!: EnsProductCategoryTid;
    product_category_name!: string;

    constructor(data?: IEnsProductCategoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_product_category_tid = _data["ens_product_category_tid"];
            this.product_category_name = _data["product_category_name"];
        }
    }

    static fromJS(data: any): EnsProductCategoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnsProductCategoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_product_category_tid"] = this.ens_product_category_tid;
        data["product_category_name"] = this.product_category_name;
        return data; 
    }
}

export interface IEnsProductCategoryResponse {
    ens_product_category_tid: EnsProductCategoryTid;
    product_category_name: string;
}

export enum EnsProductCategoryTid {
    None = 0,
    LifeInsurance = 2,
    MedicalPlan = 3,
    MedicareAdvantage = 4,
    MedicarePDP = 5,
    MedSupp = 6,
    Other = 7,
    VisionDentalHearing = 8,
    MedicareMedicaid = 9,
    MedicareCore = 10,
    DownstreamMA = 11,
    DownstreamPDP = 12,
    OptionalSupplementalBenefit = 13,
    Error = -1,
}

export class EnsProductCarrierResponse implements IEnsProductCarrierResponse {
    ens_product_carrier_tid!: EnsProductCarrierTid;
    product_carrier_name!: string;

    constructor(data?: IEnsProductCarrierResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_product_carrier_tid = _data["ens_product_carrier_tid"];
            this.product_carrier_name = _data["product_carrier_name"];
        }
    }

    static fromJS(data: any): EnsProductCarrierResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnsProductCarrierResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_product_carrier_tid"] = this.ens_product_carrier_tid;
        data["product_carrier_name"] = this.product_carrier_name;
        return data; 
    }
}

export interface IEnsProductCarrierResponse {
    ens_product_carrier_tid: EnsProductCarrierTid;
    product_carrier_name: string;
}

export enum EnsProductCarrierTid {
    None = 0,
    GenericNotSpecified = 1,
    AAA = 2,
    Aetna = 3,
    Ameritas = 4,
    CatholicLife = 5,
    Cigna = 6,
    Humana = 7,
    LibertyBankers = 8,
    MutualOfOmaha = 9,
    NationalHealthInsuranceCompanyNHIC = 10,
    Renaissance = 11,
    Sentinel = 12,
    SilverScript = 13,
    Thrivent = 14,
    IHC = 15,
    Sagicor = 16,
    Securian = 17,
    HP1 = 18,
    Surebridge = 19,
    ANICOOfNY = 20,
    ANICO = 21,
    HarvardPilgrim = 24,
    Gerber = 25,
    Anthem = 26,
    CDPHP = 28,
    AIG = 29,
    UnitedHealthcare = 30,
    WellCare = 31,
    SunFire = 32,
    PanAmerican = 33,
    AgentE = 34,
    PeoplesHealth = 35,
    ChoicePolicy = 36,
    AARP = 37,
    Accendo = 39,
    ContinentalLife = 40,
    BlueCrossBlueShield = 41,
    Aflac = 42,
    Unknown = -1,
}

export class EnsProductCarrierChildInfoTypeResponse implements IEnsProductCarrierChildInfoTypeResponse {
    ens_product_carrier_child_info_type_tid!: number;
    name!: string;

    constructor(data?: IEnsProductCarrierChildInfoTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_product_carrier_child_info_type_tid = _data["ens_product_carrier_child_info_type_tid"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): EnsProductCarrierChildInfoTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnsProductCarrierChildInfoTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_product_carrier_child_info_type_tid"] = this.ens_product_carrier_child_info_type_tid;
        data["name"] = this.name;
        return data; 
    }
}

export interface IEnsProductCarrierChildInfoTypeResponse {
    ens_product_carrier_child_info_type_tid: number;
    name: string;
}

export class EnsProductCarrierChildResponse implements IEnsProductCarrierChildResponse {
    ens_product_carrier_child_tid!: number;
    ens_product_carrier_tid!: EnsProductCarrierTid;
    company_name!: string;
    cocode!: string;
    rts_report_fl!: boolean;
    preappointment_states!: string[];
    product_categories!: EnsProductCategoryTid[];
    company_info!: ProductCarrierChildInfo[];

    constructor(data?: IEnsProductCarrierChildResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.preappointment_states = [];
            this.product_categories = [];
            this.company_info = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_product_carrier_child_tid = _data["ens_product_carrier_child_tid"];
            this.ens_product_carrier_tid = _data["ens_product_carrier_tid"];
            this.company_name = _data["company_name"];
            this.cocode = _data["cocode"];
            this.rts_report_fl = _data["rts_report_fl"];
            if (Array.isArray(_data["preappointment_states"])) {
                this.preappointment_states = [] as any;
                for (let item of _data["preappointment_states"])
                    this.preappointment_states!.push(item);
            }
            if (Array.isArray(_data["product_categories"])) {
                this.product_categories = [] as any;
                for (let item of _data["product_categories"])
                    this.product_categories!.push(item);
            }
            if (Array.isArray(_data["company_info"])) {
                this.company_info = [] as any;
                for (let item of _data["company_info"])
                    this.company_info!.push(ProductCarrierChildInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnsProductCarrierChildResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnsProductCarrierChildResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_product_carrier_child_tid"] = this.ens_product_carrier_child_tid;
        data["ens_product_carrier_tid"] = this.ens_product_carrier_tid;
        data["company_name"] = this.company_name;
        data["cocode"] = this.cocode;
        data["rts_report_fl"] = this.rts_report_fl;
        if (Array.isArray(this.preappointment_states)) {
            data["preappointment_states"] = [];
            for (let item of this.preappointment_states)
                data["preappointment_states"].push(item);
        }
        if (Array.isArray(this.product_categories)) {
            data["product_categories"] = [];
            for (let item of this.product_categories)
                data["product_categories"].push(item);
        }
        if (Array.isArray(this.company_info)) {
            data["company_info"] = [];
            for (let item of this.company_info)
                data["company_info"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IEnsProductCarrierChildResponse {
    ens_product_carrier_child_tid: number;
    ens_product_carrier_tid: EnsProductCarrierTid;
    company_name: string;
    cocode: string;
    rts_report_fl: boolean;
    preappointment_states: string[];
    product_categories: EnsProductCategoryTid[];
    company_info: ProductCarrierChildInfo[];
}

export class ProductCarrierChildInfo implements IProductCarrierChildInfo {
    ens_product_carrier_child_info_type_tid!: number;
    key!: string;
    value!: string;

    constructor(data?: IProductCarrierChildInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_product_carrier_child_info_type_tid = _data["ens_product_carrier_child_info_type_tid"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ProductCarrierChildInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCarrierChildInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_product_carrier_child_info_type_tid"] = this.ens_product_carrier_child_info_type_tid;
        data["key"] = this.key;
        data["value"] = this.value;
        return data; 
    }
}

export interface IProductCarrierChildInfo {
    ens_product_carrier_child_info_type_tid: number;
    key: string;
    value: string;
}

export class AddEnsProductCarrierChildRequest implements IAddEnsProductCarrierChildRequest {
    ens_product_carrier_tid!: EnsProductCarrierTid;
    company_name!: string;
    cocode!: string;
    rts_report_fl!: boolean;

    constructor(data?: IAddEnsProductCarrierChildRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_product_carrier_tid = _data["ens_product_carrier_tid"];
            this.company_name = _data["company_name"];
            this.cocode = _data["cocode"];
            this.rts_report_fl = _data["rts_report_fl"];
        }
    }

    static fromJS(data: any): AddEnsProductCarrierChildRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddEnsProductCarrierChildRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_product_carrier_tid"] = this.ens_product_carrier_tid;
        data["company_name"] = this.company_name;
        data["cocode"] = this.cocode;
        data["rts_report_fl"] = this.rts_report_fl;
        return data; 
    }
}

export interface IAddEnsProductCarrierChildRequest {
    ens_product_carrier_tid: EnsProductCarrierTid;
    company_name: string;
    cocode: string;
    rts_report_fl: boolean;
}

export class UpdateEnsProductCarrierChildRequest implements IUpdateEnsProductCarrierChildRequest {
    ens_product_carrier_child_tid!: number;
    ens_product_carrier_tid?: EnsProductCarrierTid | undefined;
    company_name?: string | undefined;
    cocode?: string | undefined;
    rts_report_fl?: boolean | undefined;
    preappointment_states?: string[] | undefined;
    product_categories?: EnsProductCategoryTid[] | undefined;
    company_info?: ProductCarrierChildInfo[] | undefined;

    constructor(data?: IUpdateEnsProductCarrierChildRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_product_carrier_child_tid = _data["ens_product_carrier_child_tid"];
            this.ens_product_carrier_tid = _data["ens_product_carrier_tid"];
            this.company_name = _data["company_name"];
            this.cocode = _data["cocode"];
            this.rts_report_fl = _data["rts_report_fl"];
            if (Array.isArray(_data["preappointment_states"])) {
                this.preappointment_states = [] as any;
                for (let item of _data["preappointment_states"])
                    this.preappointment_states!.push(item);
            }
            if (Array.isArray(_data["product_categories"])) {
                this.product_categories = [] as any;
                for (let item of _data["product_categories"])
                    this.product_categories!.push(item);
            }
            if (Array.isArray(_data["company_info"])) {
                this.company_info = [] as any;
                for (let item of _data["company_info"])
                    this.company_info!.push(ProductCarrierChildInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateEnsProductCarrierChildRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEnsProductCarrierChildRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_product_carrier_child_tid"] = this.ens_product_carrier_child_tid;
        data["ens_product_carrier_tid"] = this.ens_product_carrier_tid;
        data["company_name"] = this.company_name;
        data["cocode"] = this.cocode;
        data["rts_report_fl"] = this.rts_report_fl;
        if (Array.isArray(this.preappointment_states)) {
            data["preappointment_states"] = [];
            for (let item of this.preappointment_states)
                data["preappointment_states"].push(item);
        }
        if (Array.isArray(this.product_categories)) {
            data["product_categories"] = [];
            for (let item of this.product_categories)
                data["product_categories"].push(item);
        }
        if (Array.isArray(this.company_info)) {
            data["company_info"] = [];
            for (let item of this.company_info)
                data["company_info"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateEnsProductCarrierChildRequest {
    ens_product_carrier_child_tid: number;
    ens_product_carrier_tid?: EnsProductCarrierTid | undefined;
    company_name?: string | undefined;
    cocode?: string | undefined;
    rts_report_fl?: boolean | undefined;
    preappointment_states?: string[] | undefined;
    product_categories?: EnsProductCategoryTid[] | undefined;
    company_info?: ProductCarrierChildInfo[] | undefined;
}

export class GetSaleInformationRow implements IGetSaleInformationRow {
    ens_sale_tid?: number;
    ens_marketing_campaign_tid?: number;
    external_campaign_name?: string | undefined;

    constructor(data?: IGetSaleInformationRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_sale_tid = _data["ens_sale_tid"];
            this.ens_marketing_campaign_tid = _data["ens_marketing_campaign_tid"];
            this.external_campaign_name = _data["external_campaign_name"];
        }
    }

    static fromJS(data: any): GetSaleInformationRow {
        data = typeof data === 'object' ? data : {};
        let result = new GetSaleInformationRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_sale_tid"] = this.ens_sale_tid;
        data["ens_marketing_campaign_tid"] = this.ens_marketing_campaign_tid;
        data["external_campaign_name"] = this.external_campaign_name;
        return data; 
    }
}

export interface IGetSaleInformationRow {
    ens_sale_tid?: number;
    ens_marketing_campaign_tid?: number;
    external_campaign_name?: string | undefined;
}

export class UpdateCampaignMappingResult implements IUpdateCampaignMappingResult {
    isSaleValid!: boolean;
    isCampaignValid!: boolean;
    completedSuccessfully!: boolean;

    constructor(data?: IUpdateCampaignMappingResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSaleValid = _data["isSaleValid"];
            this.isCampaignValid = _data["isCampaignValid"];
            this.completedSuccessfully = _data["completedSuccessfully"];
        }
    }

    static fromJS(data: any): UpdateCampaignMappingResult {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCampaignMappingResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSaleValid"] = this.isSaleValid;
        data["isCampaignValid"] = this.isCampaignValid;
        data["completedSuccessfully"] = this.completedSuccessfully;
        return data; 
    }
}

export interface IUpdateCampaignMappingResult {
    isSaleValid: boolean;
    isCampaignValid: boolean;
    completedSuccessfully: boolean;
}

export class MarketingDiagnosticsSearchResponse implements IMarketingDiagnosticsSearchResponse {
    sale_purchaser_contact_id!: number | undefined;
    alternate_contact_id!: number | undefined;
    sale_marketing_actions!: MarketingActionsForSaleRow[];
    contact_marketing_actions!: MarketingActionsForContactRow[];
    diagnostics!: MergeDiagnostics;

    constructor(data?: IMarketingDiagnosticsSearchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sale_marketing_actions = [];
            this.contact_marketing_actions = [];
            this.diagnostics = new MergeDiagnostics();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sale_purchaser_contact_id = _data["sale_purchaser_contact_id"];
            this.alternate_contact_id = _data["alternate_contact_id"];
            if (Array.isArray(_data["sale_marketing_actions"])) {
                this.sale_marketing_actions = [] as any;
                for (let item of _data["sale_marketing_actions"])
                    this.sale_marketing_actions!.push(MarketingActionsForSaleRow.fromJS(item));
            }
            if (Array.isArray(_data["contact_marketing_actions"])) {
                this.contact_marketing_actions = [] as any;
                for (let item of _data["contact_marketing_actions"])
                    this.contact_marketing_actions!.push(MarketingActionsForContactRow.fromJS(item));
            }
            this.diagnostics = _data["diagnostics"] ? MergeDiagnostics.fromJS(_data["diagnostics"]) : new MergeDiagnostics();
        }
    }

    static fromJS(data: any): MarketingDiagnosticsSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingDiagnosticsSearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sale_purchaser_contact_id"] = this.sale_purchaser_contact_id;
        data["alternate_contact_id"] = this.alternate_contact_id;
        if (Array.isArray(this.sale_marketing_actions)) {
            data["sale_marketing_actions"] = [];
            for (let item of this.sale_marketing_actions)
                data["sale_marketing_actions"].push(item.toJSON());
        }
        if (Array.isArray(this.contact_marketing_actions)) {
            data["contact_marketing_actions"] = [];
            for (let item of this.contact_marketing_actions)
                data["contact_marketing_actions"].push(item.toJSON());
        }
        data["diagnostics"] = this.diagnostics ? this.diagnostics.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IMarketingDiagnosticsSearchResponse {
    sale_purchaser_contact_id: number | undefined;
    alternate_contact_id: number | undefined;
    sale_marketing_actions: MarketingActionsForSaleRow[];
    contact_marketing_actions: MarketingActionsForContactRow[];
    diagnostics: MergeDiagnostics;
}

export class MarketingActionBase implements IMarketingActionBase {
    contact_email?: string | undefined;
    contact_phone?: string | undefined;
    marketing_action_name!: string | undefined;
    marketing_action_datetime!: Date | undefined;
    ens_marketing_campaign_tid!: number;
    vendor_name!: string | undefined;
    brand_name!: string | undefined;
    product_name!: string | undefined;
    product_carrier_name!: string | undefined;
    marketing_channel_name!: string | undefined;

    constructor(data?: IMarketingActionBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contact_email = _data["contact_email"];
            this.contact_phone = _data["contact_phone"];
            this.marketing_action_name = _data["marketing_action_name"];
            this.marketing_action_datetime = _data["marketing_action_datetime"] ? new Date(_data["marketing_action_datetime"].toString()) : <any>undefined;
            this.ens_marketing_campaign_tid = _data["ens_marketing_campaign_tid"];
            this.vendor_name = _data["vendor_name"];
            this.brand_name = _data["brand_name"];
            this.product_name = _data["product_name"];
            this.product_carrier_name = _data["product_carrier_name"];
            this.marketing_channel_name = _data["marketing_channel_name"];
        }
    }

    static fromJS(data: any): MarketingActionBase {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingActionBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contact_email"] = this.contact_email;
        data["contact_phone"] = this.contact_phone;
        data["marketing_action_name"] = this.marketing_action_name;
        data["marketing_action_datetime"] = this.marketing_action_datetime ? this.marketing_action_datetime.toISOString() : <any>undefined;
        data["ens_marketing_campaign_tid"] = this.ens_marketing_campaign_tid;
        data["vendor_name"] = this.vendor_name;
        data["brand_name"] = this.brand_name;
        data["product_name"] = this.product_name;
        data["product_carrier_name"] = this.product_carrier_name;
        data["marketing_channel_name"] = this.marketing_channel_name;
        return data; 
    }
}

export interface IMarketingActionBase {
    contact_email?: string | undefined;
    contact_phone?: string | undefined;
    marketing_action_name: string | undefined;
    marketing_action_datetime: Date | undefined;
    ens_marketing_campaign_tid: number;
    vendor_name: string | undefined;
    brand_name: string | undefined;
    product_name: string | undefined;
    product_carrier_name: string | undefined;
    marketing_channel_name: string | undefined;
}

export class MarketingActionsForSaleRow extends MarketingActionBase implements IMarketingActionsForSaleRow {
    ens_sale_tid!: number;
    purchaser_ens_contact_id!: number;
    purchaser_last_ens_contact_marketing_action_tid!: number;
    sale_datetime!: Date;

    constructor(data?: IMarketingActionsForSaleRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ens_sale_tid = _data["ens_sale_tid"];
            this.purchaser_ens_contact_id = _data["purchaser_ens_contact_id"];
            this.purchaser_last_ens_contact_marketing_action_tid = _data["purchaser_last_ens_contact_marketing_action_tid"];
            this.sale_datetime = _data["sale_datetime"] ? new Date(_data["sale_datetime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MarketingActionsForSaleRow {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingActionsForSaleRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_sale_tid"] = this.ens_sale_tid;
        data["purchaser_ens_contact_id"] = this.purchaser_ens_contact_id;
        data["purchaser_last_ens_contact_marketing_action_tid"] = this.purchaser_last_ens_contact_marketing_action_tid;
        data["sale_datetime"] = this.sale_datetime ? this.sale_datetime.toISOString() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IMarketingActionsForSaleRow extends IMarketingActionBase {
    ens_sale_tid: number;
    purchaser_ens_contact_id: number;
    purchaser_last_ens_contact_marketing_action_tid: number;
    sale_datetime: Date;
}

export class MarketingActionsForContactRow extends MarketingActionBase implements IMarketingActionsForContactRow {
    ens_contact_tid!: number;

    constructor(data?: IMarketingActionsForContactRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ens_contact_tid = _data["ens_contact_tid"];
        }
    }

    static fromJS(data: any): MarketingActionsForContactRow {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingActionsForContactRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_contact_tid"] = this.ens_contact_tid;
        super.toJSON(data);
        return data; 
    }
}

export interface IMarketingActionsForContactRow extends IMarketingActionBase {
    ens_contact_tid: number;
}

export class MergeDiagnostics implements IMergeDiagnostics {
    sale_contact_different?: boolean;
    contact_likely_has_paid_actions_before_sale_date?: boolean;

    constructor(data?: IMergeDiagnostics) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sale_contact_different = _data["sale_contact_different"];
            this.contact_likely_has_paid_actions_before_sale_date = _data["contact_likely_has_paid_actions_before_sale_date"];
        }
    }

    static fromJS(data: any): MergeDiagnostics {
        data = typeof data === 'object' ? data : {};
        let result = new MergeDiagnostics();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sale_contact_different"] = this.sale_contact_different;
        data["contact_likely_has_paid_actions_before_sale_date"] = this.contact_likely_has_paid_actions_before_sale_date;
        return data; 
    }
}

export interface IMergeDiagnostics {
    sale_contact_different?: boolean;
    contact_likely_has_paid_actions_before_sale_date?: boolean;
}

export class MarketingDiagnosticsSearchRequest implements IMarketingDiagnosticsSearchRequest {
    sale_tid?: number;
    contact?: ContactSearchOptions | undefined;

    constructor(data?: IMarketingDiagnosticsSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sale_tid = _data["sale_tid"];
            this.contact = _data["contact"] ? ContactSearchOptions.fromJS(_data["contact"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MarketingDiagnosticsSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingDiagnosticsSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sale_tid"] = this.sale_tid;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IMarketingDiagnosticsSearchRequest {
    sale_tid?: number;
    contact?: ContactSearchOptions | undefined;
}

export class ContactSearchOptions implements IContactSearchOptions {
    contact_phone?: string | undefined;
    contact_email?: string | undefined;

    constructor(data?: IContactSearchOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contact_phone = _data["contact_phone"];
            this.contact_email = _data["contact_email"];
        }
    }

    static fromJS(data: any): ContactSearchOptions {
        data = typeof data === 'object' ? data : {};
        let result = new ContactSearchOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contact_phone"] = this.contact_phone;
        data["contact_email"] = this.contact_email;
        return data; 
    }
}

export interface IContactSearchOptions {
    contact_phone?: string | undefined;
    contact_email?: string | undefined;
}

export class CreateCampaignMappingResult implements ICreateCampaignMappingResult {
    isCampaignGroupValid!: boolean;
    isDidAlreadyMappped!: boolean;
    completedSuccessfully!: boolean;
    failureMessage!: string | undefined;

    constructor(data?: ICreateCampaignMappingResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isCampaignGroupValid = _data["isCampaignGroupValid"];
            this.isDidAlreadyMappped = _data["isDidAlreadyMappped"];
            this.completedSuccessfully = _data["completedSuccessfully"];
            this.failureMessage = _data["failureMessage"];
        }
    }

    static fromJS(data: any): CreateCampaignMappingResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCampaignMappingResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCampaignGroupValid"] = this.isCampaignGroupValid;
        data["isDidAlreadyMappped"] = this.isDidAlreadyMappped;
        data["completedSuccessfully"] = this.completedSuccessfully;
        data["failureMessage"] = this.failureMessage;
        return data; 
    }
}

export interface ICreateCampaignMappingResult {
    isCampaignGroupValid: boolean;
    isDidAlreadyMappped: boolean;
    completedSuccessfully: boolean;
    failureMessage: string | undefined;
}

export class CreateCampaignMappingRequest implements ICreateCampaignMappingRequest {
    vendor!: string;
    brand!: string;
    product!: string;
    productCarrier!: string;
    marketingChannel!: string;
    did!: string;
    listName!: string;
    mappingType!: string;
    externalCampaignName?: string | undefined;
    marketingCampaignBudgetType?: EnsMarketingCampaignBudgetType | undefined;
    ensLeadType?: EnsLeadTypeTid;
    ensDtcCampaignType?: EnsDtcCampaignTypeTid;

    constructor(data?: ICreateCampaignMappingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vendor = _data["vendor"];
            this.brand = _data["brand"];
            this.product = _data["product"];
            this.productCarrier = _data["productCarrier"];
            this.marketingChannel = _data["marketingChannel"];
            this.did = _data["did"];
            this.listName = _data["listName"];
            this.mappingType = _data["mappingType"];
            this.externalCampaignName = _data["externalCampaignName"];
            this.marketingCampaignBudgetType = _data["marketingCampaignBudgetType"];
            this.ensLeadType = _data["ensLeadType"];
            this.ensDtcCampaignType = _data["ensDtcCampaignType"];
        }
    }

    static fromJS(data: any): CreateCampaignMappingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCampaignMappingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vendor"] = this.vendor;
        data["brand"] = this.brand;
        data["product"] = this.product;
        data["productCarrier"] = this.productCarrier;
        data["marketingChannel"] = this.marketingChannel;
        data["did"] = this.did;
        data["listName"] = this.listName;
        data["mappingType"] = this.mappingType;
        data["externalCampaignName"] = this.externalCampaignName;
        data["marketingCampaignBudgetType"] = this.marketingCampaignBudgetType;
        data["ensLeadType"] = this.ensLeadType;
        data["ensDtcCampaignType"] = this.ensDtcCampaignType;
        return data; 
    }
}

export interface ICreateCampaignMappingRequest {
    vendor: string;
    brand: string;
    product: string;
    productCarrier: string;
    marketingChannel: string;
    did: string;
    listName: string;
    mappingType: string;
    externalCampaignName?: string | undefined;
    marketingCampaignBudgetType?: EnsMarketingCampaignBudgetType | undefined;
    ensLeadType?: EnsLeadTypeTid;
    ensDtcCampaignType?: EnsDtcCampaignTypeTid;
}

export enum EnsMarketingCampaignBudgetType {
    Standard = 1,
    Test = 2,
}

export enum EnsLeadTypeTid {
    Unknown = 0,
    Alliance = 1,
    Digital = 2,
    Traditional = 3,
    Kiosk = 4,
    Purchased = 5,
    Exclude = 6,
    WelcomeReps = 7,
    Recycled = 8,
    Error = -1,
}

export enum EnsDtcCampaignTypeTid {
    None = 0,
    AgentE = 1,
    Emma = 2,
    FinalExpense = 3,
    CatholicLife = 4,
    Sunfire = 5,
    DentalVision = 7,
    Error = -1,
}

export class GetCampaignMappingOptionsResponse implements IGetCampaignMappingOptionsResponse {
    vendor!: string[];
    brand!: string[];
    product!: string[];
    carrier!: string[];
    marketingChannel!: string[];
    marketingCampaigns!: string[];

    constructor(data?: IGetCampaignMappingOptionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.vendor = [];
            this.brand = [];
            this.product = [];
            this.carrier = [];
            this.marketingChannel = [];
            this.marketingCampaigns = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["vendor"])) {
                this.vendor = [] as any;
                for (let item of _data["vendor"])
                    this.vendor!.push(item);
            }
            if (Array.isArray(_data["brand"])) {
                this.brand = [] as any;
                for (let item of _data["brand"])
                    this.brand!.push(item);
            }
            if (Array.isArray(_data["product"])) {
                this.product = [] as any;
                for (let item of _data["product"])
                    this.product!.push(item);
            }
            if (Array.isArray(_data["carrier"])) {
                this.carrier = [] as any;
                for (let item of _data["carrier"])
                    this.carrier!.push(item);
            }
            if (Array.isArray(_data["marketingChannel"])) {
                this.marketingChannel = [] as any;
                for (let item of _data["marketingChannel"])
                    this.marketingChannel!.push(item);
            }
            if (Array.isArray(_data["marketingCampaigns"])) {
                this.marketingCampaigns = [] as any;
                for (let item of _data["marketingCampaigns"])
                    this.marketingCampaigns!.push(item);
            }
        }
    }

    static fromJS(data: any): GetCampaignMappingOptionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCampaignMappingOptionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vendor)) {
            data["vendor"] = [];
            for (let item of this.vendor)
                data["vendor"].push(item);
        }
        if (Array.isArray(this.brand)) {
            data["brand"] = [];
            for (let item of this.brand)
                data["brand"].push(item);
        }
        if (Array.isArray(this.product)) {
            data["product"] = [];
            for (let item of this.product)
                data["product"].push(item);
        }
        if (Array.isArray(this.carrier)) {
            data["carrier"] = [];
            for (let item of this.carrier)
                data["carrier"].push(item);
        }
        if (Array.isArray(this.marketingChannel)) {
            data["marketingChannel"] = [];
            for (let item of this.marketingChannel)
                data["marketingChannel"].push(item);
        }
        if (Array.isArray(this.marketingCampaigns)) {
            data["marketingCampaigns"] = [];
            for (let item of this.marketingCampaigns)
                data["marketingCampaigns"].push(item);
        }
        return data; 
    }
}

export interface IGetCampaignMappingOptionsResponse {
    vendor: string[];
    brand: string[];
    product: string[];
    carrier: string[];
    marketingChannel: string[];
    marketingCampaigns: string[];
}

export class MarketingCampaign implements IMarketingCampaign {
    ens_marketing_campaign_tid?: number;
    sql_created_by?: string | undefined;
    external_campaign_name?: string | undefined;
    external_campaign_id?: string | undefined;
    ens_marketing_campaign_active_fl?: boolean | undefined;
    ens_campaign_group_tid?: number;
    ens_vendor_tid?: number;
    vendor_name?: string | undefined;
    vendor_abbreviation?: string | undefined;
    ens_lead_type_tid?: number;
    lead_type_name?: string | undefined;
    ens_brand_tid?: number;
    brand_name?: string | undefined;
    brand_abbreviation?: string | undefined;
    ens_product_tid?: number;
    product_name?: string | undefined;
    product_abbreviation?: string | undefined;
    ens_product_carrier_tid?: number;
    product_carrier_name?: string | undefined;
    product_carrier_abbreviation?: string | undefined;
    ens_marketing_channel_tid?: number;
    marketing_channel_name?: string | undefined;
    marketing_channel_abbreviation?: string | undefined;
    ens_dtc_campaign_type_tid?: number;
    dtc_campaign_type_name?: string | undefined;

    constructor(data?: IMarketingCampaign) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_marketing_campaign_tid = _data["ens_marketing_campaign_tid"];
            this.sql_created_by = _data["sql_created_by"];
            this.external_campaign_name = _data["external_campaign_name"];
            this.external_campaign_id = _data["external_campaign_id"];
            this.ens_marketing_campaign_active_fl = _data["ens_marketing_campaign_active_fl"];
            this.ens_campaign_group_tid = _data["ens_campaign_group_tid"];
            this.ens_vendor_tid = _data["ens_vendor_tid"];
            this.vendor_name = _data["vendor_name"];
            this.vendor_abbreviation = _data["vendor_abbreviation"];
            this.ens_lead_type_tid = _data["ens_lead_type_tid"];
            this.lead_type_name = _data["lead_type_name"];
            this.ens_brand_tid = _data["ens_brand_tid"];
            this.brand_name = _data["brand_name"];
            this.brand_abbreviation = _data["brand_abbreviation"];
            this.ens_product_tid = _data["ens_product_tid"];
            this.product_name = _data["product_name"];
            this.product_abbreviation = _data["product_abbreviation"];
            this.ens_product_carrier_tid = _data["ens_product_carrier_tid"];
            this.product_carrier_name = _data["product_carrier_name"];
            this.product_carrier_abbreviation = _data["product_carrier_abbreviation"];
            this.ens_marketing_channel_tid = _data["ens_marketing_channel_tid"];
            this.marketing_channel_name = _data["marketing_channel_name"];
            this.marketing_channel_abbreviation = _data["marketing_channel_abbreviation"];
            this.ens_dtc_campaign_type_tid = _data["ens_dtc_campaign_type_tid"];
            this.dtc_campaign_type_name = _data["dtc_campaign_type_name"];
        }
    }

    static fromJS(data: any): MarketingCampaign {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingCampaign();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_marketing_campaign_tid"] = this.ens_marketing_campaign_tid;
        data["sql_created_by"] = this.sql_created_by;
        data["external_campaign_name"] = this.external_campaign_name;
        data["external_campaign_id"] = this.external_campaign_id;
        data["ens_marketing_campaign_active_fl"] = this.ens_marketing_campaign_active_fl;
        data["ens_campaign_group_tid"] = this.ens_campaign_group_tid;
        data["ens_vendor_tid"] = this.ens_vendor_tid;
        data["vendor_name"] = this.vendor_name;
        data["vendor_abbreviation"] = this.vendor_abbreviation;
        data["ens_lead_type_tid"] = this.ens_lead_type_tid;
        data["lead_type_name"] = this.lead_type_name;
        data["ens_brand_tid"] = this.ens_brand_tid;
        data["brand_name"] = this.brand_name;
        data["brand_abbreviation"] = this.brand_abbreviation;
        data["ens_product_tid"] = this.ens_product_tid;
        data["product_name"] = this.product_name;
        data["product_abbreviation"] = this.product_abbreviation;
        data["ens_product_carrier_tid"] = this.ens_product_carrier_tid;
        data["product_carrier_name"] = this.product_carrier_name;
        data["product_carrier_abbreviation"] = this.product_carrier_abbreviation;
        data["ens_marketing_channel_tid"] = this.ens_marketing_channel_tid;
        data["marketing_channel_name"] = this.marketing_channel_name;
        data["marketing_channel_abbreviation"] = this.marketing_channel_abbreviation;
        data["ens_dtc_campaign_type_tid"] = this.ens_dtc_campaign_type_tid;
        data["dtc_campaign_type_name"] = this.dtc_campaign_type_name;
        return data; 
    }
}

export interface IMarketingCampaign {
    ens_marketing_campaign_tid?: number;
    sql_created_by?: string | undefined;
    external_campaign_name?: string | undefined;
    external_campaign_id?: string | undefined;
    ens_marketing_campaign_active_fl?: boolean | undefined;
    ens_campaign_group_tid?: number;
    ens_vendor_tid?: number;
    vendor_name?: string | undefined;
    vendor_abbreviation?: string | undefined;
    ens_lead_type_tid?: number;
    lead_type_name?: string | undefined;
    ens_brand_tid?: number;
    brand_name?: string | undefined;
    brand_abbreviation?: string | undefined;
    ens_product_tid?: number;
    product_name?: string | undefined;
    product_abbreviation?: string | undefined;
    ens_product_carrier_tid?: number;
    product_carrier_name?: string | undefined;
    product_carrier_abbreviation?: string | undefined;
    ens_marketing_channel_tid?: number;
    marketing_channel_name?: string | undefined;
    marketing_channel_abbreviation?: string | undefined;
    ens_dtc_campaign_type_tid?: number;
    dtc_campaign_type_name?: string | undefined;
}

export class CampaignFilteredGetRequest implements ICampaignFilteredGetRequest {
    ens_marketing_campaign_tid?: number | undefined;
    external_campaign_id?: string | undefined;
    external_campaign_name?: string | undefined;
    ens_vendor_tid?: number | undefined;
    ens_brand_tid?: number | undefined;
    ens_product_tid?: number | undefined;
    ens_product_carrier_tid?: number | undefined;
    ens_marketing_channel_tid?: number | undefined;
    ens_lead_type_tid?: number | undefined;
    active_fl?: boolean | undefined;
    ens_dtc_campaign_type_tid?: number | undefined;

    constructor(data?: ICampaignFilteredGetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_marketing_campaign_tid = _data["ens_marketing_campaign_tid"];
            this.external_campaign_id = _data["external_campaign_id"];
            this.external_campaign_name = _data["external_campaign_name"];
            this.ens_vendor_tid = _data["ens_vendor_tid"];
            this.ens_brand_tid = _data["ens_brand_tid"];
            this.ens_product_tid = _data["ens_product_tid"];
            this.ens_product_carrier_tid = _data["ens_product_carrier_tid"];
            this.ens_marketing_channel_tid = _data["ens_marketing_channel_tid"];
            this.ens_lead_type_tid = _data["ens_lead_type_tid"];
            this.active_fl = _data["active_fl"];
            this.ens_dtc_campaign_type_tid = _data["ens_dtc_campaign_type_tid"];
        }
    }

    static fromJS(data: any): CampaignFilteredGetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignFilteredGetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_marketing_campaign_tid"] = this.ens_marketing_campaign_tid;
        data["external_campaign_id"] = this.external_campaign_id;
        data["external_campaign_name"] = this.external_campaign_name;
        data["ens_vendor_tid"] = this.ens_vendor_tid;
        data["ens_brand_tid"] = this.ens_brand_tid;
        data["ens_product_tid"] = this.ens_product_tid;
        data["ens_product_carrier_tid"] = this.ens_product_carrier_tid;
        data["ens_marketing_channel_tid"] = this.ens_marketing_channel_tid;
        data["ens_lead_type_tid"] = this.ens_lead_type_tid;
        data["active_fl"] = this.active_fl;
        data["ens_dtc_campaign_type_tid"] = this.ens_dtc_campaign_type_tid;
        return data; 
    }
}

export interface ICampaignFilteredGetRequest {
    ens_marketing_campaign_tid?: number | undefined;
    external_campaign_id?: string | undefined;
    external_campaign_name?: string | undefined;
    ens_vendor_tid?: number | undefined;
    ens_brand_tid?: number | undefined;
    ens_product_tid?: number | undefined;
    ens_product_carrier_tid?: number | undefined;
    ens_marketing_channel_tid?: number | undefined;
    ens_lead_type_tid?: number | undefined;
    active_fl?: boolean | undefined;
    ens_dtc_campaign_type_tid?: number | undefined;
}

export class EnsVendorResponse implements IEnsVendorResponse {
    ens_vendor_tid!: EnsVendorTid;
    vendor_name!: string;

    constructor(data?: IEnsVendorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_vendor_tid = _data["ens_vendor_tid"];
            this.vendor_name = _data["vendor_name"];
        }
    }

    static fromJS(data: any): EnsVendorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnsVendorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_vendor_tid"] = this.ens_vendor_tid;
        data["vendor_name"] = this.vendor_name;
        return data; 
    }
}

export interface IEnsVendorResponse {
    ens_vendor_tid: EnsVendorTid;
    vendor_name: string;
}

export enum EnsVendorTid {
    NONE = 0,
    ENS = 1,
    GA = 2,
    BI = 3,
    FB = 4,
    BP = 5,
    DL = 6,
    EH = 7,
    GH = 8,
    HO = 9,
    IR = 10,
    IV = 11,
    PK = 12,
    CL = 13,
    BAR = 14,
    AAA = 15,
    NEP = 16,
    LC = 17,
    EQ = 18,
    WAL = 19,
    CVS = 20,
    PUR = 21,
    CAT = 22,
    PCH = 23,
    AET = 24,
    TS = 25,
    USD = 26,
    PIC = 27,
    CRE = 28,
    BHU = 29,
    PHS = 30,
    COV = 31,
    DW = 32,
    DMS = 33,
    OT = 34,
    HR = 36,
    HC = 37,
    CR = 38,
    JOTO = 39,
    TBT = 40,
    MPC = 41,
    QV = 42,
    SF = 43,
    MER = 44,
    CM = 45,
    MH = 46,
    BC = 47,
    PRO = 48,
    EM = 49,
    AMT = 51,
    AARP = 52,
    PALO = 53,
    MHA = 55,
    ASM = 56,
    SEN = 57,
    AFV = 58,
    CLT = 59,
    FT = 60,
    CAN = 61,
    EU = -1,
}

export class EnsBrandResponse implements IEnsBrandResponse {
    ens_brand_tid!: EnsBrandTid;
    brand_name!: string;

    constructor(data?: IEnsBrandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_brand_tid = _data["ens_brand_tid"];
            this.brand_name = _data["brand_name"];
        }
    }

    static fromJS(data: any): EnsBrandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnsBrandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_brand_tid"] = this.ens_brand_tid;
        data["brand_name"] = this.brand_name;
        return data; 
    }
}

export interface IEnsBrandResponse {
    ens_brand_tid: EnsBrandTid;
    brand_name: string;
}

export enum EnsBrandTid {
    NONE = 0,
    GEN = 1,
    ENS = 2,
    MAP = 3,
    BMT = 4,
    AAA = 5,
    CAT = 6,
    BMS = 7,
    TMA = 8,
    MMA = 9,
    WAL = 10,
    CVS = 11,
    MSK = 13,
    PCH = 14,
    AG = 15,
    HR = 17,
    AMS = 18,
    MGS = 19,
    AMC = 20,
    MER = 21,
    ASME = 22,
    MHS = 23,
    AARP = 24,
    NCRA = 25,
    ACM = 26,
    NAT = 27,
    SEN = 29,
    AGF = 30,
    RTJ = 31,
    MHA = 32,
    IPR = 33,
    EU = -1,
}

export class EnsChannelResponse implements IEnsChannelResponse {
    ens_marketing_channel_tid!: EnsMarketingChannelTid;
    marketing_channel_name!: string;

    constructor(data?: IEnsChannelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_marketing_channel_tid = _data["ens_marketing_channel_tid"];
            this.marketing_channel_name = _data["marketing_channel_name"];
        }
    }

    static fromJS(data: any): EnsChannelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnsChannelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_marketing_channel_tid"] = this.ens_marketing_channel_tid;
        data["marketing_channel_name"] = this.marketing_channel_name;
        return data; 
    }
}

export interface IEnsChannelResponse {
    ens_marketing_channel_tid: EnsMarketingChannelTid;
    marketing_channel_name: string;
}

export enum EnsMarketingChannelTid {
    NONE = 0,
    UN = 1,
    SE = 2,
    DP = 3,
    DR = 4,
    SP = 5,
    SR = 6,
    WT = 7,
    DT = 8,
    CF = 9,
    RT = 10,
    LI = 11,
    TV = 12,
    RA = 13,
    PC = 14,
    FL = 15,
    KI = 16,
    BD = 17,
    MA = 18,
    EM = 19,
    OR = 20,
    SMS = 21,
    SM = 22,
    INT = 23,
    DWN = 24,
    DC = 25,
    TST = 26,
    CB = 27,
    CSE = 28,
    TTY = 29,
    REG = 30,
    CA = 31,
    PF = 32,
    MHS = 33,
    SH = 34,
    VI = 36,
    MC = 37,
    EXP = 38,
    PL = 39,
    REF = 40,
    SESP = 41,
    DN = 42,
    PR = 44,
    PA = 45,
    AFF = 46,
    INF = 47,
    EU = -1,
}

export class EnsLeadTypeResponse implements IEnsLeadTypeResponse {
    ens_lead_type_tid!: EnsLeadTypeTid;
    lead_type_name!: string;

    constructor(data?: IEnsLeadTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_lead_type_tid = _data["ens_lead_type_tid"];
            this.lead_type_name = _data["lead_type_name"];
        }
    }

    static fromJS(data: any): EnsLeadTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnsLeadTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_lead_type_tid"] = this.ens_lead_type_tid;
        data["lead_type_name"] = this.lead_type_name;
        return data; 
    }
}

export interface IEnsLeadTypeResponse {
    ens_lead_type_tid: EnsLeadTypeTid;
    lead_type_name: string;
}

export class PreSignedUrlResponse implements IPreSignedUrlResponse {
    presignedUrl!: string;
    objectKey!: string;

    constructor(data?: IPreSignedUrlResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.presignedUrl = _data["presignedUrl"];
            this.objectKey = _data["objectKey"];
        }
    }

    static fromJS(data: any): PreSignedUrlResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PreSignedUrlResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["presignedUrl"] = this.presignedUrl;
        data["objectKey"] = this.objectKey;
        return data; 
    }
}

export interface IPreSignedUrlResponse {
    presignedUrl: string;
    objectKey: string;
}

export class RolesPermissionsResponse implements IRolesPermissionsResponse {
    roles!: UserRole[];
    permissions!: UserPermission[];

    constructor(data?: IRolesPermissionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.roles = [];
            this.permissions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserRole.fromJS(item));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(UserPermission.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RolesPermissionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RolesPermissionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IRolesPermissionsResponse {
    roles: UserRole[];
    permissions: UserPermission[];
}

export class GetUserSimpleResponse extends RolesPermissionsResponse implements IGetUserSimpleResponse {
    ens_user_tid!: number;
    user_name!: string;
    user_first_name!: string;
    user_last_name!: string;
    user_email!: string;
    npn!: string | undefined;
    address_line1!: string | undefined;
    address_line2!: string | undefined;
    city!: string | undefined;
    state!: string | undefined;
    zip!: string | undefined;
    phone!: string | undefined;
    ssn_lastfour!: string | undefined;
    active_fl!: boolean;

    constructor(data?: IGetUserSimpleResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ens_user_tid = _data["ens_user_tid"];
            this.user_name = _data["user_name"];
            this.user_first_name = _data["user_first_name"];
            this.user_last_name = _data["user_last_name"];
            this.user_email = _data["user_email"];
            this.npn = _data["npn"];
            this.address_line1 = _data["address_line1"];
            this.address_line2 = _data["address_line2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.phone = _data["phone"];
            this.ssn_lastfour = _data["ssn_lastfour"];
            this.active_fl = _data["active_fl"];
        }
    }

    static fromJS(data: any): GetUserSimpleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserSimpleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_user_tid"] = this.ens_user_tid;
        data["user_name"] = this.user_name;
        data["user_first_name"] = this.user_first_name;
        data["user_last_name"] = this.user_last_name;
        data["user_email"] = this.user_email;
        data["npn"] = this.npn;
        data["address_line1"] = this.address_line1;
        data["address_line2"] = this.address_line2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["phone"] = this.phone;
        data["ssn_lastfour"] = this.ssn_lastfour;
        data["active_fl"] = this.active_fl;
        super.toJSON(data);
        return data; 
    }
}

export interface IGetUserSimpleResponse extends IRolesPermissionsResponse {
    ens_user_tid: number;
    user_name: string;
    user_first_name: string;
    user_last_name: string;
    user_email: string;
    npn: string | undefined;
    address_line1: string | undefined;
    address_line2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zip: string | undefined;
    phone: string | undefined;
    ssn_lastfour: string | undefined;
    active_fl: boolean;
}

export class UserRole implements IUserRole {
    role_id?: number;
    role_type_id?: number;
    role_description?: string | undefined;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role_id = _data["role_id"];
            this.role_type_id = _data["role_type_id"];
            this.role_description = _data["role_description"];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role_id"] = this.role_id;
        data["role_type_id"] = this.role_type_id;
        data["role_description"] = this.role_description;
        return data; 
    }
}

export interface IUserRole {
    role_id?: number;
    role_type_id?: number;
    role_description?: string | undefined;
}

export class UserPermission implements IUserPermission {
    permission_id?: number;
    permission_name?: string | undefined;

    constructor(data?: IUserPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.permission_id = _data["permission_id"];
            this.permission_name = _data["permission_name"];
        }
    }

    static fromJS(data: any): UserPermission {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["permission_id"] = this.permission_id;
        data["permission_name"] = this.permission_name;
        return data; 
    }
}

export interface IUserPermission {
    permission_id?: number;
    permission_name?: string | undefined;
}

export class EnsUser implements IEnsUser {
    ens_user_tid!: number;
    user_name?: string | undefined;
    user_first_name?: string | undefined;
    user_last_name?: string | undefined;
    user_email?: string | undefined;
    active_fl?: boolean | undefined;
    ssn?: string | undefined;
    ssn_lastfour?: string | undefined;
    dob?: Date | undefined;
    address_line1?: string | undefined;
    address_line2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    personal_email?: string | undefined;
    phone?: string | undefined;
    phone_extension?: string | undefined;
    hire_date?: Date | undefined;
    termination_date?: Date | undefined;
    npn?: string | undefined;

    constructor(data?: IEnsUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_user_tid = _data["ens_user_tid"];
            this.user_name = _data["user_name"];
            this.user_first_name = _data["user_first_name"];
            this.user_last_name = _data["user_last_name"];
            this.user_email = _data["user_email"];
            this.active_fl = _data["active_fl"];
            this.ssn = _data["ssn"];
            this.ssn_lastfour = _data["ssn_lastfour"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
            this.address_line1 = _data["address_line1"];
            this.address_line2 = _data["address_line2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.personal_email = _data["personal_email"];
            this.phone = _data["phone"];
            this.phone_extension = _data["phone_extension"];
            this.hire_date = _data["hire_date"] ? new Date(_data["hire_date"].toString()) : <any>undefined;
            this.termination_date = _data["termination_date"] ? new Date(_data["termination_date"].toString()) : <any>undefined;
            this.npn = _data["npn"];
        }
    }

    static fromJS(data: any): EnsUser {
        data = typeof data === 'object' ? data : {};
        let result = new EnsUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_user_tid"] = this.ens_user_tid;
        data["user_name"] = this.user_name;
        data["user_first_name"] = this.user_first_name;
        data["user_last_name"] = this.user_last_name;
        data["user_email"] = this.user_email;
        data["active_fl"] = this.active_fl;
        data["ssn"] = this.ssn;
        data["ssn_lastfour"] = this.ssn_lastfour;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["address_line1"] = this.address_line1;
        data["address_line2"] = this.address_line2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["personal_email"] = this.personal_email;
        data["phone"] = this.phone;
        data["phone_extension"] = this.phone_extension;
        data["hire_date"] = this.hire_date ? this.hire_date.toISOString() : <any>undefined;
        data["termination_date"] = this.termination_date ? this.termination_date.toISOString() : <any>undefined;
        data["npn"] = this.npn;
        return data; 
    }
}

export interface IEnsUser {
    ens_user_tid: number;
    user_name?: string | undefined;
    user_first_name?: string | undefined;
    user_last_name?: string | undefined;
    user_email?: string | undefined;
    active_fl?: boolean | undefined;
    ssn?: string | undefined;
    ssn_lastfour?: string | undefined;
    dob?: Date | undefined;
    address_line1?: string | undefined;
    address_line2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    personal_email?: string | undefined;
    phone?: string | undefined;
    phone_extension?: string | undefined;
    hire_date?: Date | undefined;
    termination_date?: Date | undefined;
    npn?: string | undefined;
}

export enum FindUserRequestType {
    EnsUserTid = 0,
    Npn = 1,
    Email = 2,
}

export class License implements ILicense {
    ens_user_tid!: number;
    ens_user_license_tid!: number;
    state!: string;
    expiration_date?: Date | undefined;
    issued_date?: Date | undefined;
    license_number!: string;
    license_class_code!: number;
    license_loa!: LicenseLoa[];

    constructor(data?: ILicense) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.license_loa = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_user_tid = _data["ens_user_tid"];
            this.ens_user_license_tid = _data["ens_user_license_tid"];
            this.state = _data["state"];
            this.expiration_date = _data["expiration_date"] ? new Date(_data["expiration_date"].toString()) : <any>undefined;
            this.issued_date = _data["issued_date"] ? new Date(_data["issued_date"].toString()) : <any>undefined;
            this.license_number = _data["license_number"];
            this.license_class_code = _data["license_class_code"];
            if (Array.isArray(_data["license_loa"])) {
                this.license_loa = [] as any;
                for (let item of _data["license_loa"])
                    this.license_loa!.push(LicenseLoa.fromJS(item));
            }
        }
    }

    static fromJS(data: any): License {
        data = typeof data === 'object' ? data : {};
        let result = new License();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_user_tid"] = this.ens_user_tid;
        data["ens_user_license_tid"] = this.ens_user_license_tid;
        data["state"] = this.state;
        data["expiration_date"] = this.expiration_date ? this.expiration_date.toISOString() : <any>undefined;
        data["issued_date"] = this.issued_date ? this.issued_date.toISOString() : <any>undefined;
        data["license_number"] = this.license_number;
        data["license_class_code"] = this.license_class_code;
        if (Array.isArray(this.license_loa)) {
            data["license_loa"] = [];
            for (let item of this.license_loa)
                data["license_loa"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ILicense {
    ens_user_tid: number;
    ens_user_license_tid: number;
    state: string;
    expiration_date?: Date | undefined;
    issued_date?: Date | undefined;
    license_number: string;
    license_class_code: number;
    license_loa: LicenseLoa[];
}

export class LicenseLoa implements ILicenseLoa {
    nipr_report_pdb_producer_license_loa_tid!: number;
    loa_issue_date?: Date | undefined;
    loa_name?: string | undefined;
    loa_types!: string[];
    loa_status?: string | undefined;
    loa_status_reason?: string | undefined;
    loa_status_reason_date?: Date | undefined;

    constructor(data?: ILicenseLoa) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.loa_types = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nipr_report_pdb_producer_license_loa_tid = _data["nipr_report_pdb_producer_license_loa_tid"];
            this.loa_issue_date = _data["loa_issue_date"] ? new Date(_data["loa_issue_date"].toString()) : <any>undefined;
            this.loa_name = _data["loa_name"];
            if (Array.isArray(_data["loa_types"])) {
                this.loa_types = [] as any;
                for (let item of _data["loa_types"])
                    this.loa_types!.push(item);
            }
            this.loa_status = _data["loa_status"];
            this.loa_status_reason = _data["loa_status_reason"];
            this.loa_status_reason_date = _data["loa_status_reason_date"] ? new Date(_data["loa_status_reason_date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LicenseLoa {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseLoa();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nipr_report_pdb_producer_license_loa_tid"] = this.nipr_report_pdb_producer_license_loa_tid;
        data["loa_issue_date"] = this.loa_issue_date ? this.loa_issue_date.toISOString() : <any>undefined;
        data["loa_name"] = this.loa_name;
        if (Array.isArray(this.loa_types)) {
            data["loa_types"] = [];
            for (let item of this.loa_types)
                data["loa_types"].push(item);
        }
        data["loa_status"] = this.loa_status;
        data["loa_status_reason"] = this.loa_status_reason;
        data["loa_status_reason_date"] = this.loa_status_reason_date ? this.loa_status_reason_date.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ILicenseLoa {
    nipr_report_pdb_producer_license_loa_tid: number;
    loa_issue_date?: Date | undefined;
    loa_name?: string | undefined;
    loa_types: string[];
    loa_status?: string | undefined;
    loa_status_reason?: string | undefined;
    loa_status_reason_date?: Date | undefined;
}

export class Appointment implements IAppointment {
    state!: TwoLetterState;
    appointment_date!: Date | undefined;
    expiration_date!: Date | undefined;
    broker_id!: BrokerId;
    appointment_status!: AppointmentStatus;

    constructor(data?: IAppointment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.broker_id = new BrokerId();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.appointment_date = _data["appointment_date"] ? new Date(_data["appointment_date"].toString()) : <any>undefined;
            this.expiration_date = _data["expiration_date"] ? new Date(_data["expiration_date"].toString()) : <any>undefined;
            this.broker_id = _data["broker_id"] ? BrokerId.fromJS(_data["broker_id"]) : new BrokerId();
            this.appointment_status = _data["appointment_status"];
        }
    }

    static fromJS(data: any): Appointment {
        data = typeof data === 'object' ? data : {};
        let result = new Appointment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["appointment_date"] = this.appointment_date ? this.appointment_date.toISOString() : <any>undefined;
        data["expiration_date"] = this.expiration_date ? this.expiration_date.toISOString() : <any>undefined;
        data["broker_id"] = this.broker_id ? this.broker_id.toJSON() : <any>undefined;
        data["appointment_status"] = this.appointment_status;
        return data; 
    }
}

export interface IAppointment {
    state: TwoLetterState;
    appointment_date: Date | undefined;
    expiration_date: Date | undefined;
    broker_id: BrokerId;
    appointment_status: AppointmentStatus;
}

export enum TwoLetterState {
    AL = "AL",
    AK = "AK",
    AS = "AS",
    AZ = "AZ",
    AR = "AR",
    CA = "CA",
    CO = "CO",
    CT = "CT",
    DE = "DE",
    DC = "DC",
    FM = "FM",
    FL = "FL",
    GA = "GA",
    GU = "GU",
    HI = "HI",
    ID = "ID",
    IL = "IL",
    IN = "IN",
    IA = "IA",
    KS = "KS",
    KY = "KY",
    LA = "LA",
    ME = "ME",
    MH = "MH",
    MD = "MD",
    MA = "MA",
    MI = "MI",
    MN = "MN",
    MS = "MS",
    MO = "MO",
    MT = "MT",
    NE = "NE",
    NV = "NV",
    NH = "NH",
    NJ = "NJ",
    NM = "NM",
    NY = "NY",
    NC = "NC",
    ND = "ND",
    MP = "MP",
    OH = "OH",
    OK = "OK",
    OR = "OR",
    PW = "PW",
    PA = "PA",
    PR = "PR",
    RI = "RI",
    SC = "SC",
    SD = "SD",
    TN = "TN",
    TX = "TX",
    UT = "UT",
    VT = "VT",
    VI = "VI",
    VA = "VA",
    WA = "WA",
    WV = "WV",
    WI = "WI",
    WY = "WY",
}

export class ProductCarrierInformation implements IProductCarrierInformation {
    product_category!: EnsProductCategoryResponse;
    carrier!: EnsProductCarrierResponse;

    constructor(data?: IProductCarrierInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.product_category = new EnsProductCategoryResponse();
            this.carrier = new EnsProductCarrierResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product_category = _data["product_category"] ? EnsProductCategoryResponse.fromJS(_data["product_category"]) : new EnsProductCategoryResponse();
            this.carrier = _data["carrier"] ? EnsProductCarrierResponse.fromJS(_data["carrier"]) : new EnsProductCarrierResponse();
        }
    }

    static fromJS(data: any): ProductCarrierInformation {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCarrierInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product_category"] = this.product_category ? this.product_category.toJSON() : <any>undefined;
        data["carrier"] = this.carrier ? this.carrier.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IProductCarrierInformation {
    product_category: EnsProductCategoryResponse;
    carrier: EnsProductCarrierResponse;
}

export class BrokerId extends ProductCarrierInformation implements IBrokerId {
    broker_id_tid!: number;
    broker_id!: string;

    constructor(data?: IBrokerId) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.broker_id_tid = _data["broker_id_tid"];
            this.broker_id = _data["broker_id"];
        }
    }

    static fromJS(data: any): BrokerId {
        data = typeof data === 'object' ? data : {};
        let result = new BrokerId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["broker_id_tid"] = this.broker_id_tid;
        data["broker_id"] = this.broker_id;
        super.toJSON(data);
        return data; 
    }
}

export interface IBrokerId extends IProductCarrierInformation {
    broker_id_tid: number;
    broker_id: string;
}

export enum AppointmentStatus {
    NotAppointed = 0,
    JustInTimeAppointed = 1,
    Appointed = 2,
}

export class Certification implements ICertification {
    ens_user_certification_tid!: number;
    sql_created_by!: string;
    sql_created_datetime!: Date;
    sql_modified_by!: string | undefined;
    sql_modified_datetime!: Date | undefined;
    ens_user_certification_type_tid!: number;
    user_certification_name!: string;
    expiration_date!: Date | undefined;
    complete_fl!: boolean;

    constructor(data?: ICertification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_user_certification_tid = _data["ens_user_certification_tid"];
            this.sql_created_by = _data["sql_created_by"];
            this.sql_created_datetime = _data["sql_created_datetime"] ? new Date(_data["sql_created_datetime"].toString()) : <any>undefined;
            this.sql_modified_by = _data["sql_modified_by"];
            this.sql_modified_datetime = _data["sql_modified_datetime"] ? new Date(_data["sql_modified_datetime"].toString()) : <any>undefined;
            this.ens_user_certification_type_tid = _data["ens_user_certification_type_tid"];
            this.user_certification_name = _data["user_certification_name"];
            this.expiration_date = _data["expiration_date"] ? new Date(_data["expiration_date"].toString()) : <any>undefined;
            this.complete_fl = _data["complete_fl"];
        }
    }

    static fromJS(data: any): Certification {
        data = typeof data === 'object' ? data : {};
        let result = new Certification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_user_certification_tid"] = this.ens_user_certification_tid;
        data["sql_created_by"] = this.sql_created_by;
        data["sql_created_datetime"] = this.sql_created_datetime ? this.sql_created_datetime.toISOString() : <any>undefined;
        data["sql_modified_by"] = this.sql_modified_by;
        data["sql_modified_datetime"] = this.sql_modified_datetime ? this.sql_modified_datetime.toISOString() : <any>undefined;
        data["ens_user_certification_type_tid"] = this.ens_user_certification_type_tid;
        data["user_certification_name"] = this.user_certification_name;
        data["expiration_date"] = this.expiration_date ? this.expiration_date.toISOString() : <any>undefined;
        data["complete_fl"] = this.complete_fl;
        return data; 
    }
}

export interface ICertification {
    ens_user_certification_tid: number;
    sql_created_by: string;
    sql_created_datetime: Date;
    sql_modified_by: string | undefined;
    sql_modified_datetime: Date | undefined;
    ens_user_certification_type_tid: number;
    user_certification_name: string;
    expiration_date: Date | undefined;
    complete_fl: boolean;
}

export class RtsStatus implements IRtsStatus {
    state!: string;
    readyToSell!: boolean;
    type!: EnsUserRtsType;

    constructor(data?: IRtsStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.readyToSell = _data["readyToSell"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): RtsStatus {
        data = typeof data === 'object' ? data : {};
        let result = new RtsStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["readyToSell"] = this.readyToSell;
        data["type"] = this.type;
        return data; 
    }
}

export interface IRtsStatus {
    state: string;
    readyToSell: boolean;
    type: EnsUserRtsType;
}

export enum EnsUserRtsType {
    Unknown = 0,
    JustInTime = 1,
    Preappointment = 2,
    RtsReport = 3,
}

export class UpdateUserRequest implements IUpdateUserRequest {
    user_name?: string | undefined;
    user_first_name?: string | undefined;
    user_last_name?: string | undefined;
    user_email?: string | undefined;
    active_fl?: boolean | undefined;
    ssn?: string | undefined;
    ssn_lastfour?: string | undefined;
    dob?: Date | undefined;
    address_line1?: string | undefined;
    address_line2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    personal_email?: string | undefined;
    phone?: string | undefined;
    phone_extension?: string | undefined;
    hire_date?: Date | undefined;
    termination_date?: Date | undefined;
    npn?: string | undefined;

    constructor(data?: IUpdateUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user_name = _data["user_name"];
            this.user_first_name = _data["user_first_name"];
            this.user_last_name = _data["user_last_name"];
            this.user_email = _data["user_email"];
            this.active_fl = _data["active_fl"];
            this.ssn = _data["ssn"];
            this.ssn_lastfour = _data["ssn_lastfour"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
            this.address_line1 = _data["address_line1"];
            this.address_line2 = _data["address_line2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.personal_email = _data["personal_email"];
            this.phone = _data["phone"];
            this.phone_extension = _data["phone_extension"];
            this.hire_date = _data["hire_date"] ? new Date(_data["hire_date"].toString()) : <any>undefined;
            this.termination_date = _data["termination_date"] ? new Date(_data["termination_date"].toString()) : <any>undefined;
            this.npn = _data["npn"];
        }
    }

    static fromJS(data: any): UpdateUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user_name"] = this.user_name;
        data["user_first_name"] = this.user_first_name;
        data["user_last_name"] = this.user_last_name;
        data["user_email"] = this.user_email;
        data["active_fl"] = this.active_fl;
        data["ssn"] = this.ssn;
        data["ssn_lastfour"] = this.ssn_lastfour;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["address_line1"] = this.address_line1;
        data["address_line2"] = this.address_line2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["personal_email"] = this.personal_email;
        data["phone"] = this.phone;
        data["phone_extension"] = this.phone_extension;
        data["hire_date"] = this.hire_date ? this.hire_date.toISOString() : <any>undefined;
        data["termination_date"] = this.termination_date ? this.termination_date.toISOString() : <any>undefined;
        data["npn"] = this.npn;
        return data; 
    }
}

export interface IUpdateUserRequest {
    user_name?: string | undefined;
    user_first_name?: string | undefined;
    user_last_name?: string | undefined;
    user_email?: string | undefined;
    active_fl?: boolean | undefined;
    ssn?: string | undefined;
    ssn_lastfour?: string | undefined;
    dob?: Date | undefined;
    address_line1?: string | undefined;
    address_line2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    personal_email?: string | undefined;
    phone?: string | undefined;
    phone_extension?: string | undefined;
    hire_date?: Date | undefined;
    termination_date?: Date | undefined;
    npn?: string | undefined;
}

export class UpdateUserCertificationCompleteFlRequest extends CallingUserMessage implements IUpdateUserCertificationCompleteFlRequest {
    complete_fl!: boolean;

    constructor(data?: IUpdateUserCertificationCompleteFlRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.complete_fl = _data["complete_fl"];
        }
    }

    static fromJS(data: any): UpdateUserCertificationCompleteFlRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserCertificationCompleteFlRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["complete_fl"] = this.complete_fl;
        super.toJSON(data);
        return data; 
    }
}

export interface IUpdateUserCertificationCompleteFlRequest extends ICallingUserMessage {
    complete_fl: boolean;
}

export class AddBrokerIdRequest implements IAddBrokerIdRequest {
    ens_product_carrier_tid!: number;
    ens_product_category_tid!: number;
    broker_id!: string;

    constructor(data?: IAddBrokerIdRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_product_carrier_tid = _data["ens_product_carrier_tid"];
            this.ens_product_category_tid = _data["ens_product_category_tid"];
            this.broker_id = _data["broker_id"];
        }
    }

    static fromJS(data: any): AddBrokerIdRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddBrokerIdRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_product_carrier_tid"] = this.ens_product_carrier_tid;
        data["ens_product_category_tid"] = this.ens_product_category_tid;
        data["broker_id"] = this.broker_id;
        return data; 
    }
}

export interface IAddBrokerIdRequest {
    ens_product_carrier_tid: number;
    ens_product_category_tid: number;
    broker_id: string;
}

export class UpdateBrokerIdRequest implements IUpdateBrokerIdRequest {
    ens_user_broker_id_tid!: number;
    ens_product_carrier_tid?: number | undefined;
    ens_product_category_tid?: number | undefined;
    broker_id?: string | undefined;

    constructor(data?: IUpdateBrokerIdRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_user_broker_id_tid = _data["ens_user_broker_id_tid"];
            this.ens_product_carrier_tid = _data["ens_product_carrier_tid"];
            this.ens_product_category_tid = _data["ens_product_category_tid"];
            this.broker_id = _data["broker_id"];
        }
    }

    static fromJS(data: any): UpdateBrokerIdRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBrokerIdRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_user_broker_id_tid"] = this.ens_user_broker_id_tid;
        data["ens_product_carrier_tid"] = this.ens_product_carrier_tid;
        data["ens_product_category_tid"] = this.ens_product_category_tid;
        data["broker_id"] = this.broker_id;
        return data; 
    }
}

export interface IUpdateBrokerIdRequest {
    ens_user_broker_id_tid: number;
    ens_product_carrier_tid?: number | undefined;
    ens_product_category_tid?: number | undefined;
    broker_id?: string | undefined;
}

export class GetPermissionsResponse implements IGetPermissionsResponse {
    ens_user_permission_type_tid!: number;
    permission_type_name!: string;

    constructor(data?: IGetPermissionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_user_permission_type_tid = _data["ens_user_permission_type_tid"];
            this.permission_type_name = _data["permission_type_name"];
        }
    }

    static fromJS(data: any): GetPermissionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPermissionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_user_permission_type_tid"] = this.ens_user_permission_type_tid;
        data["permission_type_name"] = this.permission_type_name;
        return data; 
    }
}

export interface IGetPermissionsResponse {
    ens_user_permission_type_tid: number;
    permission_type_name: string;
}

export class GetRoleTypeResponse implements IGetRoleTypeResponse {
    ens_user_role_type_tid!: number;
    role_type_name!: string;
    role_permissions!: GetPermissionsResponse[];

    constructor(data?: IGetRoleTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.role_permissions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_user_role_type_tid = _data["ens_user_role_type_tid"];
            this.role_type_name = _data["role_type_name"];
            if (Array.isArray(_data["role_permissions"])) {
                this.role_permissions = [] as any;
                for (let item of _data["role_permissions"])
                    this.role_permissions!.push(GetPermissionsResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRoleTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_user_role_type_tid"] = this.ens_user_role_type_tid;
        data["role_type_name"] = this.role_type_name;
        if (Array.isArray(this.role_permissions)) {
            data["role_permissions"] = [];
            for (let item of this.role_permissions)
                data["role_permissions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetRoleTypeResponse {
    ens_user_role_type_tid: number;
    role_type_name: string;
    role_permissions: GetPermissionsResponse[];
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; } | undefined;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = this.extensions[key];
            }
        }
        return data; 
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; } | undefined;
}

export enum EnsUserPermissionTypeTid {
    AdminAccess = 1,
    AdminEmployeePermissions = 2,
    ComplianceAccess = 3,
    LicensingAccessAll = 4,
    LicensingAccessSelf = 5,
    LicensingEditAll = 6,
    MarketingAccess = 7,
    OperationsAccess = 8,
    SalesPortalAccess = 9,
    DtcAccess = 10,
    AgentSaleAccess = 11,
    AdminSaleAccess = 12,
    ControllerSaleAaccess = 13,
    LicensingExperimentalAccess = 14,
    CarrierChildrenMaintenanceAccess = 15,
    SocialSecurityAccess = 16,
    CallAudioAccess = 17,
    DataDictionaryAccess = 18,
    DataDictionaryEdit = 19,
    SupervisorSaleAccess = 20,
    CallAnalyticsAccess = 21,
    AlertsAccess = 22,
    CronBossAccess = 23,
    TimesheetUploadAccess = 24,
    BusinessTermMaintainerAccess = 25,
    LicensingRequestApprovalAccess = 26,
    CommissionUploadManagerViewOnlyAccess = 27,
    SalePledgeAccess = 28,
    EcmViewApp = 29,
    EcmGetStreamers = 30,
    EcmWatchStream = 31,
    EcmGetVideoUrl = 32,
    EcmListVideos = 33,
    EcmVideoInsights = 34,
    ReadSalesCalls = 35,
    ReadCallLogs = 36,
    ReadTranscripts = 37,
    ReadCallAnalyticsResults = 38,
    SaleMassUpdateAccess = 39,
    SalesPolicyHistoryEditAccess = 40,
    EmpDownloadAllUserAttachments = 41,
    EMPEmployeeAccess = 42,
    EMPAuditAccess = 43,
    EMPSupervisorAccess = 44,
    EMPNegativeCategoryAcess = 45,
    EmployeeRelationshipUploadAccess = 46,
    HRAccess = 47,
    EcmGetAdminMetrics = 48,
    EcmGetDeveloperMetrics = 49,
    OrganizationChartAccess = 50,
    EmpDeleteAccess = 51,
    BulkListImportAccess = 52,
    EmpLwopCategoryAccess = 53,
    EmpOnOnOneCategoryAccess = 54,
    EmpSensitiveDataCategoryAccess = 55,
    EmpExportUserNotes = 56,
    EmmaLiveInsightsViewApp = 57,
    EmmaLiveInsightsListenToMyTranscripts = 58,
    EmmaLiveInsightsListenToOtherTranscripts = 59,
    GptApi = 60,
    EntityDetectionApi = 61,
    MLFactoryTrainingApi = 62,
    MLFactoryInferenceApi = 63,
    EmpOTEarnedCategoryAccess = 64,
    AgentCommissionAccess = 65,
    AccountingCommissionAccess = 66,
    SaleMedicareIdUpdate = 67,
}

export class GetUserRolesResponse extends RolesPermissionsResponse implements IGetUserRolesResponse {
    user_id!: number;

    constructor(data?: IGetUserRolesResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.user_id = _data["user_id"];
        }
    }

    static fromJS(data: any): GetUserRolesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserRolesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user_id"] = this.user_id;
        super.toJSON(data);
        return data; 
    }
}

export interface IGetUserRolesResponse extends IRolesPermissionsResponse {
    user_id: number;
}

export class WavFetchResponse implements IWavFetchResponse {
    archive_link?: string | undefined;

    constructor(data?: IWavFetchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.archive_link = _data["archive_link"];
        }
    }

    static fromJS(data: any): WavFetchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WavFetchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["archive_link"] = this.archive_link;
        return data; 
    }
}

export interface IWavFetchResponse {
    archive_link?: string | undefined;
}

export class WavFetchRequest implements IWavFetchRequest {
    archive_name?: string | undefined;
    requests?: Request[] | undefined;

    constructor(data?: IWavFetchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.archive_name = _data["archive_name"];
            if (Array.isArray(_data["requests"])) {
                this.requests = [] as any;
                for (let item of _data["requests"])
                    this.requests!.push(Request.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WavFetchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WavFetchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["archive_name"] = this.archive_name;
        if (Array.isArray(this.requests)) {
            data["requests"] = [];
            for (let item of this.requests)
                data["requests"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IWavFetchRequest {
    archive_name?: string | undefined;
    requests?: Request[] | undefined;
}

export class Request implements IRequest {
    file_name?: string | undefined;
    checksum?: string | undefined;

    constructor(data?: IRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file_name = _data["file_name"];
            this.checksum = _data["checksum"];
        }
    }

    static fromJS(data: any): Request {
        data = typeof data === 'object' ? data : {};
        let result = new Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file_name"] = this.file_name;
        data["checksum"] = this.checksum;
        return data; 
    }
}

export interface IRequest {
    file_name?: string | undefined;
    checksum?: string | undefined;
}

export class IapAccessLogRequest implements IIapAccessLogRequest {
    user_email?: string | undefined;
    log_description?: string | undefined;

    constructor(data?: IIapAccessLogRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user_email = _data["user_email"];
            this.log_description = _data["log_description"];
        }
    }

    static fromJS(data: any): IapAccessLogRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IapAccessLogRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user_email"] = this.user_email;
        data["log_description"] = this.log_description;
        return data; 
    }
}

export interface IIapAccessLogRequest {
    user_email?: string | undefined;
    log_description?: string | undefined;
}

export class LeadSearchResponse implements ILeadSearchResponse {
    phone_number?: string | undefined;
    count?: number;
    leads?: EnsLeadTimelineRow[] | undefined;

    constructor(data?: ILeadSearchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phone_number = _data["phone_number"];
            this.count = _data["count"];
            if (Array.isArray(_data["leads"])) {
                this.leads = [] as any;
                for (let item of _data["leads"])
                    this.leads!.push(EnsLeadTimelineRow.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LeadSearchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LeadSearchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phone_number"] = this.phone_number;
        data["count"] = this.count;
        if (Array.isArray(this.leads)) {
            data["leads"] = [];
            for (let item of this.leads)
                data["leads"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ILeadSearchResponse {
    phone_number?: string | undefined;
    count?: number;
    leads?: EnsLeadTimelineRow[] | undefined;
}

export abstract class HalRow implements IHalRow {
    sql_created_by?: string | undefined;
    sql_created_datetime?: Date;
    sql_modified_by?: string | undefined;
    sql_modified_datetime?: Date;

    constructor(data?: IHalRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sql_created_by = _data["sql_created_by"];
            this.sql_created_datetime = _data["sql_created_datetime"] ? new Date(_data["sql_created_datetime"].toString()) : <any>undefined;
            this.sql_modified_by = _data["sql_modified_by"];
            this.sql_modified_datetime = _data["sql_modified_datetime"] ? new Date(_data["sql_modified_datetime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HalRow {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'HalRow' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sql_created_by"] = this.sql_created_by;
        data["sql_created_datetime"] = this.sql_created_datetime ? this.sql_created_datetime.toISOString() : <any>undefined;
        data["sql_modified_by"] = this.sql_modified_by;
        data["sql_modified_datetime"] = this.sql_modified_datetime ? this.sql_modified_datetime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IHalRow {
    sql_created_by?: string | undefined;
    sql_created_datetime?: Date;
    sql_modified_by?: string | undefined;
    sql_modified_datetime?: Date;
}

export class EnsLeadTimelineRow extends HalRow implements IEnsLeadTimelineRow {
    ens_lead_timeline_tid?: number;
    lead_id?: string | undefined;
    lead_source?: string | undefined;
    ens_contact_tid?: number;
    f9_list_tid?: number;
    lead_creation_timestamp?: Date | undefined;
    received_internal_timestamp?: Date | undefined;
    sent_to_dialer_timestamp?: Date | undefined;
    sent_to_sfdc_timestamp?: Date | undefined;
    call_started_timestamp?: Date | undefined;
    call_ended_timestamp?: Date | undefined;
    test_fl?: boolean;
    ens_lead_type_tid?: number;
    ens_marketing_campaign_tid?: number;

    constructor(data?: IEnsLeadTimelineRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ens_lead_timeline_tid = _data["ens_lead_timeline_tid"];
            this.lead_id = _data["lead_id"];
            this.lead_source = _data["lead_source"];
            this.ens_contact_tid = _data["ens_contact_tid"];
            this.f9_list_tid = _data["f9_list_tid"];
            this.lead_creation_timestamp = _data["lead_creation_timestamp"] ? new Date(_data["lead_creation_timestamp"].toString()) : <any>undefined;
            this.received_internal_timestamp = _data["received_internal_timestamp"] ? new Date(_data["received_internal_timestamp"].toString()) : <any>undefined;
            this.sent_to_dialer_timestamp = _data["sent_to_dialer_timestamp"] ? new Date(_data["sent_to_dialer_timestamp"].toString()) : <any>undefined;
            this.sent_to_sfdc_timestamp = _data["sent_to_sfdc_timestamp"] ? new Date(_data["sent_to_sfdc_timestamp"].toString()) : <any>undefined;
            this.call_started_timestamp = _data["call_started_timestamp"] ? new Date(_data["call_started_timestamp"].toString()) : <any>undefined;
            this.call_ended_timestamp = _data["call_ended_timestamp"] ? new Date(_data["call_ended_timestamp"].toString()) : <any>undefined;
            this.test_fl = _data["test_fl"];
            this.ens_lead_type_tid = _data["ens_lead_type_tid"];
            this.ens_marketing_campaign_tid = _data["ens_marketing_campaign_tid"];
        }
    }

    static fromJS(data: any): EnsLeadTimelineRow {
        data = typeof data === 'object' ? data : {};
        let result = new EnsLeadTimelineRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_lead_timeline_tid"] = this.ens_lead_timeline_tid;
        data["lead_id"] = this.lead_id;
        data["lead_source"] = this.lead_source;
        data["ens_contact_tid"] = this.ens_contact_tid;
        data["f9_list_tid"] = this.f9_list_tid;
        data["lead_creation_timestamp"] = this.lead_creation_timestamp ? this.lead_creation_timestamp.toISOString() : <any>undefined;
        data["received_internal_timestamp"] = this.received_internal_timestamp ? this.received_internal_timestamp.toISOString() : <any>undefined;
        data["sent_to_dialer_timestamp"] = this.sent_to_dialer_timestamp ? this.sent_to_dialer_timestamp.toISOString() : <any>undefined;
        data["sent_to_sfdc_timestamp"] = this.sent_to_sfdc_timestamp ? this.sent_to_sfdc_timestamp.toISOString() : <any>undefined;
        data["call_started_timestamp"] = this.call_started_timestamp ? this.call_started_timestamp.toISOString() : <any>undefined;
        data["call_ended_timestamp"] = this.call_ended_timestamp ? this.call_ended_timestamp.toISOString() : <any>undefined;
        data["test_fl"] = this.test_fl;
        data["ens_lead_type_tid"] = this.ens_lead_type_tid;
        data["ens_marketing_campaign_tid"] = this.ens_marketing_campaign_tid;
        super.toJSON(data);
        return data; 
    }
}

export interface IEnsLeadTimelineRow extends IHalRow {
    ens_lead_timeline_tid?: number;
    lead_id?: string | undefined;
    lead_source?: string | undefined;
    ens_contact_tid?: number;
    f9_list_tid?: number;
    lead_creation_timestamp?: Date | undefined;
    received_internal_timestamp?: Date | undefined;
    sent_to_dialer_timestamp?: Date | undefined;
    sent_to_sfdc_timestamp?: Date | undefined;
    call_started_timestamp?: Date | undefined;
    call_ended_timestamp?: Date | undefined;
    test_fl?: boolean;
    ens_lead_type_tid?: number;
    ens_marketing_campaign_tid?: number;
}

export class LeadTimelineResponse implements ILeadTimelineResponse {
    start_datetime_est?: Date;
    end_datetime_est?: Date;
    count?: number;
    leads?: EnsLeadTimelineRow[] | undefined;

    constructor(data?: ILeadTimelineResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start_datetime_est = _data["start_datetime_est"] ? new Date(_data["start_datetime_est"].toString()) : <any>undefined;
            this.end_datetime_est = _data["end_datetime_est"] ? new Date(_data["end_datetime_est"].toString()) : <any>undefined;
            this.count = _data["count"];
            if (Array.isArray(_data["leads"])) {
                this.leads = [] as any;
                for (let item of _data["leads"])
                    this.leads!.push(EnsLeadTimelineRow.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LeadTimelineResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LeadTimelineResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start_datetime_est"] = this.start_datetime_est ? this.start_datetime_est.toISOString() : <any>undefined;
        data["end_datetime_est"] = this.end_datetime_est ? this.end_datetime_est.toISOString() : <any>undefined;
        data["count"] = this.count;
        if (Array.isArray(this.leads)) {
            data["leads"] = [];
            for (let item of this.leads)
                data["leads"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ILeadTimelineResponse {
    start_datetime_est?: Date;
    end_datetime_est?: Date;
    count?: number;
    leads?: EnsLeadTimelineRow[] | undefined;
}

export class ReversePhoneSearchResult implements IReversePhoneSearchResult {
    phone_numbers!: string[];

    constructor(data?: IReversePhoneSearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.phone_numbers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["phone_numbers"])) {
                this.phone_numbers = [] as any;
                for (let item of _data["phone_numbers"])
                    this.phone_numbers!.push(item);
            }
        }
    }

    static fromJS(data: any): ReversePhoneSearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new ReversePhoneSearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.phone_numbers)) {
            data["phone_numbers"] = [];
            for (let item of this.phone_numbers)
                data["phone_numbers"].push(item);
        }
        return data; 
    }
}

export interface IReversePhoneSearchResult {
    phone_numbers: string[];
}

export class SaleStatusUpdateMessage extends CallingUserMessage implements ISaleStatusUpdateMessage {
    current_status_tid?: EnsSaleStatus | undefined;
    issue_status_tid?: EnsSaleStatus | undefined;

    constructor(data?: ISaleStatusUpdateMessage) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.current_status_tid = _data["current_status_tid"];
            this.issue_status_tid = _data["issue_status_tid"];
        }
    }

    static fromJS(data: any): SaleStatusUpdateMessage {
        data = typeof data === 'object' ? data : {};
        let result = new SaleStatusUpdateMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current_status_tid"] = this.current_status_tid;
        data["issue_status_tid"] = this.issue_status_tid;
        super.toJSON(data);
        return data; 
    }
}

export interface ISaleStatusUpdateMessage extends ICallingUserMessage {
    current_status_tid?: EnsSaleStatus | undefined;
    issue_status_tid?: EnsSaleStatus | undefined;
}

export enum EnsSaleStatus {
    Deleted = 2,
    Duplicate = 3,
    Incomplete = 4,
    Issued = 5,
    NTO = 7,
    Pending = 8,
    PendingCMS = 9,
    Rejected = 10,
    RapidDisenrollment = 11,
    Terminated = 12,
    Error = -1,
}

export class EnsSaleResponse implements IEnsSaleResponse {
    ensSaleTid?: number;
    purchaserLastEnsContactMarketingActionTid?: number;
    purchaserEnsContactTid?: number;
    insuredEnsContactTid?: number;
    ensProductCarrierTid?: number;
    ensProductTid?: number;
    agentEnsUserTid?: number;
    referralEnsUserTid?: number | undefined;
    f9WorksheetTid?: number;
    saleDatetime?: Date;
    effectiveDate?: Date;
    ageAtTos?: number;
    premium?: number | undefined;
    premiumMultiplier?: number | undefined;
    rewriteFl?: boolean;
    referralAgentAnswer?: string | undefined;
    policyNumber?: string | undefined;
    commissionBasis?: string | undefined;
    notes?: string | undefined;
    underwritingComments?: string | undefined;
    insuredFirstName?: string | undefined;
    insuredLastName?: string | undefined;
    insuredGender?: string | undefined;
    insuredDob?: Date | undefined;
    insuredPhone?: string | undefined;
    insuredEmail?: string | undefined;
    insuredAddressLine1?: string | undefined;
    insuredAddressLine2?: string | undefined;
    insuredCity?: string | undefined;
    insuredState?: string | undefined;
    insuredZip?: string | undefined;
    approvalDatetime?: Date | undefined;
    currentEnsSaleStatusTid?: number;
    issueEnsSaleStatusTid?: number;
    terminationDate?: Date | undefined;
    ensSaleUnderwritingStatusTid?: number | undefined;
    ensMarketingCampaignTid?: number | undefined;

    constructor(data?: IEnsSaleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ensSaleTid = _data["ensSaleTid"];
            this.purchaserLastEnsContactMarketingActionTid = _data["purchaserLastEnsContactMarketingActionTid"];
            this.purchaserEnsContactTid = _data["purchaserEnsContactTid"];
            this.insuredEnsContactTid = _data["insuredEnsContactTid"];
            this.ensProductCarrierTid = _data["ensProductCarrierTid"];
            this.ensProductTid = _data["ensProductTid"];
            this.agentEnsUserTid = _data["agentEnsUserTid"];
            this.referralEnsUserTid = _data["referralEnsUserTid"];
            this.f9WorksheetTid = _data["f9WorksheetTid"];
            this.saleDatetime = _data["saleDatetime"] ? new Date(_data["saleDatetime"].toString()) : <any>undefined;
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : <any>undefined;
            this.ageAtTos = _data["ageAtTos"];
            this.premium = _data["premium"];
            this.premiumMultiplier = _data["premiumMultiplier"];
            this.rewriteFl = _data["rewriteFl"];
            this.referralAgentAnswer = _data["referralAgentAnswer"];
            this.policyNumber = _data["policyNumber"];
            this.commissionBasis = _data["commissionBasis"];
            this.notes = _data["notes"];
            this.underwritingComments = _data["underwritingComments"];
            this.insuredFirstName = _data["insuredFirstName"];
            this.insuredLastName = _data["insuredLastName"];
            this.insuredGender = _data["insuredGender"];
            this.insuredDob = _data["insuredDob"] ? new Date(_data["insuredDob"].toString()) : <any>undefined;
            this.insuredPhone = _data["insuredPhone"];
            this.insuredEmail = _data["insuredEmail"];
            this.insuredAddressLine1 = _data["insuredAddressLine1"];
            this.insuredAddressLine2 = _data["insuredAddressLine2"];
            this.insuredCity = _data["insuredCity"];
            this.insuredState = _data["insuredState"];
            this.insuredZip = _data["insuredZip"];
            this.approvalDatetime = _data["approvalDatetime"] ? new Date(_data["approvalDatetime"].toString()) : <any>undefined;
            this.currentEnsSaleStatusTid = _data["currentEnsSaleStatusTid"];
            this.issueEnsSaleStatusTid = _data["issueEnsSaleStatusTid"];
            this.terminationDate = _data["terminationDate"] ? new Date(_data["terminationDate"].toString()) : <any>undefined;
            this.ensSaleUnderwritingStatusTid = _data["ensSaleUnderwritingStatusTid"];
            this.ensMarketingCampaignTid = _data["ensMarketingCampaignTid"];
        }
    }

    static fromJS(data: any): EnsSaleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnsSaleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ensSaleTid"] = this.ensSaleTid;
        data["purchaserLastEnsContactMarketingActionTid"] = this.purchaserLastEnsContactMarketingActionTid;
        data["purchaserEnsContactTid"] = this.purchaserEnsContactTid;
        data["insuredEnsContactTid"] = this.insuredEnsContactTid;
        data["ensProductCarrierTid"] = this.ensProductCarrierTid;
        data["ensProductTid"] = this.ensProductTid;
        data["agentEnsUserTid"] = this.agentEnsUserTid;
        data["referralEnsUserTid"] = this.referralEnsUserTid;
        data["f9WorksheetTid"] = this.f9WorksheetTid;
        data["saleDatetime"] = this.saleDatetime ? this.saleDatetime.toISOString() : <any>undefined;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["ageAtTos"] = this.ageAtTos;
        data["premium"] = this.premium;
        data["premiumMultiplier"] = this.premiumMultiplier;
        data["rewriteFl"] = this.rewriteFl;
        data["referralAgentAnswer"] = this.referralAgentAnswer;
        data["policyNumber"] = this.policyNumber;
        data["commissionBasis"] = this.commissionBasis;
        data["notes"] = this.notes;
        data["underwritingComments"] = this.underwritingComments;
        data["insuredFirstName"] = this.insuredFirstName;
        data["insuredLastName"] = this.insuredLastName;
        data["insuredGender"] = this.insuredGender;
        data["insuredDob"] = this.insuredDob ? this.insuredDob.toISOString() : <any>undefined;
        data["insuredPhone"] = this.insuredPhone;
        data["insuredEmail"] = this.insuredEmail;
        data["insuredAddressLine1"] = this.insuredAddressLine1;
        data["insuredAddressLine2"] = this.insuredAddressLine2;
        data["insuredCity"] = this.insuredCity;
        data["insuredState"] = this.insuredState;
        data["insuredZip"] = this.insuredZip;
        data["approvalDatetime"] = this.approvalDatetime ? this.approvalDatetime.toISOString() : <any>undefined;
        data["currentEnsSaleStatusTid"] = this.currentEnsSaleStatusTid;
        data["issueEnsSaleStatusTid"] = this.issueEnsSaleStatusTid;
        data["terminationDate"] = this.terminationDate ? this.terminationDate.toISOString() : <any>undefined;
        data["ensSaleUnderwritingStatusTid"] = this.ensSaleUnderwritingStatusTid;
        data["ensMarketingCampaignTid"] = this.ensMarketingCampaignTid;
        return data; 
    }
}

export interface IEnsSaleResponse {
    ensSaleTid?: number;
    purchaserLastEnsContactMarketingActionTid?: number;
    purchaserEnsContactTid?: number;
    insuredEnsContactTid?: number;
    ensProductCarrierTid?: number;
    ensProductTid?: number;
    agentEnsUserTid?: number;
    referralEnsUserTid?: number | undefined;
    f9WorksheetTid?: number;
    saleDatetime?: Date;
    effectiveDate?: Date;
    ageAtTos?: number;
    premium?: number | undefined;
    premiumMultiplier?: number | undefined;
    rewriteFl?: boolean;
    referralAgentAnswer?: string | undefined;
    policyNumber?: string | undefined;
    commissionBasis?: string | undefined;
    notes?: string | undefined;
    underwritingComments?: string | undefined;
    insuredFirstName?: string | undefined;
    insuredLastName?: string | undefined;
    insuredGender?: string | undefined;
    insuredDob?: Date | undefined;
    insuredPhone?: string | undefined;
    insuredEmail?: string | undefined;
    insuredAddressLine1?: string | undefined;
    insuredAddressLine2?: string | undefined;
    insuredCity?: string | undefined;
    insuredState?: string | undefined;
    insuredZip?: string | undefined;
    approvalDatetime?: Date | undefined;
    currentEnsSaleStatusTid?: number;
    issueEnsSaleStatusTid?: number;
    terminationDate?: Date | undefined;
    ensSaleUnderwritingStatusTid?: number | undefined;
    ensMarketingCampaignTid?: number | undefined;
}

export class SaleUpdateRequest implements ISaleUpdateRequest {
    purchaser_last_ens_contact_marketing_action_tid?: number | undefined;
    purchaser_ens_contact_id?: number | undefined;
    insured_ens_contact_tid?: number | undefined;
    ens_product_carrier_tid?: number | undefined;
    ens_product_tid?: number | undefined;
    agent_ens_user_tid?: number | undefined;
    referral_ens_user_tid?: number | undefined;
    f9_worksheet_tid?: number | undefined;
    sale_datetime?: Date | undefined;
    effective_date?: Date | undefined;
    age_at_tos?: number | undefined;
    premium?: number | undefined;
    premium_multiplier?: number | undefined;
    rewrite_fl?: boolean | undefined;
    referral_agent_answer?: string | undefined;
    primary_policy_number?: string | undefined;
    commission_basis?: string | undefined;
    notes?: string | undefined;
    underwriting_comments?: string | undefined;
    insured_first_name?: string | undefined;
    insured_last_name?: string | undefined;
    insured_gender?: string | undefined;
    insured_dob?: Date | undefined;
    insured_phone?: string | undefined;
    insured_email?: string | undefined;
    insured_address_line1?: string | undefined;
    insured_address_line2?: string | undefined;
    insured_city?: string | undefined;
    insured_state?: string | undefined;
    insured_zip?: string | undefined;
    approval_datetime?: Date | undefined;
    current_ens_sale_status_tid?: number | undefined;
    issued_ens_sale_status_tid?: number | undefined;
    termination_date?: Date | undefined;
    ens_sale_underwritting_status_tid?: number | undefined;
    ens_marketing_campaign_tid?: number | undefined;
    medicare_id?: string | undefined;

    constructor(data?: ISaleUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.purchaser_last_ens_contact_marketing_action_tid = _data["purchaser_last_ens_contact_marketing_action_tid"];
            this.purchaser_ens_contact_id = _data["purchaser_ens_contact_id"];
            this.insured_ens_contact_tid = _data["insured_ens_contact_tid"];
            this.ens_product_carrier_tid = _data["ens_product_carrier_tid"];
            this.ens_product_tid = _data["ens_product_tid"];
            this.agent_ens_user_tid = _data["agent_ens_user_tid"];
            this.referral_ens_user_tid = _data["referral_ens_user_tid"];
            this.f9_worksheet_tid = _data["f9_worksheet_tid"];
            this.sale_datetime = _data["sale_datetime"] ? new Date(_data["sale_datetime"].toString()) : <any>undefined;
            this.effective_date = _data["effective_date"] ? new Date(_data["effective_date"].toString()) : <any>undefined;
            this.age_at_tos = _data["age_at_tos"];
            this.premium = _data["premium"];
            this.premium_multiplier = _data["premium_multiplier"];
            this.rewrite_fl = _data["rewrite_fl"];
            this.referral_agent_answer = _data["referral_agent_answer"];
            this.primary_policy_number = _data["primary_policy_number"];
            this.commission_basis = _data["commission_basis"];
            this.notes = _data["notes"];
            this.underwriting_comments = _data["underwriting_comments"];
            this.insured_first_name = _data["insured_first_name"];
            this.insured_last_name = _data["insured_last_name"];
            this.insured_gender = _data["insured_gender"];
            this.insured_dob = _data["insured_dob"] ? new Date(_data["insured_dob"].toString()) : <any>undefined;
            this.insured_phone = _data["insured_phone"];
            this.insured_email = _data["insured_email"];
            this.insured_address_line1 = _data["insured_address_line1"];
            this.insured_address_line2 = _data["insured_address_line2"];
            this.insured_city = _data["insured_city"];
            this.insured_state = _data["insured_state"];
            this.insured_zip = _data["insured_zip"];
            this.approval_datetime = _data["approval_datetime"] ? new Date(_data["approval_datetime"].toString()) : <any>undefined;
            this.current_ens_sale_status_tid = _data["current_ens_sale_status_tid"];
            this.issued_ens_sale_status_tid = _data["issued_ens_sale_status_tid"];
            this.termination_date = _data["termination_date"] ? new Date(_data["termination_date"].toString()) : <any>undefined;
            this.ens_sale_underwritting_status_tid = _data["ens_sale_underwritting_status_tid"];
            this.ens_marketing_campaign_tid = _data["ens_marketing_campaign_tid"];
            this.medicare_id = _data["medicare_id"];
        }
    }

    static fromJS(data: any): SaleUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaleUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["purchaser_last_ens_contact_marketing_action_tid"] = this.purchaser_last_ens_contact_marketing_action_tid;
        data["purchaser_ens_contact_id"] = this.purchaser_ens_contact_id;
        data["insured_ens_contact_tid"] = this.insured_ens_contact_tid;
        data["ens_product_carrier_tid"] = this.ens_product_carrier_tid;
        data["ens_product_tid"] = this.ens_product_tid;
        data["agent_ens_user_tid"] = this.agent_ens_user_tid;
        data["referral_ens_user_tid"] = this.referral_ens_user_tid;
        data["f9_worksheet_tid"] = this.f9_worksheet_tid;
        data["sale_datetime"] = this.sale_datetime ? this.sale_datetime.toISOString() : <any>undefined;
        data["effective_date"] = this.effective_date ? this.effective_date.toISOString() : <any>undefined;
        data["age_at_tos"] = this.age_at_tos;
        data["premium"] = this.premium;
        data["premium_multiplier"] = this.premium_multiplier;
        data["rewrite_fl"] = this.rewrite_fl;
        data["referral_agent_answer"] = this.referral_agent_answer;
        data["primary_policy_number"] = this.primary_policy_number;
        data["commission_basis"] = this.commission_basis;
        data["notes"] = this.notes;
        data["underwriting_comments"] = this.underwriting_comments;
        data["insured_first_name"] = this.insured_first_name;
        data["insured_last_name"] = this.insured_last_name;
        data["insured_gender"] = this.insured_gender;
        data["insured_dob"] = this.insured_dob ? this.insured_dob.toISOString() : <any>undefined;
        data["insured_phone"] = this.insured_phone;
        data["insured_email"] = this.insured_email;
        data["insured_address_line1"] = this.insured_address_line1;
        data["insured_address_line2"] = this.insured_address_line2;
        data["insured_city"] = this.insured_city;
        data["insured_state"] = this.insured_state;
        data["insured_zip"] = this.insured_zip;
        data["approval_datetime"] = this.approval_datetime ? this.approval_datetime.toISOString() : <any>undefined;
        data["current_ens_sale_status_tid"] = this.current_ens_sale_status_tid;
        data["issued_ens_sale_status_tid"] = this.issued_ens_sale_status_tid;
        data["termination_date"] = this.termination_date ? this.termination_date.toISOString() : <any>undefined;
        data["ens_sale_underwritting_status_tid"] = this.ens_sale_underwritting_status_tid;
        data["ens_marketing_campaign_tid"] = this.ens_marketing_campaign_tid;
        data["medicare_id"] = this.medicare_id;
        return data; 
    }
}

export interface ISaleUpdateRequest {
    purchaser_last_ens_contact_marketing_action_tid?: number | undefined;
    purchaser_ens_contact_id?: number | undefined;
    insured_ens_contact_tid?: number | undefined;
    ens_product_carrier_tid?: number | undefined;
    ens_product_tid?: number | undefined;
    agent_ens_user_tid?: number | undefined;
    referral_ens_user_tid?: number | undefined;
    f9_worksheet_tid?: number | undefined;
    sale_datetime?: Date | undefined;
    effective_date?: Date | undefined;
    age_at_tos?: number | undefined;
    premium?: number | undefined;
    premium_multiplier?: number | undefined;
    rewrite_fl?: boolean | undefined;
    referral_agent_answer?: string | undefined;
    primary_policy_number?: string | undefined;
    commission_basis?: string | undefined;
    notes?: string | undefined;
    underwriting_comments?: string | undefined;
    insured_first_name?: string | undefined;
    insured_last_name?: string | undefined;
    insured_gender?: string | undefined;
    insured_dob?: Date | undefined;
    insured_phone?: string | undefined;
    insured_email?: string | undefined;
    insured_address_line1?: string | undefined;
    insured_address_line2?: string | undefined;
    insured_city?: string | undefined;
    insured_state?: string | undefined;
    insured_zip?: string | undefined;
    approval_datetime?: Date | undefined;
    current_ens_sale_status_tid?: number | undefined;
    issued_ens_sale_status_tid?: number | undefined;
    termination_date?: Date | undefined;
    ens_sale_underwritting_status_tid?: number | undefined;
    ens_marketing_campaign_tid?: number | undefined;
    medicare_id?: string | undefined;
}

export class SaleInsertRequest implements ISaleInsertRequest {
    purchaser_last_ens_contact_marketing_action_tid?: number | undefined;
    purchaser_ens_contact_id?: number | undefined;
    insured_ens_contact_tid?: number | undefined;
    ens_product_carrier_tid!: EnsProductCarrierTid;
    ens_product_tid!: EnsProductTid;
    agent_ens_user_tid!: number;
    referral_ens_user_tid?: number | undefined;
    f9_worksheet_tid?: number | undefined;
    current_ens_sale_status_tid!: number;
    issued_ens_sale_status_tid!: number;
    sale_datetime!: Date;
    effective_date!: Date;
    age_at_tos?: number | undefined;
    rewrite_fl!: boolean;
    premium?: number | undefined;
    ens_marketing_campaign_tid?: number | undefined;
    premium_multiplier?: number | undefined;
    referral_agent_answer?: string | undefined;
    primary_policy_number?: string | undefined;
    commission_basis?: string | undefined;
    notes?: string | undefined;
    underwriting_comments?: string | undefined;
    insured_first_name?: string | undefined;
    insured_last_name?: string | undefined;
    insured_gender?: string | undefined;
    insured_dob!: Date;
    insured_phone?: string | undefined;
    insured_email?: string | undefined;
    insured_address_line1?: string | undefined;
    insured_address_line2?: string | undefined;
    insured_city?: string | undefined;
    insured_state?: TwoLetterState | undefined;
    insured_zip?: string | undefined;
    approval_datetime?: Date | undefined;
    termination_date?: Date | undefined;
    ens_sale_underwritting_status_tid?: number | undefined;

    constructor(data?: ISaleInsertRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.purchaser_last_ens_contact_marketing_action_tid = _data["purchaser_last_ens_contact_marketing_action_tid"];
            this.purchaser_ens_contact_id = _data["purchaser_ens_contact_id"];
            this.insured_ens_contact_tid = _data["insured_ens_contact_tid"];
            this.ens_product_carrier_tid = _data["ens_product_carrier_tid"];
            this.ens_product_tid = _data["ens_product_tid"];
            this.agent_ens_user_tid = _data["agent_ens_user_tid"];
            this.referral_ens_user_tid = _data["referral_ens_user_tid"];
            this.f9_worksheet_tid = _data["f9_worksheet_tid"];
            this.current_ens_sale_status_tid = _data["current_ens_sale_status_tid"];
            this.issued_ens_sale_status_tid = _data["issued_ens_sale_status_tid"];
            this.sale_datetime = _data["sale_datetime"] ? new Date(_data["sale_datetime"].toString()) : <any>undefined;
            this.effective_date = _data["effective_date"] ? new Date(_data["effective_date"].toString()) : <any>undefined;
            this.age_at_tos = _data["age_at_tos"];
            this.rewrite_fl = _data["rewrite_fl"];
            this.premium = _data["premium"];
            this.ens_marketing_campaign_tid = _data["ens_marketing_campaign_tid"];
            this.premium_multiplier = _data["premium_multiplier"];
            this.referral_agent_answer = _data["referral_agent_answer"];
            this.primary_policy_number = _data["primary_policy_number"];
            this.commission_basis = _data["commission_basis"];
            this.notes = _data["notes"];
            this.underwriting_comments = _data["underwriting_comments"];
            this.insured_first_name = _data["insured_first_name"];
            this.insured_last_name = _data["insured_last_name"];
            this.insured_gender = _data["insured_gender"];
            this.insured_dob = _data["insured_dob"] ? new Date(_data["insured_dob"].toString()) : <any>undefined;
            this.insured_phone = _data["insured_phone"];
            this.insured_email = _data["insured_email"];
            this.insured_address_line1 = _data["insured_address_line1"];
            this.insured_address_line2 = _data["insured_address_line2"];
            this.insured_city = _data["insured_city"];
            this.insured_state = _data["insured_state"];
            this.insured_zip = _data["insured_zip"];
            this.approval_datetime = _data["approval_datetime"] ? new Date(_data["approval_datetime"].toString()) : <any>undefined;
            this.termination_date = _data["termination_date"] ? new Date(_data["termination_date"].toString()) : <any>undefined;
            this.ens_sale_underwritting_status_tid = _data["ens_sale_underwritting_status_tid"];
        }
    }

    static fromJS(data: any): SaleInsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaleInsertRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["purchaser_last_ens_contact_marketing_action_tid"] = this.purchaser_last_ens_contact_marketing_action_tid;
        data["purchaser_ens_contact_id"] = this.purchaser_ens_contact_id;
        data["insured_ens_contact_tid"] = this.insured_ens_contact_tid;
        data["ens_product_carrier_tid"] = this.ens_product_carrier_tid;
        data["ens_product_tid"] = this.ens_product_tid;
        data["agent_ens_user_tid"] = this.agent_ens_user_tid;
        data["referral_ens_user_tid"] = this.referral_ens_user_tid;
        data["f9_worksheet_tid"] = this.f9_worksheet_tid;
        data["current_ens_sale_status_tid"] = this.current_ens_sale_status_tid;
        data["issued_ens_sale_status_tid"] = this.issued_ens_sale_status_tid;
        data["sale_datetime"] = this.sale_datetime ? this.sale_datetime.toISOString() : <any>undefined;
        data["effective_date"] = this.effective_date ? this.effective_date.toISOString() : <any>undefined;
        data["age_at_tos"] = this.age_at_tos;
        data["rewrite_fl"] = this.rewrite_fl;
        data["premium"] = this.premium;
        data["ens_marketing_campaign_tid"] = this.ens_marketing_campaign_tid;
        data["premium_multiplier"] = this.premium_multiplier;
        data["referral_agent_answer"] = this.referral_agent_answer;
        data["primary_policy_number"] = this.primary_policy_number;
        data["commission_basis"] = this.commission_basis;
        data["notes"] = this.notes;
        data["underwriting_comments"] = this.underwriting_comments;
        data["insured_first_name"] = this.insured_first_name;
        data["insured_last_name"] = this.insured_last_name;
        data["insured_gender"] = this.insured_gender;
        data["insured_dob"] = this.insured_dob ? this.insured_dob.toISOString() : <any>undefined;
        data["insured_phone"] = this.insured_phone;
        data["insured_email"] = this.insured_email;
        data["insured_address_line1"] = this.insured_address_line1;
        data["insured_address_line2"] = this.insured_address_line2;
        data["insured_city"] = this.insured_city;
        data["insured_state"] = this.insured_state;
        data["insured_zip"] = this.insured_zip;
        data["approval_datetime"] = this.approval_datetime ? this.approval_datetime.toISOString() : <any>undefined;
        data["termination_date"] = this.termination_date ? this.termination_date.toISOString() : <any>undefined;
        data["ens_sale_underwritting_status_tid"] = this.ens_sale_underwritting_status_tid;
        return data; 
    }
}

export interface ISaleInsertRequest {
    purchaser_last_ens_contact_marketing_action_tid?: number | undefined;
    purchaser_ens_contact_id?: number | undefined;
    insured_ens_contact_tid?: number | undefined;
    ens_product_carrier_tid: EnsProductCarrierTid;
    ens_product_tid: EnsProductTid;
    agent_ens_user_tid: number;
    referral_ens_user_tid?: number | undefined;
    f9_worksheet_tid?: number | undefined;
    current_ens_sale_status_tid: number;
    issued_ens_sale_status_tid: number;
    sale_datetime: Date;
    effective_date: Date;
    age_at_tos?: number | undefined;
    rewrite_fl: boolean;
    premium?: number | undefined;
    ens_marketing_campaign_tid?: number | undefined;
    premium_multiplier?: number | undefined;
    referral_agent_answer?: string | undefined;
    primary_policy_number?: string | undefined;
    commission_basis?: string | undefined;
    notes?: string | undefined;
    underwriting_comments?: string | undefined;
    insured_first_name?: string | undefined;
    insured_last_name?: string | undefined;
    insured_gender?: string | undefined;
    insured_dob: Date;
    insured_phone?: string | undefined;
    insured_email?: string | undefined;
    insured_address_line1?: string | undefined;
    insured_address_line2?: string | undefined;
    insured_city?: string | undefined;
    insured_state?: TwoLetterState | undefined;
    insured_zip?: string | undefined;
    approval_datetime?: Date | undefined;
    termination_date?: Date | undefined;
    ens_sale_underwritting_status_tid?: number | undefined;
}

export class SalePolicyResponse implements ISalePolicyResponse {
    code?: SalePolicyCode;
    message?: string | undefined;

    constructor(data?: ISalePolicyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SalePolicyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SalePolicyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        return data; 
    }
}

export interface ISalePolicyResponse {
    code?: SalePolicyCode;
    message?: string | undefined;
}

export enum SalePolicyCode {
    SUCCESS = 0,
    NOT_FOUND = 1,
}

export class SalePolicyUpdateMessage implements ISalePolicyUpdateMessage {
    policyNumber!: string;
    effectiveDate!: Date;

    constructor(data?: ISalePolicyUpdateMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.policyNumber = _data["policyNumber"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SalePolicyUpdateMessage {
        data = typeof data === 'object' ? data : {};
        let result = new SalePolicyUpdateMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policyNumber"] = this.policyNumber;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ISalePolicyUpdateMessage {
    policyNumber: string;
    effectiveDate: Date;
}

export class MktgCampaign implements IMktgCampaign {
    external_campaign_name?: string | undefined;
    ens_marketing_campaign_tid?: number;
    marketing_campaign_option?: string | undefined;

    constructor(data?: IMktgCampaign) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.external_campaign_name = _data["external_campaign_name"];
            this.ens_marketing_campaign_tid = _data["ens_marketing_campaign_tid"];
            this.marketing_campaign_option = _data["marketing_campaign_option"];
        }
    }

    static fromJS(data: any): MktgCampaign {
        data = typeof data === 'object' ? data : {};
        let result = new MktgCampaign();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["external_campaign_name"] = this.external_campaign_name;
        data["ens_marketing_campaign_tid"] = this.ens_marketing_campaign_tid;
        data["marketing_campaign_option"] = this.marketing_campaign_option;
        return data; 
    }
}

export interface IMktgCampaign {
    external_campaign_name?: string | undefined;
    ens_marketing_campaign_tid?: number;
    marketing_campaign_option?: string | undefined;
}

export class SalesforceCaseSubmissionResponse implements ISalesforceCaseSubmissionResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    caseId?: string | undefined;

    constructor(data?: ISalesforceCaseSubmissionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.errorMessage = _data["errorMessage"];
            this.caseId = _data["caseId"];
        }
    }

    static fromJS(data: any): SalesforceCaseSubmissionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SalesforceCaseSubmissionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMessage"] = this.errorMessage;
        data["caseId"] = this.caseId;
        return data; 
    }
}

export interface ISalesforceCaseSubmissionResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    caseId?: string | undefined;
}

export class SalesforceFormSubmission implements ISalesforceFormSubmission {
    case_status?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    birthdate?: string | undefined;
    dateformat?: string | undefined;
    gender?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    city?: string | undefined;
    address?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    tobacco_use?: string | undefined;
    ens_v?: string | undefined;
    ens_b?: string | undefined;
    ens_p?: string | undefined;
    ens_c?: string | undefined;
    ens_ch?: string | undefined;
    ens_f9ln?: string | undefined;
    ens_adgrpid?: string | undefined;
    ens_campid?: string | undefined;
    ens_clckid?: string | undefined;
    form_guid?: string | undefined;
    dtc_docusign_link?: string | undefined;
    dtc_quote_type?: string | undefined;
    dtc_quote_rates?: string | undefined;
    dtc_quote_link?: string | undefined;
    application_status?: string | undefined;
    dtc_application_status?: string | undefined;
    no_plan_available?: string | undefined;
    no_plan_reason?: string | undefined;
    formdata?: string | undefined;
    five9CallDay?: string | undefined;
    five9CallTime?: string | undefined;
    ref?: string | undefined;
    ip_address?: string | undefined;
    utmSource?: string | undefined;
    utmMedium?: string | undefined;
    utmCampaign?: string | undefined;
    utmTerm?: string | undefined;
    utmContent?: string | undefined;
    ensTrackingUrl?: string | undefined;
    emmaActionType?: string | undefined;
    journeyActionType?: string | undefined;
    trustedFormToken?: string | undefined;
    ensContactTid?: string | undefined;
    has_medicaid?: string | undefined;
    has_part_A?: string | undefined;
    has_part_B?: string | undefined;
    contact_marketing_action_tid?: string | undefined;

    [key: string]: string | any; 

    constructor(data?: ISalesforceFormSubmission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.case_status = _data["case_status"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.birthdate = _data["birthdate"];
            this.dateformat = _data["dateformat"];
            this.gender = _data["gender"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.city = _data["city"];
            this.address = _data["address"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.tobacco_use = _data["tobacco_use"];
            this.ens_v = _data["ens_v"];
            this.ens_b = _data["ens_b"];
            this.ens_p = _data["ens_p"];
            this.ens_c = _data["ens_c"];
            this.ens_ch = _data["ens_ch"];
            this.ens_f9ln = _data["ens_f9ln"];
            this.ens_adgrpid = _data["ens_adgrpid"];
            this.ens_campid = _data["ens_campid"];
            this.ens_clckid = _data["ens_clckid"];
            this.form_guid = _data["form_guid"];
            this.dtc_docusign_link = _data["dtc_docusign_link"];
            this.dtc_quote_type = _data["dtc_quote_type"];
            this.dtc_quote_rates = _data["dtc_quote_rates"];
            this.dtc_quote_link = _data["dtc_quote_link"];
            this.application_status = _data["application_status"];
            this.dtc_application_status = _data["dtc_application_status"];
            this.no_plan_available = _data["no_plan_available"];
            this.no_plan_reason = _data["no_plan_reason"];
            this.formdata = _data["formdata"];
            this.five9CallDay = _data["Five9CallDay"];
            this.five9CallTime = _data["Five9CallTime"];
            this.ref = _data["ref"];
            this.ip_address = _data["ip_address"];
            this.utmSource = _data["UtmSource"];
            this.utmMedium = _data["UtmMedium"];
            this.utmCampaign = _data["UtmCampaign"];
            this.utmTerm = _data["UtmTerm"];
            this.utmContent = _data["UtmContent"];
            this.ensTrackingUrl = _data["EnsTrackingUrl"];
            this.emmaActionType = _data["EmmaActionType"];
            this.journeyActionType = _data["JourneyActionType"];
            this.trustedFormToken = _data["TrustedFormToken"];
            this.ensContactTid = _data["EnsContactTid"];
            this.has_medicaid = _data["has_medicaid"];
            this.has_part_A = _data["has_part_A"];
            this.has_part_B = _data["has_part_B"];
            this.contact_marketing_action_tid = _data["contact_marketing_action_tid"];
        }
    }

    static fromJS(data: any): SalesforceFormSubmission {
        data = typeof data === 'object' ? data : {};
        let result = new SalesforceFormSubmission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["case_status"] = this.case_status;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["birthdate"] = this.birthdate;
        data["dateformat"] = this.dateformat;
        data["gender"] = this.gender;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["city"] = this.city;
        data["address"] = this.address;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["tobacco_use"] = this.tobacco_use;
        data["ens_v"] = this.ens_v;
        data["ens_b"] = this.ens_b;
        data["ens_p"] = this.ens_p;
        data["ens_c"] = this.ens_c;
        data["ens_ch"] = this.ens_ch;
        data["ens_f9ln"] = this.ens_f9ln;
        data["ens_adgrpid"] = this.ens_adgrpid;
        data["ens_campid"] = this.ens_campid;
        data["ens_clckid"] = this.ens_clckid;
        data["form_guid"] = this.form_guid;
        data["dtc_docusign_link"] = this.dtc_docusign_link;
        data["dtc_quote_type"] = this.dtc_quote_type;
        data["dtc_quote_rates"] = this.dtc_quote_rates;
        data["dtc_quote_link"] = this.dtc_quote_link;
        data["application_status"] = this.application_status;
        data["dtc_application_status"] = this.dtc_application_status;
        data["no_plan_available"] = this.no_plan_available;
        data["no_plan_reason"] = this.no_plan_reason;
        data["formdata"] = this.formdata;
        data["Five9CallDay"] = this.five9CallDay;
        data["Five9CallTime"] = this.five9CallTime;
        data["ref"] = this.ref;
        data["ip_address"] = this.ip_address;
        data["UtmSource"] = this.utmSource;
        data["UtmMedium"] = this.utmMedium;
        data["UtmCampaign"] = this.utmCampaign;
        data["UtmTerm"] = this.utmTerm;
        data["UtmContent"] = this.utmContent;
        data["EnsTrackingUrl"] = this.ensTrackingUrl;
        data["EmmaActionType"] = this.emmaActionType;
        data["JourneyActionType"] = this.journeyActionType;
        data["TrustedFormToken"] = this.trustedFormToken;
        data["EnsContactTid"] = this.ensContactTid;
        data["has_medicaid"] = this.has_medicaid;
        data["has_part_A"] = this.has_part_A;
        data["has_part_B"] = this.has_part_B;
        data["contact_marketing_action_tid"] = this.contact_marketing_action_tid;
        return data; 
    }
}

export interface ISalesforceFormSubmission {
    case_status?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    birthdate?: string | undefined;
    dateformat?: string | undefined;
    gender?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    city?: string | undefined;
    address?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    tobacco_use?: string | undefined;
    ens_v?: string | undefined;
    ens_b?: string | undefined;
    ens_p?: string | undefined;
    ens_c?: string | undefined;
    ens_ch?: string | undefined;
    ens_f9ln?: string | undefined;
    ens_adgrpid?: string | undefined;
    ens_campid?: string | undefined;
    ens_clckid?: string | undefined;
    form_guid?: string | undefined;
    dtc_docusign_link?: string | undefined;
    dtc_quote_type?: string | undefined;
    dtc_quote_rates?: string | undefined;
    dtc_quote_link?: string | undefined;
    application_status?: string | undefined;
    dtc_application_status?: string | undefined;
    no_plan_available?: string | undefined;
    no_plan_reason?: string | undefined;
    formdata?: string | undefined;
    five9CallDay?: string | undefined;
    five9CallTime?: string | undefined;
    ref?: string | undefined;
    ip_address?: string | undefined;
    utmSource?: string | undefined;
    utmMedium?: string | undefined;
    utmCampaign?: string | undefined;
    utmTerm?: string | undefined;
    utmContent?: string | undefined;
    ensTrackingUrl?: string | undefined;
    emmaActionType?: string | undefined;
    journeyActionType?: string | undefined;
    trustedFormToken?: string | undefined;
    ensContactTid?: string | undefined;
    has_medicaid?: string | undefined;
    has_part_A?: string | undefined;
    has_part_B?: string | undefined;
    contact_marketing_action_tid?: string | undefined;

    [key: string]: string | any; 
}

export class SalesforceSubmission implements ISalesforceSubmission {
    householdId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    householdName?: string | undefined;
    gender?: string | undefined;
    dobMonth?: string | undefined;
    dobDay?: string | undefined;
    dobYear?: string | undefined;
    birthdate?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    addressLine1?: string | undefined;
    addressCity?: string | undefined;
    addressState?: string | undefined;
    addressZip?: string | undefined;
    addressCountry?: string | undefined;
    memberId?: string | undefined;
    opportunityId?: string | undefined;
    planType?: string | undefined;
    signatureDateMonth?: string | undefined;
    signatureDateDay?: string | undefined;
    signatureDateYear?: string | undefined;
    effectiveDateMonth?: string | undefined;
    effectiveDateDay?: string | undefined;
    effectiveDateYear?: string | undefined;
    enrollmentCode?: string | undefined;
    confirmationCode?: string | undefined;
    confirmationStatus?: string | undefined;
    planCarrierId?: number;
    planCarrierName?: string | undefined;
    agentNpn?: string | undefined;
    agentUserName?: string | undefined;
    agentFirstName?: string | undefined;
    agentLastName?: string | undefined;
    agentEmail?: string | undefined;
    premium?: number | undefined;
    ensSaleId?: number | undefined;
    enrollmentPortal?: string | undefined;
    dtcApplicationSubmissionTid?: number | undefined;
    dtcFl?: boolean;
    ensContactTid?: number;
    addressCountyName?: string | undefined;
    hasMedicaid?: string | undefined;
    hasMedicarePartA?: string | undefined;
    hasMedicarePartB?: string | undefined;

    constructor(data?: ISalesforceSubmission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.householdId = _data["householdId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.householdName = _data["householdName"];
            this.gender = _data["gender"];
            this.dobMonth = _data["dobMonth"];
            this.dobDay = _data["dobDay"];
            this.dobYear = _data["dobYear"];
            this.birthdate = _data["birthdate"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.addressLine1 = _data["addressLine1"];
            this.addressCity = _data["addressCity"];
            this.addressState = _data["addressState"];
            this.addressZip = _data["addressZip"];
            this.addressCountry = _data["addressCountry"];
            this.memberId = _data["memberId"];
            this.opportunityId = _data["opportunityId"];
            this.planType = _data["planType"];
            this.signatureDateMonth = _data["signatureDateMonth"];
            this.signatureDateDay = _data["signatureDateDay"];
            this.signatureDateYear = _data["signatureDateYear"];
            this.effectiveDateMonth = _data["effectiveDateMonth"];
            this.effectiveDateDay = _data["effectiveDateDay"];
            this.effectiveDateYear = _data["effectiveDateYear"];
            this.enrollmentCode = _data["enrollmentCode"];
            this.confirmationCode = _data["confirmationCode"];
            this.confirmationStatus = _data["confirmationStatus"];
            this.planCarrierId = _data["planCarrierId"];
            this.planCarrierName = _data["planCarrierName"];
            this.agentNpn = _data["agentNpn"];
            this.agentUserName = _data["agentUserName"];
            this.agentFirstName = _data["agentFirstName"];
            this.agentLastName = _data["agentLastName"];
            this.agentEmail = _data["agentEmail"];
            this.premium = _data["premium"];
            this.ensSaleId = _data["ensSaleId"];
            this.enrollmentPortal = _data["enrollmentPortal"];
            this.dtcApplicationSubmissionTid = _data["dtcApplicationSubmissionTid"];
            this.dtcFl = _data["dtcFl"];
            this.ensContactTid = _data["ensContactTid"];
            this.addressCountyName = _data["addressCountyName"];
            this.hasMedicaid = _data["hasMedicaid"];
            this.hasMedicarePartA = _data["hasMedicarePartA"];
            this.hasMedicarePartB = _data["hasMedicarePartB"];
        }
    }

    static fromJS(data: any): SalesforceSubmission {
        data = typeof data === 'object' ? data : {};
        let result = new SalesforceSubmission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["householdId"] = this.householdId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["householdName"] = this.householdName;
        data["gender"] = this.gender;
        data["dobMonth"] = this.dobMonth;
        data["dobDay"] = this.dobDay;
        data["dobYear"] = this.dobYear;
        data["birthdate"] = this.birthdate;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["addressLine1"] = this.addressLine1;
        data["addressCity"] = this.addressCity;
        data["addressState"] = this.addressState;
        data["addressZip"] = this.addressZip;
        data["addressCountry"] = this.addressCountry;
        data["memberId"] = this.memberId;
        data["opportunityId"] = this.opportunityId;
        data["planType"] = this.planType;
        data["signatureDateMonth"] = this.signatureDateMonth;
        data["signatureDateDay"] = this.signatureDateDay;
        data["signatureDateYear"] = this.signatureDateYear;
        data["effectiveDateMonth"] = this.effectiveDateMonth;
        data["effectiveDateDay"] = this.effectiveDateDay;
        data["effectiveDateYear"] = this.effectiveDateYear;
        data["enrollmentCode"] = this.enrollmentCode;
        data["confirmationCode"] = this.confirmationCode;
        data["confirmationStatus"] = this.confirmationStatus;
        data["planCarrierId"] = this.planCarrierId;
        data["planCarrierName"] = this.planCarrierName;
        data["agentNpn"] = this.agentNpn;
        data["agentUserName"] = this.agentUserName;
        data["agentFirstName"] = this.agentFirstName;
        data["agentLastName"] = this.agentLastName;
        data["agentEmail"] = this.agentEmail;
        data["premium"] = this.premium;
        data["ensSaleId"] = this.ensSaleId;
        data["enrollmentPortal"] = this.enrollmentPortal;
        data["dtcApplicationSubmissionTid"] = this.dtcApplicationSubmissionTid;
        data["dtcFl"] = this.dtcFl;
        data["ensContactTid"] = this.ensContactTid;
        data["addressCountyName"] = this.addressCountyName;
        data["hasMedicaid"] = this.hasMedicaid;
        data["hasMedicarePartA"] = this.hasMedicarePartA;
        data["hasMedicarePartB"] = this.hasMedicarePartB;
        return data; 
    }
}

export interface ISalesforceSubmission {
    householdId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    householdName?: string | undefined;
    gender?: string | undefined;
    dobMonth?: string | undefined;
    dobDay?: string | undefined;
    dobYear?: string | undefined;
    birthdate?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    addressLine1?: string | undefined;
    addressCity?: string | undefined;
    addressState?: string | undefined;
    addressZip?: string | undefined;
    addressCountry?: string | undefined;
    memberId?: string | undefined;
    opportunityId?: string | undefined;
    planType?: string | undefined;
    signatureDateMonth?: string | undefined;
    signatureDateDay?: string | undefined;
    signatureDateYear?: string | undefined;
    effectiveDateMonth?: string | undefined;
    effectiveDateDay?: string | undefined;
    effectiveDateYear?: string | undefined;
    enrollmentCode?: string | undefined;
    confirmationCode?: string | undefined;
    confirmationStatus?: string | undefined;
    planCarrierId?: number;
    planCarrierName?: string | undefined;
    agentNpn?: string | undefined;
    agentUserName?: string | undefined;
    agentFirstName?: string | undefined;
    agentLastName?: string | undefined;
    agentEmail?: string | undefined;
    premium?: number | undefined;
    ensSaleId?: number | undefined;
    enrollmentPortal?: string | undefined;
    dtcApplicationSubmissionTid?: number | undefined;
    dtcFl?: boolean;
    ensContactTid?: number;
    addressCountyName?: string | undefined;
    hasMedicaid?: string | undefined;
    hasMedicarePartA?: string | undefined;
    hasMedicarePartB?: string | undefined;
}

export class ProductCommissionResponseRow implements IProductCommissionResponseRow {
    ens_commission_category_tid?: number;
    commission_category_name?: string | undefined;
    commission_category_amount?: number;

    constructor(data?: IProductCommissionResponseRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_commission_category_tid = _data["ens_commission_category_tid"];
            this.commission_category_name = _data["commission_category_name"];
            this.commission_category_amount = _data["commission_category_amount"];
        }
    }

    static fromJS(data: any): ProductCommissionResponseRow {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCommissionResponseRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_commission_category_tid"] = this.ens_commission_category_tid;
        data["commission_category_name"] = this.commission_category_name;
        data["commission_category_amount"] = this.commission_category_amount;
        return data; 
    }
}

export interface IProductCommissionResponseRow {
    ens_commission_category_tid?: number;
    commission_category_name?: string | undefined;
    commission_category_amount?: number;
}

export class CommissionAmountUpdateRequest implements ICommissionAmountUpdateRequest {
    ens_commission_category_tid!: number;
    commission_amount!: number;

    constructor(data?: ICommissionAmountUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_commission_category_tid = _data["ens_commission_category_tid"];
            this.commission_amount = _data["commission_amount"];
        }
    }

    static fromJS(data: any): CommissionAmountUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionAmountUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_commission_category_tid"] = this.ens_commission_category_tid;
        data["commission_amount"] = this.commission_amount;
        return data; 
    }
}

export interface ICommissionAmountUpdateRequest {
    ens_commission_category_tid: number;
    commission_amount: number;
}

export class GenerateCommissionRequest implements IGenerateCommissionRequest {
    date?: Date;

    constructor(data?: IGenerateCommissionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GenerateCommissionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateCommissionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGenerateCommissionRequest {
    date?: Date;
}

export class CommissionRow implements ICommissionRow {
    ens_user_commission_tracker_tid?: number;
    ens_sale_tid?: number | undefined;
    policy_number?: string | undefined;
    insured_name?: string | undefined;
    product_name?: string | undefined;
    product_carrier_name?: string | undefined;
    sale_date?: Date | undefined;
    effective_date?: Date | undefined;
    commission_amount?: number;
    public_note?: string | undefined;
    pre_approved_fl?: boolean;
    agent_approved_fl?: boolean;
    ready_for_payment_fl?: boolean;
    paid_fl?: boolean;
    processed_fl?: boolean;
    commission_type?: EnsCommissionType;
    paid_datetime?: Date | undefined;
    ens_product_category_tid?: EnsProductCategoryTid | undefined;
    sale_note?: string | undefined;
    aep_commission_fl?: boolean | undefined;
    ens_commission_aep_split_tid?: number | undefined;
    split_percentage?: number | undefined;
    termination_date?: Date | undefined;
    overtime_bonus_percentage?: number | undefined;
    opportunity_line_item_id?: string | undefined;
    advanced_fl?: boolean | undefined;
    paid_through_bonus_percentage?: number | undefined;

    constructor(data?: ICommissionRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_user_commission_tracker_tid = _data["ens_user_commission_tracker_tid"];
            this.ens_sale_tid = _data["ens_sale_tid"];
            this.policy_number = _data["policy_number"];
            this.insured_name = _data["insured_name"];
            this.product_name = _data["product_name"];
            this.product_carrier_name = _data["product_carrier_name"];
            this.sale_date = _data["sale_date"] ? new Date(_data["sale_date"].toString()) : <any>undefined;
            this.effective_date = _data["effective_date"] ? new Date(_data["effective_date"].toString()) : <any>undefined;
            this.commission_amount = _data["commission_amount"];
            this.public_note = _data["public_note"];
            this.pre_approved_fl = _data["pre_approved_fl"];
            this.agent_approved_fl = _data["agent_approved_fl"];
            this.ready_for_payment_fl = _data["ready_for_payment_fl"];
            this.paid_fl = _data["paid_fl"];
            this.processed_fl = _data["processed_fl"];
            this.commission_type = _data["commission_type"];
            this.paid_datetime = _data["paid_datetime"] ? new Date(_data["paid_datetime"].toString()) : <any>undefined;
            this.ens_product_category_tid = _data["ens_product_category_tid"];
            this.sale_note = _data["sale_note"];
            this.aep_commission_fl = _data["aep_commission_fl"];
            this.ens_commission_aep_split_tid = _data["ens_commission_aep_split_tid"];
            this.split_percentage = _data["split_percentage"];
            this.termination_date = _data["termination_date"] ? new Date(_data["termination_date"].toString()) : <any>undefined;
            this.overtime_bonus_percentage = _data["overtime_bonus_percentage"];
            this.opportunity_line_item_id = _data["opportunity_line_item_id"];
            this.advanced_fl = _data["advanced_fl"];
            this.paid_through_bonus_percentage = _data["paid_through_bonus_percentage"];
        }
    }

    static fromJS(data: any): CommissionRow {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_user_commission_tracker_tid"] = this.ens_user_commission_tracker_tid;
        data["ens_sale_tid"] = this.ens_sale_tid;
        data["policy_number"] = this.policy_number;
        data["insured_name"] = this.insured_name;
        data["product_name"] = this.product_name;
        data["product_carrier_name"] = this.product_carrier_name;
        data["sale_date"] = this.sale_date ? this.sale_date.toISOString() : <any>undefined;
        data["effective_date"] = this.effective_date ? this.effective_date.toISOString() : <any>undefined;
        data["commission_amount"] = this.commission_amount;
        data["public_note"] = this.public_note;
        data["pre_approved_fl"] = this.pre_approved_fl;
        data["agent_approved_fl"] = this.agent_approved_fl;
        data["ready_for_payment_fl"] = this.ready_for_payment_fl;
        data["paid_fl"] = this.paid_fl;
        data["processed_fl"] = this.processed_fl;
        data["commission_type"] = this.commission_type;
        data["paid_datetime"] = this.paid_datetime ? this.paid_datetime.toISOString() : <any>undefined;
        data["ens_product_category_tid"] = this.ens_product_category_tid;
        data["sale_note"] = this.sale_note;
        data["aep_commission_fl"] = this.aep_commission_fl;
        data["ens_commission_aep_split_tid"] = this.ens_commission_aep_split_tid;
        data["split_percentage"] = this.split_percentage;
        data["termination_date"] = this.termination_date ? this.termination_date.toISOString() : <any>undefined;
        data["overtime_bonus_percentage"] = this.overtime_bonus_percentage;
        data["opportunity_line_item_id"] = this.opportunity_line_item_id;
        data["advanced_fl"] = this.advanced_fl;
        data["paid_through_bonus_percentage"] = this.paid_through_bonus_percentage;
        return data; 
    }
}

export interface ICommissionRow {
    ens_user_commission_tracker_tid?: number;
    ens_sale_tid?: number | undefined;
    policy_number?: string | undefined;
    insured_name?: string | undefined;
    product_name?: string | undefined;
    product_carrier_name?: string | undefined;
    sale_date?: Date | undefined;
    effective_date?: Date | undefined;
    commission_amount?: number;
    public_note?: string | undefined;
    pre_approved_fl?: boolean;
    agent_approved_fl?: boolean;
    ready_for_payment_fl?: boolean;
    paid_fl?: boolean;
    processed_fl?: boolean;
    commission_type?: EnsCommissionType;
    paid_datetime?: Date | undefined;
    ens_product_category_tid?: EnsProductCategoryTid | undefined;
    sale_note?: string | undefined;
    aep_commission_fl?: boolean | undefined;
    ens_commission_aep_split_tid?: number | undefined;
    split_percentage?: number | undefined;
    termination_date?: Date | undefined;
    overtime_bonus_percentage?: number | undefined;
    opportunity_line_item_id?: string | undefined;
    advanced_fl?: boolean | undefined;
    paid_through_bonus_percentage?: number | undefined;
}

export enum EnsCommissionType {
    Sale = 1,
    Referral = 2,
    Bonus = 3,
    Chargeback = 4,
    OvertimeBonus = 5,
    OvertimeBonusChargeback = 6,
    BonusChargeback = 7,
    PaidThroughBonus = 8,
    TrueUp = 9,
    TrueUpChargeback = 10,
    HRA = 11,
}

export class AdminCommissionRow extends CommissionRow implements IAdminCommissionRow {
    internal_note?: string | undefined;

    constructor(data?: IAdminCommissionRow) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.internal_note = _data["internal_note"];
        }
    }

    static fromJS(data: any): AdminCommissionRow {
        data = typeof data === 'object' ? data : {};
        let result = new AdminCommissionRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internal_note"] = this.internal_note;
        super.toJSON(data);
        return data; 
    }
}

export interface IAdminCommissionRow extends ICommissionRow {
    internal_note?: string | undefined;
}

export class UserCommissionStatusResponse implements IUserCommissionStatusResponse {
    total_records?: number;
    successfully_processed?: number;

    constructor(data?: IUserCommissionStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total_records = _data["total_records"];
            this.successfully_processed = _data["successfully_processed"];
        }
    }

    static fromJS(data: any): UserCommissionStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserCommissionStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total_records"] = this.total_records;
        data["successfully_processed"] = this.successfully_processed;
        return data; 
    }
}

export interface IUserCommissionStatusResponse {
    total_records?: number;
    successfully_processed?: number;
}

export class CommissionStatusRequest implements ICommissionStatusRequest {
    ens_user_commission_tracker_tid!: number;
    pre_approved_fl!: boolean;
    agent_approved_fl!: boolean;
    ready_for_payment_updated_fl!: boolean;
    paid_fl!: boolean;
    internal_note?: string | undefined;
    public_note?: string | undefined;
    processed_fl?: boolean | undefined;
    self_referral_fl?: boolean | undefined;

    constructor(data?: ICommissionStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_user_commission_tracker_tid = _data["ens_user_commission_tracker_tid"];
            this.pre_approved_fl = _data["pre_approved_fl"];
            this.agent_approved_fl = _data["agent_approved_fl"];
            this.ready_for_payment_updated_fl = _data["ready_for_payment_updated_fl"];
            this.paid_fl = _data["paid_fl"];
            this.internal_note = _data["internal_note"];
            this.public_note = _data["public_note"];
            this.processed_fl = _data["processed_fl"];
            this.self_referral_fl = _data["self_referral_fl"];
        }
    }

    static fromJS(data: any): CommissionStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_user_commission_tracker_tid"] = this.ens_user_commission_tracker_tid;
        data["pre_approved_fl"] = this.pre_approved_fl;
        data["agent_approved_fl"] = this.agent_approved_fl;
        data["ready_for_payment_updated_fl"] = this.ready_for_payment_updated_fl;
        data["paid_fl"] = this.paid_fl;
        data["internal_note"] = this.internal_note;
        data["public_note"] = this.public_note;
        data["processed_fl"] = this.processed_fl;
        data["self_referral_fl"] = this.self_referral_fl;
        return data; 
    }
}

export interface ICommissionStatusRequest {
    ens_user_commission_tracker_tid: number;
    pre_approved_fl: boolean;
    agent_approved_fl: boolean;
    ready_for_payment_updated_fl: boolean;
    paid_fl: boolean;
    internal_note?: string | undefined;
    public_note?: string | undefined;
    processed_fl?: boolean | undefined;
    self_referral_fl?: boolean | undefined;
}

export class AddCommissionRequest implements IAddCommissionRequest {
    ens_user_tid!: number;
    ens_commission_type!: EnsCommissionType;
    commission_amount!: number;
    ens_sale_tid!: number;
    internal_note?: string | undefined;
    public_note?: string | undefined;

    constructor(data?: IAddCommissionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_user_tid = _data["ens_user_tid"];
            this.ens_commission_type = _data["ens_commission_type"];
            this.commission_amount = _data["commission_amount"];
            this.ens_sale_tid = _data["ens_sale_tid"];
            this.internal_note = _data["internal_note"];
            this.public_note = _data["public_note"];
        }
    }

    static fromJS(data: any): AddCommissionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddCommissionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_user_tid"] = this.ens_user_tid;
        data["ens_commission_type"] = this.ens_commission_type;
        data["commission_amount"] = this.commission_amount;
        data["ens_sale_tid"] = this.ens_sale_tid;
        data["internal_note"] = this.internal_note;
        data["public_note"] = this.public_note;
        return data; 
    }
}

export interface IAddCommissionRequest {
    ens_user_tid: number;
    ens_commission_type: EnsCommissionType;
    commission_amount: number;
    ens_sale_tid: number;
    internal_note?: string | undefined;
    public_note?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}